(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pdp-swiper-large-diffuser-free-flow"] && !Shopify.designMode) return;
  try {
    

  // ── External Swiper initialiser ────────────────────────────────────────────
  // Runs at DOMContentLoaded — before Alpine's init() — so Swiper is always
  // created by this function. Slide changes are communicated to Alpine via a
  // custom event on the section root, which Alpine listens for in init().
  const initQtyPdpSwiper = (root) => {
    if (typeof window.Swiper === 'undefined') return

    // Media swipers (left column on slide 0 and review slide)
    root.querySelectorAll('.pdp-swiper__media-swiper').forEach((mediaEl) => {
      if (mediaEl.swiper) return
      new window.Swiper(mediaEl, {
        nested: true,
        slidesPerView: 1,
        speed: 650,
        breakpoints: { 990: { allowTouchMove: false, simulateTouch: false } },
      })
    })

    // Root Swiper — controls all step slides
    const rootEl = root.querySelector('.pdp-swiper__root')
    if (!rootEl || rootEl.swiper) return
    new window.Swiper(rootEl, {
      slidesPerView: 1,
      speed: 700,
      allowTouchMove: false,
      simulateTouch: false,
      autoHeight: true,
      on: {
        slideChange(sw) {
          root.dispatchEvent(
            new CustomEvent('pdp-swiper-ldff:slide-change', {
              bubbles: false,
              detail: { activeIndex: sw.activeIndex },
            })
          )
        },
      },
    })
  }

  const _runQtyPdpSwiperInit = () => {
    document.querySelectorAll('.pdp-swiper-ldff').forEach(initQtyPdpSwiper)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', _runQtyPdpSwiperInit)
  } else {
    _runQtyPdpSwiperInit()
  }

  // ── Discount / product-type rule parsers ───────────────────────────────────

  const parseDiscountByProductTypeRules = (raw) => {
    if (!raw || typeof raw !== 'string') return []
    return raw
      .replace(/\r\n/g, '\n')
      .split(/[,\n]+/)
      .map((s) => s.trim())
      .filter(Boolean)
      .map((segment) => {
        const idx = segment.lastIndexOf('/')
        if (idx === -1) return null
        const productType = segment.slice(0, idx).trim()
        const percent = segment.slice(idx + 1).trim()
        if (!productType || !percent) return null
        return { productType, percent: Number(percent) }
      })
      .filter(Boolean)
  }

  const parseQtyAddonProductTypeRules = (raw) => {
    if (!raw || typeof raw !== 'string') return []
    return raw
      .replace(/\r\n/g, '\n')
      .split(/[,\n]+/)
      .map((s) => s.trim())
      .filter(Boolean)
      .map((segment) => {
        const parts = segment.split('|').map((p) => p.trim())
        const match = parts[0]
        const productType = parts[1] || ''
        const collectionFilter = parts[2] || null
        if (!match || !productType) return null
        return { match, productType, collectionFilter }
      })
      .filter(Boolean)
  }

  document.addEventListener('alpine:init', () => {
    Alpine.data('pdpSwiperLdffState', () => ({

      // ── Variant data ────────────────────────────────────────────────
      productHandle: '',
      variantsById: {},
      addonVariantsById: {},
      defaultByOption1: {},
      addonProductTypeMap: '',
      discountByProductTypeMap: '',
      reviewImageMappings: [],
      productFeaturedImage: '',
      bundleVariantId: '',
      bundleOnlyMode: false,
      freePromo: true,
      subscriptionOnly: true,
      frequencyStep: false,
      frequencyHeadline: 'Select scent delivery frequency',
      subscriptionBestOfferLabel: '',
      bundleVariant: null,
      bundleSlotsByType: {},

      // ── Commitment term step (12/24/36 month) ────────────────────────
      diffuserPromo: '',
      diffuserTypeSlugByOption1: {},
      commitmentTermOptions: [],
      selectedCommitmentTerm: null,

      // ── Step 1 quantity state ────────────────────────────────────────
      // { [option1Key]: 0..3 }
      quantityByOption1: {},

      // ── Step 1 slot color state ──────────────────────────────────────
      // { [option1Key]: [variantId, variantId, ...] }  length === qty
      slotColorByOption1: {},

      // ── Swatch data (baked from Liquid) ──────────────────────────────
      // { [option1Key]: [{ variantId, option2, swatchBg }, ...] }
      swatchesByOption1: {},

      // Ordered list of option1 keys (Liquid render order)
      option1Order: [],

      // ── Bundle list (built on NEXT from Step 1) ──────────────────────
      bundles: [],

      // ── Addon type groups (derived from bundles, drives addon slides) ─
      // [{ productType, count, bundles[], label }]
      addonTypeGroups: [],

      // ── Scent qty per type: { [productType]: { [addonVariantId]: qty } }
      addonQtyByType: {},

      // ── Purchase mode per addon: { [addonVariantId]: 'subscription' | 'one_time' }
      addonPurchaseModeById: {},
      // ── Group-level frequency choice: { [productType]: 'subscription' | 'one_time' }
      groupPurchaseModeByType: {},

      // ── Swiper tracking ──────────────────────────────────────────────
      currentSwiperIndex: 0,
      stepTextTemplate: '',

      // ── Shared UI state ─────────────────────────────────────────────
      termsAccepted: false,
      termsAcceptedAt: null,
      termsModalOpen: false,
      addToCartLoading: false,
      popupOpen: false,
      popupVariant: null,
      popupOption1: null,
      popupSectionsCache: {},
      popupSectionsHtml: '',
      addonPopupOpen: false,
      addonPopupVariant: null,
      addonPopupSectionsCache: {},
      addonPopupSectionsHtml: '',
      pdpSwiperRootEl: null,

      // ── Init ────────────────────────────────────────────────────────
      init() {
        this.pdpSwiperRootEl =
          this.$el && this.$el.closest ? this.$el.closest('.pdp-swiper-ldff') : null

        const jsonEl = this.$el.querySelector('[data-pdp-variant-state]')
        if (!jsonEl) return

        let state = null
        try {
          state = JSON.parse(jsonEl.textContent || '{}')
        } catch (e) {
          state = null
        }
        if (!state) return

        // Populate variantsById
        ;(state.variants || []).forEach((v) => {
          this.variantsById[String(v.id)] = v
        })

        // Populate addonVariantsById
        this.addonVariantsById = {}
        ;(state.addonVariants || []).forEach((row) => {
          if (row && row.id != null) {
            this.addonVariantsById[String(row.id)] = row
          }
        })

        this.defaultByOption1 = { ...(state.defaults || {}) }
        this.addonProductTypeMap =
          typeof state.addonProductTypeMap === 'string' ? state.addonProductTypeMap : ''
        this.discountByProductTypeMap =
          typeof state.discountByProductTypeMap === 'string'
            ? state.discountByProductTypeMap
            : ''
        this.reviewImageMappings = Array.isArray(state.reviewImageMappings)
          ? state.reviewImageMappings
          : []
        this.productFeaturedImage = state.productFeaturedImage || ''

        this.productHandle = state.productHandle || ''

        this.bundleVariantId = state.bundleVariantId || ''
        this.bundleOnlyMode = !!state.bundleOnlyMode
        this.freePromo = state.freePromo !== false
        this.subscriptionOnly = state.subscriptionOnly !== false
        this.frequencyStep = !!state.frequencyStep
        this.frequencyHeadline =
          typeof state.frequencyHeadline === 'string' && state.frequencyHeadline.trim()
            ? state.frequencyHeadline.trim()
            : 'Select scent delivery frequency'
        this.subscriptionBestOfferLabel =
          typeof state.subscriptionBestOfferLabel === 'string'
            ? state.subscriptionBestOfferLabel.trim()
            : ''
        this.addonPurchaseModeById = {}
        this.groupPurchaseModeByType = {}
        this.bundleVariant = this.bundleVariantId
          ? (Object.values(this.variantsById).find((v) => v.option1 === this.bundleVariantId) || null)
          : null

        // Swatch data per option1 group
        this.swatchesByOption1 =
          state.swatchesByOption1 && typeof state.swatchesByOption1 === 'object'
            ? state.swatchesByOption1
            : {}

        // Ordered option1 keys (Liquid render order for bundle building)
        this.option1Order = Array.isArray(state.option1Order) ? state.option1Order : []

        // Initialize quantityByOption1: all option1 groups start at 0,
        // unless there is only a single option1 (diffuser type) group,
        // in which case it defaults to 1 so the lone type is pre-selected.
        const qtyInit = {}
        const option1Keys = Object.keys(this.defaultByOption1)
        const singleOption1Default = option1Keys.length === 1 ? 1 : 0
        option1Keys.forEach((key) => {
          qtyInit[key] = singleOption1Default
        })
        this.quantityByOption1 = qtyInit
        this.slotColorByOption1 = {}

        // Bundle-only mode: the bundle card is the only purchasable item on Step 1,
        // so pre-select 1 unit (and its default color per component type) instead of
        // landing on an empty page with nothing selected and NEXT disabled.
        if (this.bundleOnlyMode && this.bundleVariant) {
          this.quantityByOption1 = { ...this.quantityByOption1, __bundle__: 1 }
          const typeOrder = this.getBundleTypeOrder()
          const initialSlots = {}
          typeOrder.forEach((t) => {
            initialSlots[t.productType] = [t.swatches.length ? t.swatches[0].variantId : null]
          })
          this.bundleSlotsByType = initialSlots
        }

        // Step text template for addon slides ("Step {step_number}: ...")
        this.stepTextTemplate = typeof state.stepTextTemplate === 'string'
          ? state.stepTextTemplate
          : 'Step {step_number}: Choose your scent.'

        // Commitment term options (12/24/36 month), merchant-configured
        this.diffuserPromo = typeof state.diffuserPromo === 'string' ? state.diffuserPromo : ''
        this.diffuserTypeSlugByOption1 =
          state.diffuserTypeSlugByOption1 && typeof state.diffuserTypeSlugByOption1 === 'object'
            ? state.diffuserTypeSlugByOption1
            : {}
        this.commitmentTermOptions = Array.isArray(state.commitmentTermOptions)
          ? state.commitmentTermOptions
          : []
        const bestOffer = this.commitmentTermOptions.find((t) => t.bestOffer)
        const lastOption = this.commitmentTermOptions[this.commitmentTermOptions.length - 1]
        this.selectedCommitmentTerm = (bestOffer || lastOption || {}).months || null

        // Listen for slide changes dispatched by the external Swiper init
        const root = this.pdpSwiperRootEl
        if (root) {
          root.addEventListener('pdp-swiper-ldff:slide-change', (e) => {
            this.currentSwiperIndex = (e.detail && e.detail.activeIndex != null)
              ? e.detail.activeIndex
              : 0
          })
        }
      },

      // ── Quantity helpers ─────────────────────────────────────────────
      getQty(option1Key) {
        return Number(this.quantityByOption1[option1Key] || 0)
      },

      incrementQty(option1Key) {
        const current = this.getQty(option1Key)
        const weight = option1Key === '__bundle__' ? 3 : 1
        if (this.totalWeightedUnits() + weight > 5) return
        this.quantityByOption1 = { ...this.quantityByOption1, [option1Key]: current + 1 }
        if (option1Key === '__bundle__') {
          const typeOrder = this.getBundleTypeOrder()
          const newSlots = { ...this.bundleSlotsByType }
          typeOrder.forEach((t) => {
            const existing = [...(newSlots[t.productType] || [])]
            existing.push(t.swatches.length ? t.swatches[0].variantId : null)
            newSlots[t.productType] = existing
          })
          this.bundleSlotsByType = newSlots
        } else {
          const existing = [...(this.slotColorByOption1[option1Key] || [])]
          existing.push(this.firstSwatchVariantIdForOption1(option1Key))
          this.slotColorByOption1 = { ...this.slotColorByOption1, [option1Key]: existing }
        }
      },

      decrementQty(option1Key) {
        const current = this.getQty(option1Key)
        if (current <= 0) return
        this.quantityByOption1 = { ...this.quantityByOption1, [option1Key]: current - 1 }
        if (option1Key === '__bundle__') {
          const newSlots = { ...this.bundleSlotsByType }
          Object.keys(newSlots).forEach((pt) => {
            newSlots[pt] = newSlots[pt].slice(0, -1)
          })
          this.bundleSlotsByType = newSlots
        } else {
          const existing = [...(this.slotColorByOption1[option1Key] || [])]
          existing.pop()
          this.slotColorByOption1 = { ...this.slotColorByOption1, [option1Key]: existing }
        }
      },

      totalUnits() {
        return Object.values(this.quantityByOption1).reduce(
          (sum, q) => sum + (Number(q) || 0),
          0
        )
      },

      totalWeightedUnits() {
        const bundleQty = this.getQty('__bundle__')
        const regularQty = Object.entries(this.quantityByOption1)
          .filter(([key]) => key !== '__bundle__')
          .reduce((sum, [, q]) => sum + (Number(q) || 0), 0)
        return regularQty + bundleQty * 3
      },

      canAdvanceFromStep1() {
        if (this.totalUnits() === 0) return false
        if (!this.selectedCommitmentTerm) return false
        const bundleQty = this.getQty('__bundle__')
        if (bundleQty > 0) {
          const typeOrder = this.getBundleTypeOrder()
          for (let ti = 0; ti < typeOrder.length; ti++) {
            const slots = this.bundleSlotsByType[typeOrder[ti].productType] || []
            for (let i = 0; i < bundleQty; i++) {
              if (!slots[i]) return false
            }
          }
        }
        return true
      },

      // ── Swatch / slot helpers ────────────────────────────────────────
      getSwatchesForOption1(option1Key) {
        return this.swatchesByOption1[option1Key] || []
      },

      firstSwatchVariantIdForOption1(option1Key) {
        const swatches = this.getSwatchesForOption1(option1Key)
        if (swatches.length) return swatches[0].variantId
        // Fallback to the defaults map if no swatch data (single-option products)
        return this.defaultByOption1[option1Key] || null
      },

      getSlotVariantId(option1Key, slotIndex) {
        const slots = this.slotColorByOption1[option1Key] || []
        return slots[slotIndex] != null ? slots[slotIndex] : null
      },

      // ── Bundle slot helpers ──────────────────────────────────────────
      getBundleTypeOrder() {
        const rules = parseQtyAddonProductTypeRules(this.addonProductTypeMap)
        const bundleOption1 = this.bundleVariant ? (this.bundleVariant.option1 || '') : ''
        return this.option1Order
          .filter((o1) => !bundleOption1 || o1 !== bundleOption1)
          .map((o1) => {
            for (let i = 0; i < rules.length; i++) {
              if (o1.indexOf(rules[i].match) !== -1) {
                const rule = rules[i]
                const compositeKey = rule.collectionFilter
                  ? rule.productType + '::' + rule.collectionFilter
                  : rule.productType
                return { option1: o1, productType: compositeKey, swatches: this.swatchesByOption1[o1] || [] }
              }
            }
            return null
          })
          .filter(Boolean)
      },

      getBundleUnitCount() {
        return this.getQty('__bundle__')
      },

      isBundleSlotSelected(productType, unitIdx, variantId) {
        const slots = this.bundleSlotsByType[productType] || []
        return slots[unitIdx] === variantId
      },

      setBundleSlotColor(productType, unitIdx, variantId) {
        const slots = [...(this.bundleSlotsByType[productType] || [])]
        slots[unitIdx] = variantId
        this.bundleSlotsByType = { ...this.bundleSlotsByType, [productType]: slots }
      },

      getBundleSlotColorName(productType, unitIdx) {
        const slots = this.bundleSlotsByType[productType] || []
        const variantId = slots[unitIdx]
        if (!variantId) return ''
        const v = this.variantsById[String(variantId)]
        return v ? (v.option2 || '') : ''
      },

      setSlotColor(option1Key, slotIndex, variantId) {
        const slots = [...(this.slotColorByOption1[option1Key] || [])]
        slots[slotIndex] = variantId
        this.slotColorByOption1 = { ...this.slotColorByOption1, [option1Key]: slots }
      },

      isSlotSwatchSelected(option1Key, slotIndex, variantId) {
        const current = this.getSlotVariantId(option1Key, slotIndex)
        return Number(current) === Number(variantId)
      },
      getSlotColorName(option1Key, slotIndex) {
        const variantId = this.getSlotVariantId(option1Key, slotIndex)
        const v = variantId ? this.variantsById[String(variantId)] : null
        return v ? (v.option2 || '') : ''
      },

      // ── Build flat bundle list ───────────────────────────────────────
      // Called when user clicks NEXT on Step 1.
      // Produces: [{ bundleId, variantId, option1, option2, productType }, ...]
      // opts.advance === false skips swiper navigation (used for direct ATC).
      buildBundles(opts) {
        const advance = !(opts && opts.advance === false)
        const order = this.option1Order.length
          ? this.option1Order
          : Object.keys(this.quantityByOption1)

        const bundles = []
        order.forEach((option1Key) => {
          const qty = this.getQty(option1Key)
          const slots = this.slotColorByOption1[option1Key] || []
          for (let i = 0; i < qty; i++) {
            const variantId =
              slots[i] != null
                ? slots[i]
                : this.firstSwatchVariantIdForOption1(option1Key)
            if (!variantId) continue
            const variant = this.getVariantById(variantId)
            if (!variant) continue
            const bundle = {
              bundleId: `_bundle_qty_${variantId}_s${i}_${Date.now()}_${Math.random()
                .toString(36)
                .slice(2, 7)}`,
              variantId: Number(variantId),
              option1: variant.option1 || option1Key,
              option2: variant.option2 || '',
            }
            bundle.productType = this.expectedAddonProductTypeForBundle(bundle)
            bundles.push(bundle)
          }
        })
        // Bundle card entries — one per type per unit
        const bundleQty = this.getQty('__bundle__')
        if (bundleQty > 0 && this.bundleVariant) {
          const typeOrder = this.getBundleTypeOrder()
          for (let unitIdx = 0; unitIdx < bundleQty; unitIdx++) {
            typeOrder.forEach((t) => {
              const slotVarId = (this.bundleSlotsByType[t.productType] || [])[unitIdx]
                || (t.swatches.length ? t.swatches[0].variantId : null)
              if (!slotVarId) return
              const variant = this.getVariantById(slotVarId)
              if (!variant) return
              const bEntry = {
                bundleId: `_bundle_qty_${slotVarId}_u${unitIdx}_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
                variantId: Number(slotVarId),
                option1: variant.option1 || t.option1,
                option2: variant.option2 || '',
                isBundle: true,
                bundleUnitIdx: unitIdx,
              }
              bEntry.productType = this.expectedAddonProductTypeForBundle(bEntry)
              bundles.push(bEntry)
            })
          }
        }

        this.bundles = bundles
        const newGroups = this.buildAddonTypeGroups(bundles)
        this.addonTypeGroups = newGroups

        // Preserve existing scent selections — clip to new limits, drop removed types
        const preserved = {}
        newGroups.forEach((group) => {
          const existing = this.addonQtyByType[group.productType] || {}
          const limit = group.count
          let total = 0
          const clipped = {}
          Object.entries(existing).forEach(([variantId, qty]) => {
            const q = Number(qty) || 0
            if (q <= 0) return
            const take = Math.min(q, limit - total)
            if (take > 0) { clipped[variantId] = take; total += take }
          })
          // Nothing selected yet: if exactly one in-stock oil is available for
          // this group, default it to 1 instead of leaving all oils at 0.
          if (total === 0 && limit > 0) {
            const availableRows = this.getAvailableAddonRowsForGroup(group)
            if (availableRows.length === 1) {
              clipped[String(availableRows[0].id)] = Math.min(1, limit)
            }
          }
          preserved[group.productType] = clipped
        })
        this.addonQtyByType = preserved

        if (!advance) return

        // After Alpine renders the new x-for slides, update Swiper and advance.
        this.$nextTick(() => {
          const root = this.pdpSwiperRootEl
          if (!root) return
          const rootEl = root.querySelector('.pdp-swiper__root')
          if (!rootEl || !rootEl.swiper) return
          rootEl.swiper.update()
          rootEl.swiper.slideTo(1, 700)
          if (typeof window !== 'undefined' && window.matchMedia &&
              window.matchMedia('(max-width: 989px)').matches) {
            window.scrollTo({ top: 0, behavior: 'smooth' })
          }
        })
      },

      step1PrimaryClick() {
        if (!this.canAdvanceFromStep1() || this.addToCartLoading) return
        if (this.isPaidBestsellerDirectAtc()) {
          this.buildBundles({ advance: false })
          this.addReviewQtySetToCart()
          return
        }
        this.buildBundles()
      },

      // Aliases for hc-rebooted's shared pdp-swiper-aside-quantity.liquid snippet,
      // whose Step 1 NEXT button calls onStep1PrimaryClick()/isDirectAddSelection()
      // (that repo's own pdp-swiper-quantity.liquid section uses those names instead
      // of step1PrimaryClick()/isPaidBestsellerDirectAtc()).
      onStep1PrimaryClick() {
        return this.step1PrimaryClick()
      },
      isDirectAddSelection() {
        return this.isPaidBestsellerDirectAtc()
      },

      // ── Variant lookup helpers ───────────────────────────────────────
      getVariantById(id) {
        if (!id) return null
        return this.variantsById[String(id)] || null
      },

      variantIsAvailable(v) {
        if (!v) return false
        return v.available !== false
      },

      // ── Image URL helper ─────────────────────────────────────────────
      imageUrlWithWidth(url, width) {
        const src = url != null ? String(url).trim() : ''
        const w = Number(width)
        if (!src) return ''
        if (!w || Number.isNaN(w) || w <= 0) return src
        if (src.includes(' width=')) return src
        if (/[?&]width=\d+/.test(src)) {
          return src.replace(/([?&]width=)\d+/, `$1${w}`)
        }
        const sep = src.includes('?') ? '&' : '?'
        return `${src}${sep}width=${w}`
      },

      // ── Card image helpers (used by aside snippet) ───────────────────
      getCardImageForOption1(option1Key) {
        // Returns the default variant's image for this option1 group
        const defaultId = this.defaultByOption1[option1Key]
        const v = this.getVariantById(defaultId)
        return v && v.image ? this.imageUrlWithWidth(v.image, 248) : ''
      },

      // ── Money formatters ─────────────────────────────────────────────
      formatPdpMoney(cents) {
        const n = Number(cents)
        if (cents == null || cents === '' || Number.isNaN(n)) return ''
        if (typeof window.formatMoney === 'function') {
          return window.formatMoney(n)
        }
        return String(n)
      },

      // ── Terms modal ──────────────────────────────────────────────────
      onTermsAcceptanceChange() {
        this.termsAcceptedAt = this.termsAccepted ? new Date().toISOString() : null
      },

      openTermsModal() {
        this.termsModalOpen = true
        document.body.style.overflow = 'hidden'
      },

      closeTermsModal() {
        this.termsModalOpen = false
        document.body.style.overflow = ''
      },

      // ── Addon product type resolution ────────────────────────────────
      isPaidBestsellerOption1(option1) {
        return String(option1 || '').toLowerCase().includes('bestseller')
      },

      // True when Step 1 selection is only paid bestseller set(s) (no free-promo units).
      isPaidBestsellerDirectAtc() {
        let hasBestseller = false
        let hasOther = false
        Object.entries(this.quantityByOption1 || {}).forEach(([key, qty]) => {
          if ((Number(qty) || 0) <= 0) return
          if (key === '__bundle__') {
            hasOther = true
            return
          }
          if (this.isPaidBestsellerOption1(key)) hasBestseller = true
          else hasOther = true
        })
        return hasBestseller && !hasOther
      },

      expectedAddonProductTypeForBundle(bundle) {
        if (!bundle || !bundle.option1) return null
        if (this.isPaidBestsellerOption1(bundle.option1)) return null
        const title = String(bundle.option1)
        const rules = parseQtyAddonProductTypeRules(this.addonProductTypeMap)
        for (let i = 0; i < rules.length; i++) {
          if (title.indexOf(rules[i].match) !== -1) {
            const rule = rules[i]
            return rule.collectionFilter ? rule.productType + '::' + rule.collectionFilter : rule.productType
          }
        }
        return null
      },

      // ── Swiper navigation helpers ────────────────────────────────────
      slideTo(idx) {
        const root = this.pdpSwiperRootEl
        if (!root) return
        const rootEl = root.querySelector('.pdp-swiper__root')
        if (!rootEl || !rootEl.swiper) return
        rootEl.swiper.slideTo(idx, 700)
      },

      advanceAddonStep() {
        const root = this.pdpSwiperRootEl
        if (!root) return
        const rootEl = root.querySelector('.pdp-swiper__root')
        if (!rootEl || !rootEl.swiper) return
        rootEl.swiper.slideNext()
        if (typeof window !== 'undefined' && window.matchMedia &&
            window.matchMedia('(max-width: 989px)').matches) {
          window.scrollTo({ top: 0, behavior: 'smooth' })
        }
      },

      // ── Mobile CTA helpers ───────────────────────────────────────────
      mobileNextDisabled() {
        const reviewIdx = this.reviewSlideIndex()
        if (this.currentSwiperIndex === reviewIdx) {
          if (this.addToCartLoading) return true
          if (this.requiresFreePromoTerms() && !this.termsAccepted) return true
          return false
        }
        if (this.currentSwiperIndex === 0) {
          if (this.addToCartLoading) return true
          return !this.canAdvanceFromStep1()
        }
        if (this.isFrequencySlideIndex(this.currentSwiperIndex)) return false
        const groupIdx = this.scentGroupIndexFromSlide(this.currentSwiperIndex)
        const group = groupIdx != null ? this.addonTypeGroups[groupIdx] : null
        if (!group) return true
        return !this.canAdvanceFromTypeStep(group)
      },

      mobileNextClick() {
        const reviewIdx = this.reviewSlideIndex()
        if (this.currentSwiperIndex === reviewIdx) {
          this.addReviewQtySetToCart()
        } else if (this.currentSwiperIndex === 0) {
          this.step1PrimaryClick()
        } else {
          this.advanceAddonStep()
        }
      },

      frequencyStepEnabled() {
        return !!this.frequencyStep && !this.subscriptionOnly
      },

      // ── Commitment term (12/24/36 month) — now selected on Step 1 itself,
      // alongside the diffuser card. No dedicated slide/index of its own.
      setCommitmentTerm(months) {
        this.selectedCommitmentTerm = months
      },

      isCommitmentTermSelected(months) {
        return this.selectedCommitmentTerm === months
      },

      commitmentTermPriceDisplay(option) {
        return this.formatPdpMoney(Number(option.discountedPrice) || 0)
      },

      commitmentTermCompareDisplay(option) {
        return this.formatPdpMoney(Number(option.basePrice) || 0)
      },

      flowSlides() {
        const slides = []
        this.addonTypeGroups.forEach((group, groupIdx) => {
          if (this.frequencyStepEnabled()) {
            slides.push({
              kind: 'frequency',
              group,
              groupIdx,
              key: 'freq-' + group.productType,
            })
          }
          slides.push({
            kind: 'scent',
            group,
            groupIdx,
            key: 'scent-' + group.productType,
          })
        })
        return slides
      },

      scentSlideIndex(groupIdx) {
        const i = Number(groupIdx || 0)
        return this.frequencyStepEnabled() ? 1 + i * 2 + 1 : 1 + i
      },

      frequencySlideIndex(groupIdx) {
        return 1 + Number(groupIdx || 0) * 2
      },

      reviewSlideIndex() {
        const n = this.addonTypeGroups.length
        return this.frequencyStepEnabled() ? 1 + n * 2 : 1 + n
      },

      isFrequencySlideIndex(idx) {
        if (!this.frequencyStepEnabled()) return false
        const reviewIdx = this.reviewSlideIndex()
        if (idx < 1 || idx >= reviewIdx) return false
        return (idx - 1) % 2 === 0
      },

      scentGroupIndexFromSlide(idx) {
        if (idx < 1 || idx >= this.reviewSlideIndex()) return null
        if (!this.frequencyStepEnabled()) {
          return idx - 1 < this.addonTypeGroups.length ? idx - 1 : null
        }
        const mid = idx - 1
        if (mid % 2 !== 1) return null
        return (mid - 1) / 2
      },

      frequencyStepSubheadline(groupIdx) {
        return 'Step ' + (this.frequencySlideIndex(groupIdx) + 1) + ': Select delivery frequency'
      },

      selectedAddonIdsForGroup(group) {
        if (!group) return []
        const typeMap = this.addonQtyByType[group.productType] || {}
        return Object.keys(typeMap)
          .filter((id) => (Number(typeMap[id]) || 0) > 0)
          .map((id) => Number(id))
      },

      frequencyStepSampleVariantId(group) {
        // Frequency step precedes oil selection, so presume pricing/discount
        // based on the first available oil in the next (scent) step.
        const rows = this.getAddonRowsForGroup(group)
        if (rows.length) return Number(rows[0].id)
        const selected = this.selectedAddonIdsForGroup(group)
        return selected.length ? selected[0] : null
      },

      getGroupPurchaseMode(group) {
        if (!group) return 'subscription'
        const stored = this.groupPurchaseModeByType[group.productType]
        if (stored === 'one_time' || stored === 'subscription') return stored
        const ids = this.selectedAddonIdsForGroup(group)
        if (ids.length) return this.getAddonPurchaseMode(ids[0])
        return 'subscription'
      },

      setGroupPurchaseMode(group, mode) {
        if (!group || this.subscriptionOnly) return
        const next = mode === 'one_time' ? 'one_time' : 'subscription'
        this.groupPurchaseModeByType = {
          ...this.groupPurchaseModeByType,
          [group.productType]: next,
        }
        this.selectedAddonIdsForGroup(group).forEach((id) => this.setAddonPurchaseMode(id, next))
      },

      frequencyStepPricing(group, mode) {
        const id = this.frequencyStepSampleVariantId(group)
        const row = this.addonRowById(id)
        if (!row) return { price: 0, compareAtPrice: 0 }
        return this.normalizedPricing(row, mode === 'one_time' ? 'one_time' : 'subscription')
      },

      frequencyStepPriceDisplay(group, mode) {
        const p = this.frequencyStepPricing(group, mode)
        return this.formatPdpMoney(p.price)
      },

      frequencyStepCompareDisplay(group, mode) {
        const p = this.frequencyStepPricing(group, mode)
        if (!(Number(p.compareAtPrice) > Number(p.price))) return ''
        return this.formatPdpMoney(p.compareAtPrice)
      },

      frequencyStepHasCompare(group, mode) {
        const p = this.frequencyStepPricing(group, mode)
        return Number(p.compareAtPrice) > Number(p.price)
      },

      frequencyStepSavePercent(group) {
        const p = this.frequencyStepPricing(group, 'subscription')
        const compareAt = Number(p.compareAtPrice || 0)
        const price = Number(p.price || 0)
        if (!compareAt || compareAt <= 0 || compareAt <= price) return ''
        return String(Math.round(((compareAt - price) / compareAt) * 100))
      },

      // ── Addon type group builder ─────────────────────────────────────
      buildAddonTypeGroups(bundles) {
        const rules = parseQtyAddonProductTypeRules(this.addonProductTypeMap)
        const seen = []
        const map = {}
        bundles.forEach((bundle) => {
          // Paid bestseller sets already include scents — no oil/frequency step.
          if (this.isPaidBestsellerOption1(bundle.option1)) return
          const compositeKey = bundle.productType || '__none__'
          if (!map[compositeKey]) {
            const o1 = bundle.option1 || ''
            let realProductType = compositeKey
            let collectionFilter = null
            for (let i = 0; i < rules.length; i++) {
              if (o1.indexOf(rules[i].match) !== -1) {
                realProductType = rules[i].productType
                collectionFilter = rules[i].collectionFilter || null
                break
              }
            }
            map[compositeKey] = { productType: compositeKey, realProductType, count: 0, bundles: [], collectionFilter }
            seen.push(compositeKey)
          }
          map[compositeKey].count++
          map[compositeKey].bundles.push(bundle)
        })
        return seen.map((key, idx) => ({
          ...map[key],
          label: 'Oils ' + (idx + 1),
        }))
      },

      // ── Addon step helpers ───────────────────────────────────────────
      getAvailableAddonRowsForGroup(group) {
        const productType = group ? (group.realProductType || group.productType) : null
        const collectionFilter = group ? (group.collectionFilter || null) : null
        const rows = Object.values(this.addonVariantsById).filter((row) => row && row.available !== false)
        return (!productType || productType === '__none__')
          ? rows
          : rows.filter((row) => {
              if (row.productType !== productType) return false
              if (collectionFilter && row.collectionName !== collectionFilter) return false
              return true
            })
      },

      getAddonRowsForGroup(group) {
        const qtyKey = group ? group.productType : null
        const filtered = this.getAvailableAddonRowsForGroup(group)
        const preview = filtered.slice(0, 5)
        const previewIds = {}
        preview.forEach((row) => {
          previewIds[String(row.id)] = true
        })
        const extras = []
        const typeMap = qtyKey ? (this.addonQtyByType[qtyKey] || {}) : {}
        Object.keys(typeMap).forEach((id) => {
          if ((Number(typeMap[id]) || 0) <= 0) return
          if (previewIds[String(id)]) return
          const row = this.addonRowById(id)
          if (row && row.available !== false) extras.push(row)
        })
        return preview.concat(extras)
      },

      getAddonQty(productType, variantId) {
        const typeMap = this.addonQtyByType[productType] || {}
        return typeMap[String(variantId)] || 0
      },

      incrementAddonQty(productType, variantId) {
        const limit = this.addonTypeLimit(productType)
        if (this.addonTypeTotal(productType) >= limit) return
        const typeMap = { ...(this.addonQtyByType[productType] || {}) }
        typeMap[String(variantId)] = (typeMap[String(variantId)] || 0) + 1
        this.addonQtyByType = { ...this.addonQtyByType, [productType]: typeMap }
        if (this.frequencyStepEnabled()) {
          const mode = this.groupPurchaseModeByType[productType] || 'subscription'
          this.setAddonPurchaseMode(variantId, mode)
        }
      },

      decrementAddonQty(productType, variantId) {
        const typeMap = { ...(this.addonQtyByType[productType] || {}) }
        const current = typeMap[String(variantId)] || 0
        if (current <= 0) return
        typeMap[String(variantId)] = current - 1
        this.addonQtyByType = { ...this.addonQtyByType, [productType]: typeMap }
      },

      addonTypeTotal(productType) {
        const typeMap = this.addonQtyByType[productType] || {}
        return Object.values(typeMap).reduce((sum, q) => sum + (Number(q) || 0), 0)
      },

      addonTypeLimit(productType) {
        const group = this.addonTypeGroups.find((g) => g.productType === productType)
        return group ? group.count : 0
      },

      canAdvanceFromTypeStep(group) {
        if (!group) return false
        return this.addonTypeTotal(group.productType) === this.addonTypeLimit(group.productType)
      },

      addonTypeSubheadline(group) {
        if (!group) return ''
        const n = group.count
        const unit = n === 1 ? 'Oil' : 'Oils'
        const option1s = [...new Set((group.bundles || []).map((b) => b.option1 || '').filter(Boolean))]
        const name = option1s.length > 1 ? 'Diffusers' : (option1s[0] || '')
        return `Choose at least <strong>${n} ${unit}</strong> for the ${name}`
      },

      // ── resolvedPairings: expand addonQtyByType into per-bundle pairs ─
      resolvedPairings() {
        const pairs = []
        const covered = {}
        this.addonTypeGroups.forEach((group) => {
          const typeMap = this.addonQtyByType[group.productType] || {}
          // Expand qty map into flat ordered list of addonVariantIds
          const scentList = []
          Object.entries(typeMap).forEach(([variantId, qty]) => {
            for (let i = 0; i < qty; i++) scentList.push(Number(variantId))
          })
          // Zip sequentially with bundles
          group.bundles.forEach((bundle, idx) => {
            covered[bundle.bundleId] = true
            pairs.push({ bundle, addonVariantId: scentList[idx] || null })
          })
        })
        // Paid bestseller (and any other non-grouped) bundles still need a review/ATC pairing
        ;(this.bundles || []).forEach((bundle) => {
          if (!bundle || covered[bundle.bundleId]) return
          pairs.push({ bundle, addonVariantId: null })
        })
        return pairs
      },

      getBundleDiffuserImage(bundle, width) {
        if (!bundle) return ''
        const variant = this.getVariantById(bundle.variantId)
        if (!variant || !variant.image) return ''
        return this.imageUrlWithWidth(variant.image, width || 2000)
      },

      formatStepText(stepNumber) {
        const tmpl = this.stepTextTemplate || 'Step {step_number}: Choose your scent.'
        return tmpl.replace('{step_number}', String(stepNumber))
      },

      // ── Addon pricing ────────────────────────────────────────────────
      mappedDiscountPercentForType(productType) {
        const pt = productType != null ? String(productType).trim() : ''
        if (!pt) return null
        const rules = parseDiscountByProductTypeRules(this.discountByProductTypeMap)
        for (let i = 0; i < rules.length; i++) {
          if (rules[i].productType === pt) return Number(rules[i].percent)
        }
        return null
      },

      selectedCommitmentTermPercent() {
        const opt = (this.commitmentTermOptions || []).find(
          (t) => Number(t.months) === Number(this.selectedCommitmentTerm)
        )
        return opt ? Number(opt.savePercent) : null
      },

      getAddonPurchaseMode(variantId) {
        if (this.subscriptionOnly) return 'subscription'
        const key = String(variantId)
        const mode = this.addonPurchaseModeById[key]
        return mode === 'one_time' ? 'one_time' : 'subscription'
      },

      setAddonPurchaseMode(variantId, mode) {
        if (this.subscriptionOnly) return
        const next = mode === 'one_time' ? 'one_time' : 'subscription'
        this.addonPurchaseModeById = {
          ...this.addonPurchaseModeById,
          [String(variantId)]: next,
        }
      },

      isAddonSubscription(variantId) {
        return this.getAddonPurchaseMode(variantId) === 'subscription'
      },

      normalizedPricing(v, mode) {
        if (!v) return { price: 0, compareAtPrice: 0 }
        const originalPrice = Number(v.price || 0)
        const originalCompare = Number(v.compareAtPrice || 0)
        const purchaseMode = mode || 'subscription'
        if (purchaseMode === 'one_time') {
          return { price: originalPrice, compareAtPrice: originalCompare }
        }
        const mappedPct = this.selectedCommitmentTermPercent()
        if (mappedPct == null) return { price: originalPrice, compareAtPrice: originalCompare }
        const hasOriginalCompare = originalCompare > originalPrice && originalCompare > 0
        if (hasOriginalCompare) {
          const currentPct = ((originalCompare - originalPrice) / originalCompare) * 100
          if (currentPct > mappedPct) return { price: originalPrice, compareAtPrice: originalCompare }
        }
        const base = hasOriginalCompare ? originalCompare : originalPrice
        if (base <= 0) return { price: originalPrice, compareAtPrice: originalCompare }
        const discounted = Math.max(0, Math.round((base * (100 - mappedPct)) / 100))
        if (discounted >= base) return { price: originalPrice, compareAtPrice: originalCompare }
        return { price: discounted, compareAtPrice: base }
      },

      addonRowById(variantId) {
        return this.addonVariantsById[String(variantId)] || null
      },

      normalizedAddonRowById(id) {
        const row = this.addonRowById(id)
        if (!row) return null
        return this.normalizedPricing(row, this.getAddonPurchaseMode(id))
      },

      addonHasCompare(variantId) {
        const p = this.normalizedAddonRowById(variantId)
        if (!p) return false
        return Number(p.compareAtPrice) > Number(p.price)
      },

      addonDisplayCompare(variantId) {
        const p = this.normalizedAddonRowById(variantId)
        if (!p) return ''
        return this.formatPdpMoney(p.compareAtPrice)
      },

      addonDisplayPrice(variantId) {
        const p = this.normalizedAddonRowById(variantId)
        if (!p) return ''
        return this.formatPdpMoney(p.price)
      },

      addonSavePercent(variantId) {
        const p = this.normalizedAddonRowById(variantId)
        if (!p) return ''
        const compareAt = Number(p.compareAtPrice || 0)
        const price = Number(p.price || 0)
        if (!compareAt || compareAt <= 0 || compareAt <= price) return ''
        return String(Math.round(((compareAt - price) / compareAt) * 100))
      },

      // ── Feature metadata (How it works / Subscription perks / Why Aroma360) ──
      getFeatureMetadata() {
        // Use the first option1 group with qty > 0; fallback to first variant overall
        const activeOption1 = this.option1Order.find(
          (key) => this.getQty(key) > 0
        )
        const variantId = activeOption1
          ? this.defaultByOption1[activeOption1]
          : Object.values(this.defaultByOption1)[0]
        const v = this.getVariantById(variantId)
        if (v && v.featureMetadata && v.featureMetadata.length) return v.featureMetadata
        // Fallback: any variant for the same option1 that has metadata
        const option1 = v ? v.option1 : null
        if (option1) {
          const match = Object.values(this.variantsById).find(
            (vv) => vv.option1 === option1 && vv.featureMetadata && vv.featureMetadata.length
          )
          if (match) return match.featureMetadata
        }
        return []
      },

      // ── Addon scent data ─────────────────────────────────────────────
      getAddonScentProfile(variantId) {
        const row = this.addonRowById(variantId)
        if (!row) return []
        return Array.isArray(row.scentProfile) ? row.scentProfile : []
      },

      getAddonScentMoods(variantId) {
        const row = this.addonRowById(variantId)
        if (!row) return []
        return Array.isArray(row.scentMoods) ? row.scentMoods : []
      },

      getAddonScentNotes(variantId) {
        const row = this.addonRowById(variantId)
        return row && row.scentNotes ? row.scentNotes : ''
      },

      // ── Review step helpers ──────────────────────────────────────────

      reviewAddonRowForBundle(bundle) {
        if (!bundle) return null
        const pair = this.resolvedPairings().find(
          (p) => p.bundle.bundleId === bundle.bundleId
        )
        if (!pair || !pair.addonVariantId) return null
        return this.addonRowById(pair.addonVariantId) || null
      },

      reviewMainVariant(bundle) {
        if (!bundle) return null
        return this.getVariantById(bundle.variantId)
      },

      reviewMainDisplayPrice(bundle) {
        const v = this.reviewMainVariant(bundle)
        if (!v) return ''
        const cents = this.isPaidBestsellerOption1(bundle && bundle.option1)
          ? Number(v.realPrice != null ? v.realPrice : v.price) || 0
          : Number(v.price != null ? v.price : v.realPrice) || 0
        return this.formatPdpMoney(cents)
      },

      reviewMainDisplayCompare(bundle) {
        const v = this.reviewMainVariant(bundle)
        if (!v) return ''
        const c = Number(v.compareAtPrice || 0)
        if (!c || c <= 0) return ''
        return this.formatPdpMoney(c)
      },

      reviewMainHasCompare(bundle) {
        const v = this.reviewMainVariant(bundle)
        if (!v) return false
        const price = this.isPaidBestsellerOption1(bundle && bundle.option1)
          ? Number(v.realPrice != null ? v.realPrice : v.price) || 0
          : Number(v.price != null ? v.price : v.realPrice) || 0
        const compare = Number(v.compareAtPrice || 0)
        return compare > price
      },

      reviewSumPriceCents() {
        return this.resolvedPairings().reduce((total, pair) => {
          let sum = total
          const isPaidSet = this.isPaidBestsellerOption1(pair.bundle && pair.bundle.option1)
          if (!this.freePromo || isPaidSet) {
            const main = this.getVariantById(pair.bundle.variantId)
            if (main) {
              sum += isPaidSet
                ? Number(main.realPrice != null ? main.realPrice : main.price) || 0
                : Number(main.price != null ? main.price : main.realPrice) || 0
            }
          }
          if (!pair.addonVariantId) return sum
          const row = this.normalizedAddonRowById(pair.addonVariantId)
          return sum + (row ? Number(row.price) || 0 : 0)
        }, 0)
      },

      reviewSumCompareAtCents() {
        return this.resolvedPairings().reduce((total, pair) => {
          let sum = total
          const isPaidSet = this.isPaidBestsellerOption1(pair.bundle && pair.bundle.option1)
          if (!this.freePromo || isPaidSet) {
            const main = this.getVariantById(pair.bundle.variantId)
            if (main) {
              const fallback = isPaidSet
                ? Number(main.realPrice != null ? main.realPrice : main.price) || 0
                : Number(main.price != null ? main.price : main.realPrice) || 0
              sum += Number(main.compareAtPrice) || fallback
            }
          }
          if (!pair.addonVariantId) return sum
          const row = this.normalizedAddonRowById(pair.addonVariantId)
          return sum + (row ? Number(row.compareAtPrice) || Number(row.price) || 0 : 0)
        }, 0)
      },

      reviewHasSubscription() {
        return this.resolvedPairings().some((pair) => {
          if (!pair.addonVariantId) return false
          return this.isAddonSubscription(pair.addonVariantId)
        })
      },

      reviewSubscriptionSumPriceCents() {
        return this.resolvedPairings().reduce((total, pair) => {
          if (!pair.addonVariantId) return total
          if (!this.isAddonSubscription(pair.addonVariantId)) return total
          const row = this.normalizedAddonRowById(pair.addonVariantId)
          return total + (row ? Number(row.price) || 0 : 0)
        }, 0)
      },

      formatPdpMoneyOrFree(cents) {
        const n = Number(cents)
        if (!n || n <= 0) return 'FREE'
        return this.formatPdpMoney(n)
      },

      // ── Cart helpers (mirror existing section) ───────────────────────

      buildBundleId(mainVariantId, addonVariantId) {
        return `_bundle_${mainVariantId}_${addonVariantId}_plan_30_ts_${Date.now()}`
      },

      compareAtCentsString(variantRow) {
        if (!variantRow) return '0'
        const c = Number(variantRow.compareAtPrice || 0)
        if (!c || c <= 0) return '0'
        return String(Math.round(c))
      },

      compareDiscountPercentString(variantRow) {
        if (!variantRow) return '0'
        const cap = Number(variantRow.compareAtPrice || 0)
        const price = Number(variantRow.price || 0)
        if (!cap || cap <= 0 || cap <= price) return '0'
        const pct = Math.round(((cap - price) / cap) * 100)
        return String(Math.max(0, pct))
      },

      buildBundleLineProperties(variantRow, bundleId, tosAcceptedAt, applyFreePromo) {
        const props = {
          _bundle_id: bundleId,
          _bundle_identifier: 'true',
          _compare_at_price: this.compareAtCentsString(variantRow),
          _compare_at_price_discount: this.compareDiscountPercentString(variantRow),
        }
        if (applyFreePromo) {
          props._bundle_promo = 'free-large-diffuser-promo'
          props._free_diffuser_tos_aceptance =
            tosAcceptedAt != null && tosAcceptedAt !== '' ? String(tosAcceptedAt) : ''
        }
        return props
      },

      diffuserTypeSlug(option1) {
        return (option1 && this.diffuserTypeSlugByOption1[option1]) || ''
      },

      // Shared by both the diffuser line and its paired oil line — both need
      // _diffuser_promo / _promo_term so backend automation can see the promo
      // and term on every line in the bundle, not just the diffuser.
      buildPromoLineProperties(variantRow, bundleId, tosAcceptedAt, applyFreePromo, diffuserOption1) {
        const props = this.buildBundleLineProperties(variantRow, bundleId, tosAcceptedAt, applyFreePromo)
        props._diffuser_promo = this.diffuserPromo || ''
        const slug = this.diffuserTypeSlug(diffuserOption1)
        const term = this.selectedCommitmentTerm != null ? String(this.selectedCommitmentTerm) : ''
        props._promo_term = slug && term ? slug + '-term-' + term : ''
        return props
      },

      requiresFreePromoTerms() {
        if (!this.freePromo) return false
        const bundles = this.bundles || []
        if (!bundles.length) return true
        // Paid bestseller-only carts are not part of the free diffuser promo
        return bundles.some((b) => !this.isPaidBestsellerOption1(b.option1))
      },

      // ── Add to cart ──────────────────────────────────────────────────

      async addReviewQtySetToCart() {
        if (this.addToCartLoading) return
        if (this.requiresFreePromoTerms() && !this.termsAccepted) return
        this.addToCartLoading = true
        try {
          const applyFreePromo = this.requiresFreePromoTerms()
          const tosAt = applyFreePromo ? this.termsAcceptedAt : null
          const items = []

          for (const pair of this.resolvedPairings()) {
            const bundle = pair.bundle
            const mainVariant = this.getVariantById(bundle.variantId)
            if (!mainVariant) continue

            const isPaidSet = this.isPaidBestsellerOption1(bundle.option1)
            const lineFreePromo = applyFreePromo && !isPaidSet
            const mainForProps = isPaidSet
              ? { ...mainVariant, price: Number(mainVariant.realPrice != null ? mainVariant.realPrice : mainVariant.price) || 0 }
              : mainVariant

            const addonRow = pair.addonVariantId ? this.addonRowById(pair.addonVariantId) : null
            const addonEligible = addonRow && addonRow.available !== false
            const resolvedAddonId = addonEligible ? Number(pair.addonVariantId) : 0

            const bundleId = this.buildBundleId(Number(bundle.variantId), resolvedAddonId)

            // Diffuser line item
            items.push({
              id: Number(bundle.variantId),
              quantity: 1,
              properties: this.buildPromoLineProperties(mainForProps, bundleId, tosAt, lineFreePromo, bundle.option1),
            })

            // Scent line item
            if (addonEligible) {
              const addonLine = {
                id: resolvedAddonId,
                quantity: 1,
                properties: this.buildPromoLineProperties(addonRow, bundleId, tosAt, lineFreePromo, bundle.option1),
              }
              if (this.isAddonSubscription(resolvedAddonId)) {
                const sp = addonRow.sellingPlanId
                if (sp != null && sp !== '') {
                  addonLine.selling_plan = Number(sp)
                  addonLine.properties._notes = 'Initial Subscription Order'
                }
              }
              items.push(addonLine)
            }
          }

          if (!items.length) return

          const rootPath =
            typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.root
              ? window.Shopify.routes.root
              : '/'

          const res = await fetch(`${rootPath}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ items }),
          })
          const data = await res.json().catch(() => ({}))
          if (!res.ok || data.status === 422) {
            console.error('[pdp-swiper-ldff] cart/add error:', data)
            return
          }

          document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'))
          document.dispatchEvent(new CustomEvent('eurus:cart:redirect'))
        } catch (err) {
          console.error('[pdp-swiper-ldff] addReviewQtySetToCart error:', err)
        } finally {
          this.addToCartLoading = false
        }
      },

      // ── Popup (Learn More) ──────────────────────────────────────────
      openVariantPopup(option1Key) {
        this.popupOption1 = option1Key
        const id = this.defaultByOption1[option1Key]
        const v = id ? this.variantsById[String(id)] : null
        if (!v) {
          const fallback = Object.values(this.variantsById).find((vv) => vv.option1 === option1Key)
          if (!fallback) return
          this.popupVariant = fallback
        } else {
          this.popupVariant = v
        }
        this.popupOpen = true
        this.popupSectionsHtml = ''
        this.$nextTick(() => {
          this.fetchPopupSections(this.popupLinkedProductHandle())
        })
      },
      closePopup() {
        this.popupOpen = false
        this.popupVariant = null
        this.popupOption1 = null
      },
      popupAccordionItems() {
        const option1 = this.popupOption1
        const all = Object.values(this.variantsById)
        const match = all.find((v) => v.option1 === option1 && v.accordionItems?.length)
        return match?.accordionItems || this.popupVariant?.accordionItems || []
      },
      popupLinkedProductHandle() {
        const items = this.popupAccordionItems()
        const item = items.find((i) => i.linkedProductHandle)
        return item?.linkedProductHandle || null
      },
      _initPopupSectionAnimations() {
        const container = this.$refs.popupSections
        if (!container) return
        const store = Alpine.store('xScrollPromotion')
        if (store) {
          const bannerEl = container.querySelector('.el_animate')?.closest('[class*="section-"]')
          if (bannerEl) { store.load(bannerEl); return }
        }
        container.querySelectorAll('.el_animate').forEach((el) => {
          el.classList.add('animate-scroll-banner')
        })
      },
      async fetchPopupSections(handle) {
        if (!handle) return
        if (this.popupSectionsCache[handle] !== undefined) {
          this.popupSectionsHtml = this.popupSectionsCache[handle]
          await this.$nextTick()
          this._initPopupSectionAnimations()
          return
        }
        const items = this.popupAccordionItems()
        const sourceItem = items.find((i) => i.linkedProductHandle === handle)
        let sectionIds = [sourceItem?.popupSection1, sourceItem?.popupSection2].filter(Boolean)
        if (sectionIds.length === 0) {
          const sectionMap = {
            'mini360-scent-diffuser': ['scrolling_banner_JGUym3', 'grid_blocks_mp494W'],
            'smart-car-diffuser': ['scrolling_banner_3aBXMF', 'image_with_text_LtBR7i']
          }
          sectionIds = sectionMap[handle] || []
        }
        const ratingId = 'pdp-popup-okendo-rating'
        try {
          const res = await fetch(`${window.location.origin}/products/${handle}`)
          const html = await res.text()
          const parser = new DOMParser()
          const doc = parser.parseFromString(html, 'text/html')
          const ratingSection = doc.querySelector(`#shopify-section-${ratingId}`)
          if (ratingSection && this.popupVariant) {
            const tmp = document.createElement('div')
            tmp.innerHTML = ratingSection.outerHTML
            const el = tmp.querySelector('[data-popup-okendo-rating]')
            if (el) {
              try {
                const rd = JSON.parse(el.textContent)
                this.popupVariant = { ...this.popupVariant, reviewCount: rd.reviewCount, reviewRating: rd.reviewRating }
              } catch(e) {}
            }
          }
          let sectionHtml = ''
          sectionIds.forEach((sectionSuffix) => {
            const section = doc.querySelector(`[id*="${sectionSuffix}"]`)
            if (section) sectionHtml += section.outerHTML
          })
          this.popupSectionsCache[handle] = sectionHtml
          this.popupSectionsHtml = sectionHtml
          await this.$nextTick()
          this._initPopupSectionAnimations()
        } catch (e) {
          console.error('Error fetching popup sections:', e)
          this.popupSectionsCache[handle] = ''
          this.popupSectionsHtml = ''
        }
      },
      popupSelectSwatch(variantId) {
        const v = this.variantsById[String(variantId)]
        if (v) this.popupVariant = v
      },
      popupSwatches() {
        if (!this.popupOption1) return []
        const swatches = []
        const seen = {}
        Object.values(this.variantsById).forEach((v) => {
          if (v.option1 !== this.popupOption1) return
          if (!v.available) return
          if (!v.option2 || seen[v.option2]) return
          seen[v.option2] = true
          swatches.push({ id: v.id, label: v.option2, bg: v.swatchBg || '#e0e0e0' })
        })
        return swatches
      },
      isPopupSwatchActive(variantId) {
        return this.popupVariant && Number(this.popupVariant.id) === Number(variantId)
      },
      popupFeatures() {
        if (!this.popupVariant) return []
        return Array.isArray(this.popupVariant.allFeatures) ? this.popupVariant.allFeatures : []
      },
      popupTitle() {
        if (!this.popupVariant) return ''
        return this.popupVariant.option1 || this.popupVariant.title || ''
      },
      popupImage() {
        if (!this.popupVariant) return ''
        return this.popupVariant.image || ''
      },
      popupCompareAtPrice() {
        if (!this.popupVariant) return ''
        const c = Number(this.popupVariant.compareAtPrice || 0)
        const p = Number(this.popupVariant.realPrice || this.popupVariant.price || 0)
        if (c > p) return this.formatPdpMoney(c)
        return ''
      },
      popupShowsFreePrice() {
        if (!this.freePromo) return false
        const o1 =
          (this.popupVariant && this.popupVariant.option1) ||
          this.popupOption1 ||
          ''
        // Paid bestseller sets show catalog price in the learn-more popup
        if (this.isPaidBestsellerOption1(o1)) return false
        return true
      },
      popupCurrentPrice() {
        if (!this.popupVariant) return ''
        return this.formatPdpMoney(
          Number(this.popupVariant.realPrice != null ? this.popupVariant.realPrice : this.popupVariant.price) || 0
        )
      },
      richTextToHtml(json) {
        if (!json) return ''
        let tree
        try { tree = typeof json === 'string' ? JSON.parse(json) : json }
        catch (e) { return json }
        function walk(node) {
          if (!node) return ''
          if (node.type === 'text') {
            let t = (node.value || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
            if (node.bold)   t = '<strong>' + t + '</strong>'
            if (node.italic) t = '<em>' + t + '</em>'
            if (node.code)   t = '<code>' + t + '</code>'
            return t
          }
          const inner = (node.children || []).map(walk).join('')
          switch (node.type) {
            case 'root':      return inner
            case 'paragraph': return '<p>' + inner + '</p>'
            case 'heading':   return '<h' + node.level + '>' + inner + '</h' + node.level + '>'
            case 'list':      return node.listType === 'ordered' ? '<ol>' + inner + '</ol>' : '<ul>' + inner + '</ul>'
            case 'list-item': return '<li>' + inner + '</li>'
            case 'link':      return '<a href="' + (node.url || '') + '"' + (node.target ? ' target="' + node.target + '"' : '') + '>' + inner + '</a>'
            default:          return inner
          }
        }
        return walk(tree)
      },

      // ── Review image ────────────────────────────────────────────────
      reviewMappedImageUrl() {
        const bundles = this.bundles || []
        const option1 = bundles.length ? (bundles[0].option1 || '') : ''
        const rules = parseQtyAddonProductTypeRules(this.addonProductTypeMap)
        let productType = null
        for (let i = 0; i < rules.length; i++) {
          if (option1.indexOf(rules[i].match) !== -1) { productType = rules[i].productType; break }
        }
        const mappings = Array.isArray(this.reviewImageMappings) ? this.reviewImageMappings : []
        for (let i = 0; i < mappings.length; i++) {
          const row = mappings[i] || {}
          const rowRules = parseQtyAddonProductTypeRules(row.map || '')
          for (let j = 0; j < rowRules.length; j++) {
            const matches = productType
              ? rowRules[j].productType === productType
              : option1.indexOf(rowRules[j].match) !== -1
            if (matches && row.imageUrl) return row.imageUrl
          }
        }
        // No merchant-configured mapping matched — fall back to the actual
        // selected diffuser variant's image (correct color) rather than a
        // single static product photo that ignores which color was chosen.
        if (bundles.length) {
          const dynamic = this.getBundleDiffuserImage(bundles[0], 2000)
          if (dynamic) return dynamic
        }
        return this.productFeaturedImage || ''
      },

      // ── Addon popup ──────────────────────────────────────────────────
      openAddonPopup(addonVariantId) {
        const v = this.addonRowById(addonVariantId)
        if (v) {
          this.addonPopupVariant = v
          this.addonPopupOpen = true
          this.addonPopupSectionsHtml = ''
          this.$nextTick(() => {
            this.fetchAddonPopupSections(v.handle)
          })
        }
      },
      closeAddonPopup() {
        this.addonPopupOpen = false
        this.addonPopupVariant = null
      },
      addonPopupTitle() {
        if (!this.addonPopupVariant) return ''
        return this.addonPopupVariant.cardTitle || ''
      },
      addonPopupImage() {
        if (!this.addonPopupVariant) return ''
        return this.addonPopupVariant.cardImage || ''
      },
      addonPopupPrice() {
        if (!this.addonPopupVariant) return ''
        return this.addonDisplayPrice(this.addonPopupVariant.id)
      },
      addonPopupCompareAtPrice() {
        if (!this.addonPopupVariant) return ''
        return this.addonDisplayCompare(this.addonPopupVariant.id)
      },
      addonPopupHasCompare() {
        if (!this.addonPopupVariant) return false
        return this.addonHasCompare(this.addonPopupVariant.id)
      },
      addonPopupSavePercent() {
        if (!this.addonPopupVariant) return ''
        const pct = this.addonSavePercent(this.addonPopupVariant.id)
        return pct ? pct + '%' : ''
      },
      addonPopupScentProfile() {
        if (!this.addonPopupVariant) return []
        return Array.isArray(this.addonPopupVariant.scentProfile) ? this.addonPopupVariant.scentProfile : []
      },
      addonPopupScentMoods() {
        if (!this.addonPopupVariant) return []
        return Array.isArray(this.addonPopupVariant.scentMoods) ? this.addonPopupVariant.scentMoods : []
      },
      addonPopupInspiredBy() {
        if (!this.addonPopupVariant) return ''
        return this.addonPopupVariant.inspiredBy || ''
      },
      addonPopupDescription() {
        if (!this.addonPopupVariant) return ''
        return this.addonPopupVariant.description || ''
      },
      _initAddonPopupSectionAnimations() {
        const container = this.$refs.addonPopupSections
        if (!container) return
        container.querySelectorAll('.el_animate').forEach(el => {
          el.classList.add('animate-scroll-banner')
        })
      },
      async fetchAddonPopupSections(handle) {
        if (!handle) return
        if (this.addonPopupSectionsCache[handle] !== undefined) {
          this.addonPopupSectionsHtml = this.addonPopupSectionsCache[handle]
          await this.$nextTick()
          this._initAddonPopupSectionAnimations()
          return
        }
        const sectionIds = ['scrolling_banner_3aBXMF', 'image_with_text_LtBR7i']
        try {
          const url = `${window.location.origin}/products/${handle}`
          const res = await fetch(url)
          const html = await res.text()
          const parser = new DOMParser()
          const doc = parser.parseFromString(html, 'text/html')
          let sectionHtml = ''
          sectionIds.forEach(sectionSuffix => {
            const section = doc.querySelector(`[id*="${sectionSuffix}"]`)
            if (section) sectionHtml += section.outerHTML
          })
          this.addonPopupSectionsCache[handle] = sectionHtml
          this.addonPopupSectionsHtml = sectionHtml
          await this.$nextTick()
          this._initAddonPopupSectionAnimations()
        } catch (e) {
          this.addonPopupSectionsCache[handle] = ''
          this.addonPopupSectionsHtml = ''
        }
      },

    }))
  })


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-swiper-nba"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('alpine:init', () => {
    Alpine.data('pdpSwiperNbaState', () => ({
      // ── raw catalog data, parsed once from the JSON blob ──────────────
      data: null,
      teamList: [],
      diffuserOptions: [],
      featureMetadataSections: [],
      bundlePromo: 'free-diffuser-set',

      // ── selection state ────────────────────────────────────────────
      // Keyed directly by each diffuser option's real option1 value
      // (data.diffuserOptions[].key) — no fixed "diffuser1"/"diffuser2"
      // role names, so this generalizes to however many diffuser options
      // the product actually has.
      quantityByOption1: {},
      selectedTeam: null,
      currentStep: 0,
      termsAccepted: false,
      termsAcceptedAt: null,
      termsModalOpen: false,
      addToCartLoading: false,
      learnMoreOpen: false,
      learnMoreKey: null,

      init() {
        const jsonEl = this.$root.querySelector('[data-pdp-nba-state]')
        this.data = jsonEl ? JSON.parse(jsonEl.textContent) : null
        this.bundlePromo = (this.data && this.data.bundlePromo) || this.bundlePromo
        this.teamList = (this.data && this.data.teams) || []
        this.diffuserOptions = (this.data && this.data.diffuserOptions) || []
        this.featureMetadataSections = (this.data && this.data.featureMetadataSections) || []
        // Every discovered diffuser option starts at qty 0.
        // Bundle gets its own independent quantity key too — same object,
        // no special-casing, no cross-mutation with the diffuser options.
        const bundleKeyEntry = (this.data && this.data.bundle && this.data.bundle.key) ? [[this.data.bundle.key, 0]] : []
        this.quantityByOption1 = Object.fromEntries([...this.diffuserOptions.map((o) => [o.key, 0]), ...bundleKeyEntry])

        // Bridge the vendor Swiper instance's slideChange to Alpine state,
        // same pattern as pdp-swiper-quantity.liquid's slide-change event.
        this.$nextTick(() => {
          const rootEl = this.$root.querySelector('[data-pdp-nba-root]')
          if (!rootEl || typeof window.Swiper === 'undefined') return
          const swiper = new window.Swiper(rootEl, {
            slidesPerView: 1,
            allowTouchMove: false,
            simulateTouch: false,
            autoHeight: true,
            on: {
              slideChange: (sw) => { this.currentStep = sw.activeIndex },
            },
          })
          rootEl.swiper = swiper
        })
      },

      // ── step navigation ────────────────────────────────────────────
      slideTo(idx) {
        const rootEl = this.$root.querySelector('[data-pdp-nba-root]')
        if (rootEl && rootEl.swiper) rootEl.swiper.slideTo(idx, 700)
        this.currentStep = idx
      },
      goToStepIfValid(idx) {
        if (idx >= 1 && this.totalDiffuserQty() === 0) return
        if (idx >= 2 && !this.teamSelectionIsComplete()) return
        this.slideTo(idx)
      },

      // ── step 1: quantity ───────────────────────────────────────────
      getQty(key) { return Number(this.quantityByOption1[key] || 0) },
      // Same 5-unit hard cap as pdp-swiper-quantity.liquid's
      // totalWeightedUnits()/incrementQty() — a bundle unit weighs as much
      // as one of each real diffuser it expands into (there, a fixed 3;
      // here, diffuserOptions.length, since the set of diffuser options is
      // discovered dynamically rather than fixed).
      bundleWeight() {
        return Math.max(this.diffuserOptions.length, 1)
      },
      weightForKey(key) {
        return this.data && this.data.bundle && key === this.data.bundle.key ? this.bundleWeight() : 1
      },
      totalWeightedUnits() {
        const regular = this.diffuserOptions.reduce((sum, o) => sum + this.getQty(o.key), 0)
        return regular + this.bundleQty() * this.bundleWeight()
      },
      canIncrement(key) {
        return this.totalWeightedUnits() + this.weightForKey(key) <= 6
      },
      incrementQty(key) {
        if (!this.canIncrement(key)) return
        this.quantityByOption1 = { ...this.quantityByOption1, [key]: this.getQty(key) + 1 }
      },
      decrementQty(key) {
        const next = Math.max(0, this.getQty(key) - 1)
        this.quantityByOption1 = { ...this.quantityByOption1, [key]: next }
      },
      // Sum of every card's own quantity (diffuser options + bundle) — just
      // used to gate the step-1 "Next" button on "something is selected".
      totalDiffuserQty() {
        return Object.values(this.quantityByOption1).reduce((sum, n) => sum + Number(n || 0), 0)
      },
      bundleQty() {
        return this.data && this.data.bundle ? this.getQty(this.data.bundle.key) : 0
      },
      // The quantity that actually matters for a given diffuser option once
      // the Bundle placeholder is accounted for: its own directly-selected
      // quantity PLUS one per bundle unit — exactly the same "bundle
      // expands into one of each real diffuser at resolution time" concept
      // the original sections use (see plan: Bundle Construction). This is
      // the ONLY place bundle quantity and diffuser quantity interact —
      // the step-1 cards themselves stay fully independent (no
      // cross-mutation), per plan.
      effectiveQty(diffuserKey) {
        return this.getQty(diffuserKey) + this.bundleQty()
      },
      // Unified step-1 card list — the bundle figurehead first, then every
      // discovered diffuser option, so all cards render through one
      // identical template with identical (independent) qty behavior.
      cardList() {
        if (!this.data) return []
        return [this.data.bundle, ...this.diffuserOptions.map((o) => ({ ...o, name: o.key }))]
      },

      // ── team → variant resolution ──────────────────────────────────
      // Shared by every product role (diffuser 1, diffuser 2, each oil, the
      // gift, the gift fallback): match on option2 first (team is option2
      // on the main product's variants per confirmed store setup), fall
      // back to a `custom.team` variant metafield for a referenced addon/
      // gift product that doesn't use option2 for team.
      resolveTeamVariantFromList(list, team) {
        if (!list || !list.length || !team) return null
        const norm = (s) => String(s || '').trim().toLowerCase()
        let match = list.find((v) => norm(v.option2) === norm(team))
        if (!match) match = list.find((v) => norm(v.teamMeta) === norm(team))
        if (!match) return null
        return match.available !== false ? match : null
      },
      variantsForOption1(key) {
        if (!this.data || !key) return []
        return (this.data.productVariants || []).filter((v) => v.option1 === key)
      },
      resolveDiffuserVariant(key, team) {
        return this.resolveTeamVariantFromList(this.variantsForOption1(key), team)
      },
      // Oil no longer gets team-matched by scanning a pool of variants —
      // oil/car-oil products don't carry team on any option or metafield
      // (see pdp-swiper-nba-team-map.liquid), so it's looked up directly:
      // team → diffuser option1 key → an already-resolved variant row,
      // straight out of the hardcoded map baked into the JSON blob.
      resolveOilVariant(diffuserKey, team) {
        if (!this.data || !this.data.teamMap || !diffuserKey || !team) return null
        const teamEntry = this.data.teamMap[team]
        const variant = teamEntry && teamEntry.oils && teamEntry.oils[diffuserKey]
        return variant && variant.available !== false ? variant : null
      },
      // ── stock substitution: never block checkout over one out-of-stock item ──
      // One shared substitute per role (not per team) — if the team's own
      // item isn't available, fall back to data.substitutes.{diffusers,oils}
      // [key] (already resolved server-side, incl. the Mini Pro oil's exact
      // variant match). isFallback lets the UI/pricing know a substitution
      // happened, same shape resolveGiftVariant() already returns.
      resolveDiffuserVariantResolved(key, team) {
        const exact = this.resolveDiffuserVariant(key, team)
        if (exact) return { variant: exact, isFallback: false }
        const substitute = this.data && this.data.substitutes && this.data.substitutes.diffusers && this.data.substitutes.diffusers[key]
        if (substitute && substitute.available !== false) return { variant: substitute, isFallback: true }
        return { variant: null, isFallback: false }
      },
      resolveOilVariantResolved(key, team) {
        const exact = this.resolveOilVariant(key, team)
        if (exact) return { variant: exact, isFallback: false }
        const substitute = this.data && this.data.substitutes && this.data.substitutes.oils && this.data.substitutes.oils[key]
        if (substitute && substitute.available !== false) return { variant: substitute, isFallback: true }
        return { variant: null, isFallback: false }
      },
      selectTeam(team) { this.selectedTeam = team },
      // Complete once every selected diffuser's diffuser+oil AND the gift
      // resolve to SOMETHING (team item or substitute) — a stock gap alone
      // no longer blocks Next, only a gap with no substitute configured does.
      teamSelectionIsComplete() {
        if (!this.selectedTeam || !this.data) return false
        for (const opt of this.diffuserOptions) {
          if (this.effectiveQty(opt.key) <= 0) continue
          if (!this.resolveDiffuserVariantResolved(opt.key, this.selectedTeam).variant) return false
          if (!this.resolveOilVariantResolved(opt.key, this.selectedTeam).variant) return false
        }
        return !!this.resolveGiftVariant()
      },
      // True if any selected diffuser/oil, or the gift, is currently
      // running on its substitute rather than the team's own item — drives
      // the yellow "replaced with a substitute" banner on step 2.
      // Gift substitution is deliberately excluded — the user never had an
      // explicit expectation of getting a specific team candle, so a
      // fallback there isn't worth flagging the way a swapped diffuser/oil
      // is.
      hasSubstitutions() {
        if (!this.selectedTeam || !this.data) return false
        for (const opt of this.diffuserOptions) {
          if (this.effectiveQty(opt.key) <= 0) continue
          if (this.resolveDiffuserVariantResolved(opt.key, this.selectedTeam).isFallback) return true
          if (this.resolveOilVariantResolved(opt.key, this.selectedTeam).isFallback) return true
        }
        return false
      },
      // 'none' | 'ok' | 'substituted' | 'blocked' — single source of truth
      // for the step-2 pick banner's copy/color.
      bannerState() {
        if (!this.selectedTeam) return 'none'
        if (!this.teamSelectionIsComplete()) return 'blocked'
        return this.hasSubstitutions() ? 'substituted' : 'ok'
      },
      pickMessage() {
        const t = this.selectedTeam
        const parts = this.diffuserOptions
          .filter((o) => this.effectiveQty(o.key) > 0)
          .map((o) => `${t} ${o.key} Oil`)
        const oilsText = parts.join(' and ')
        return `${oilsText}${oilsText ? ' and ' : ''}${t} NBA Candle selected automatically.`
      },
      // Real team swatch (image or color) from the product's own option2
      // values — same source pdp-swiper-quantity.liquid's swatchesByOption1
      // uses for color. Falls back to a deterministic hashed color (with
      // initials shown as text) only for a team option value that has no
      // swatch configured in Shopify admin yet.
      teamSwatchStyle(team) {
        if (team.swatchBg) return `background: ${team.swatchBg}; background-size: cover; background-position: center;`
        let hash = 0
        for (let i = 0; i < team.name.length; i++) hash = team.name.charCodeAt(i) + ((hash << 5) - hash)
        const hue = Math.abs(hash) % 360
        return `background: hsl(${hue}, 42%, 32%);`
      },
      teamInitials(team) {
        return team.split(' ').map((w) => w[0]).join('').slice(-3).toUpperCase()
      },

      // ── free gift: exactly one per checkout, section-wide promo ─────
      // Same hardcoded-map lookup as oil — the candle is resolved directly
      // by team, not matched. Falls back to the single non-team product
      // configured as a section setting if no candle is mapped/available
      // for this team yet. Not tied to the Bundle option or diffuser
      // quantity — computed once per checkout.
      resolveGiftVariant() {
        if (!this.data || !this.selectedTeam) return null
        const teamEntry = this.data.teamMap && this.data.teamMap[this.selectedTeam]
        const candle = teamEntry && teamEntry.candle
        if (candle && candle.available !== false) return { variant: candle, isFallback: false }
        const fallback = this.data.giftFallback && this.data.giftFallback.variants && this.data.giftFallback.variants[0]
        if (fallback && fallback.available !== false) return { variant: fallback, isFallback: true }
        return null
      },

      // ── money formatting ──────────────────────────────────────────
      // variant.price/compareAtPrice render as raw CENTS when interpolated
      // directly in Liquid (not decimal dollars) — same as
      // pdp-swiper-quantity.liquid's formatPdpMoney(), use Shopify's global
      // cents-aware formatter rather than a hand-rolled toFixed(2).
      formatMoney(cents) {
        const n = Number(cents || 0)
        if (typeof window.formatMoney === 'function') return window.formatMoney(n)
        return '$' + (n / 100).toFixed(2)
      },
      dueTodayFormatted() {
        let total = 0
        this.diffuserOptions.forEach((o) => {
          const qty = this.effectiveQty(o.key)
          if (qty <= 0) return
          const oil = this.resolveOilVariantResolved(o.key, this.selectedTeam).variant
          if (oil) total += Number(oil.price || 0) * qty
        })
        return this.formatMoney(total)
      },

      // ── step 2: fine print ─────────────────────────────────────────
      // Static/always-on (not a section setting — every price in it is
      // still computed live). It used to return '' until a team was picked,
      // which meant this box only gained its content (and height) after
      // selection — collapsing/expanding the layout around the team grid
      // and clipping the bottom rows. It now always renders, using
      // per-diffuser quantities from step 1 (available before any team is
      // chosen), so the box's height is stable from the moment step 2
      // loads.
      //
      // Cancellation fee is a fixed, business-set amount per diffuser role
      // (NOT derived from compare-at price anymore — that produced
      // inconsistent numbers depending on which substitute/team resolved).
      // Mirrors the same array-position convention used elsewhere in this
      // file (reviewLines()'s `isCarDiffuser = idx === 1`): index 0 is
      // always the Mini Pro diffuser, index 1 the Smart Car diffuser.
      cancelFeeCentsForDiffuserIndex(idx) {
        const CANCEL_FEE_CENTS = [11567, 7576] // [Mini Pro, Smart Car] — dollars * 100
        return CANCEL_FEE_CENTS[idx] || 0
      },
      // Highest oil price found across every team's mapping for this
      // diffuser role — used only pre-team-selection so the price shown
      // is never an undersell of what a (possibly pricier) team's scent
      // will actually cost once picked.
      maxOilPriceForKey(key) {
        const teamMap = this.data && this.data.teamMap
        if (!teamMap) return 0
        let max = 0
        Object.keys(teamMap).forEach((team) => {
          const oil = teamMap[team].oils && teamMap[team].oils[key]
          const price = oil && Number(oil.price || 0)
          if (price > max) max = price
        })
        return max
      },
      step2Fineprint() {
        if (!this.data) return ''
        const sentences = this.diffuserOptions
          .map((o, idx) => {
            const qty = this.effectiveQty(o.key)
            if (qty <= 0) return null
            let monthlyUnitPrice = 0
            let oilName = "your team's scent"
            if (this.selectedTeam) {
              const oil = this.resolveOilVariantResolved(o.key, this.selectedTeam).variant
              if (!oil) return null
              monthlyUnitPrice = Number(oil.price || 0)
              oilName = oil.productTitle || oil.title || oilName
            } else {
              monthlyUnitPrice = this.maxOilPriceForKey(o.key)
            }
            const monthlyTotal = monthlyUnitPrice * qty
            const cancelFee = this.cancelFeeCentsForDiffuserIndex(idx) * qty
            return `Your ${o.key} is free with a 6-month ${oilName} subscription (${this.formatMoney(monthlyTotal)}/mo) — cancel early and pay ${this.formatMoney(cancelFee)}.`
          })
          .filter(Boolean)
        if (!sentences.length) return ''
        return `${sentences.join(' ')} 30-day risk-free returns.`
      },

      // ── step 3: review ────────────────────────────────────────────
      reviewLines() {
        if (!this.data || !this.selectedTeam) return []
        const lines = []
        this.diffuserOptions.forEach((o, idx) => {
          const qty = this.effectiveQty(o.key)
          if (qty <= 0) return
          // Card title stays the role name ("NBA Mini Pro Diffuser" / team
          // + " Oil") whether substituted or not — what actually changed is
          // called out as its own stacked line (substitutionNote) styled
          // like the small commitment/shipping text, not by swapping the
          // title itself. Named from the substitute product's own title,
          // EXCEPT the car diffuser (2nd discovered diffuser role), which
          // is described by its variant's option1 value instead — the
          // product title alone ("Smart Car Diffuser") doesn't distinguish
          // it, and the full variant title includes extra option segments
          // beyond just the option1 name.
          const dResolved = this.resolveDiffuserVariantResolved(o.key, this.selectedTeam)
          const d = dResolved.variant
          if (d) {
            const isCarDiffuser = idx === 1
            const subName = isCarDiffuser ? (d.option1 || d.title || d.productTitle) : (d.productTitle || d.title)
            lines.push({
              key: o.key,
              icon: '▮',
              image: d.image,
              name: o.key,
              desc: this.selectedTeam + ' · with 6-mo subscription',
              substitutionNote: dResolved.isFallback ? `Substituted with ${subName}` : '',
              qty,
              free: true,
              substituted: dResolved.isFallback,
            })
          }
          const oilResolved = this.resolveOilVariantResolved(o.key, this.selectedTeam)
          const oil = oilResolved.variant
          if (oil) {
            // Mini Pro oils are one standalone product per scent, so
            // productTitle already IS the scent name ("My Way"). Car oil is
            // one shared product across every scent — its productTitle is
            // just "Smart Car Diffuser Oil", so the actual scent lives in
            // the variant's option1 instead. Same role-based split as the
            // car diffuser's substitutionNote above.
            //
            // Unlike the diffuser, a substituted oil doesn't get a stacked
            // note — its scent name replaces the team name directly in the
            // title ("My Way Mini Pro Diffuser Oil" instead of "Atlanta
            // Hawks Mini Pro Diffuser Oil"), since "the oil" already means
            // "the scent" to begin with.
            const isCarOil = idx === 1
            const oilSubName = isCarOil ? (oil.option1 || oil.productTitle) : (oil.productTitle || oil.title)
            // Drop the "NBA" prefix from the role name here — it's the
            // official product name elsewhere (cards, etc.), but reads
            // redundant stacked right after a team/scent name in this title.
            const oilRoleName = o.key.replace(/^NBA\s+/, '')
            lines.push({
              key: o.key + '-oil',
              icon: '🧴',
              image: oil.image,
              name: (oilResolved.isFallback ? oilSubName : this.selectedTeam) + ' ' + oilRoleName + ' Oil',
              desc: 'Ships monthly · 6-month commitment',
              qty,
              free: false,
              priceFormatted: this.formatMoney(oil.price),
              substituted: oilResolved.isFallback,
            })
          }
        })
        const gift = this.resolveGiftVariant()
        if (gift) {
          lines.push({
            key: 'gift',
            image: gift.variant.image,
            icon: '🕯️',
            name: gift.isFallback ? this.data.giftFallback.name : (this.selectedTeam + ' NBA Candle'),
            desc: 'FREE GIFT with purchase — ships with your first order',
            // Deliberately never marked substituted — see hasSubstitutions().
            substituted: false,
            qty: 1,
            free: true,
          })
        }
        return lines
      },

      // ── terms ─────────────────────────────────────────────────────
      onTermsAcceptanceChange() {
        this.termsAcceptedAt = this.termsAccepted ? new Date().toISOString() : null
      },
      openTermsModal() { this.termsModalOpen = true; document.body.style.overflow = 'hidden' },
      closeTermsModal() { this.termsModalOpen = false; document.body.style.overflow = '' },

      // ── "Learn more" popup — step 1 diffuser cards only ──────────────
      // Purely informational (no variant selection/qty inside it, unlike
      // the originals' popup — this card already owns its own qty
      // stepper). Never opened for the bundle card (see markup x-show).
      openLearnMore(cardKey) {
        this.learnMoreKey = cardKey
        this.learnMoreOpen = true
        document.body.style.overflow = 'hidden'
      },
      closeLearnMore() {
        this.learnMoreOpen = false
        this.learnMoreKey = null
        document.body.style.overflow = ''
      },
      learnMoreCard() {
        if (!this.learnMoreKey) return null
        return this.diffuserOptions.find((o) => o.key === this.learnMoreKey) || null
      },
      // Ported from pdp-swiper-quantity.liquid's richTextToHtml — renders a
      // Shopify rich-text-field JSON tree (from variant_page_accordion) as
      // plain HTML for the accordion body.
      richTextToHtml(json) {
        if (!json) return ''
        let tree
        try { tree = typeof json === 'string' ? JSON.parse(json) : json }
        catch (e) { return json }
        function walk(node) {
          if (!node) return ''
          if (node.type === 'text') {
            let t = (node.value || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
            if (node.bold) t = '<strong>' + t + '</strong>'
            if (node.italic) t = '<em>' + t + '</em>'
            if (node.code) t = '<code>' + t + '</code>'
            return t
          }
          const inner = (node.children || []).map(walk).join('')
          switch (node.type) {
            case 'root': return inner
            case 'paragraph': return '<p>' + inner + '</p>'
            case 'heading': return '<h' + node.level + '>' + inner + '</h' + node.level + '>'
            case 'list': return node.listType === 'ordered' ? '<ol>' + inner + '</ol>' : '<ul>' + inner + '</ul>'
            case 'list-item': return '<li>' + inner + '</li>'
            case 'link': return '<a href="' + (node.url || '') + '"' + (node.target ? ' target="' + node.target + '"' : '') + '>' + inner + '</a>'
            default: return inner
          }
        }
        return walk(tree)
      },

      // ── bundle line-item property contract ───────────────────────
      // Copied verbatim from pdp-swiper-quantity.liquid's
      // buildBundleLineProperties() — the third-party discount app depends
      // on these exact keys (including the `_free_diffuser_tos_aceptance`
      // typo). Only `_bundle_promo`'s value changes, to a new NBA-specific
      // constant so the app can tell this campaign apart from the original.
      compareAtCentsString(variantRow) {
        const c = Number((variantRow && variantRow.compareAtPrice) || 0)
        if (!c || c <= 0) return '0'
        return String(Math.round(c))
      },
      compareDiscountPercentString(variantRow) {
        if (!variantRow) return '0'
        const cap = Number(variantRow.compareAtPrice || 0)
        const price = Number(variantRow.price || 0)
        if (!cap || cap <= 0 || cap <= price) return '0'
        return String(Math.max(0, Math.round(((cap - price) / cap) * 100)))
      },
      buildBundleLineProperties(variantRow, bundleId, tosAcceptedAt, extraProperties) {
        return {
          _bundle_promo: this.bundlePromo,
          _bundle_id: bundleId,
          _bundle_identifier: 'true',
          _compare_at_price: this.compareAtCentsString(variantRow),
          _compare_at_price_discount: this.compareDiscountPercentString(variantRow),
          _free_diffuser_tos_aceptance:
            tosAcceptedAt != null && tosAcceptedAt !== '' ? String(tosAcceptedAt) : '',
          ...extraProperties,
        }
      },
      buildBundleId(prefix) {
        return `_bundle_nba_${prefix}_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`
      },

      // ── add to cart ───────────────────────────────────────────────
      // Checks the LIVE cart (not just this page load's local state) for a
      // line already carrying the gift's _promotional_source property —
      // catches the gift already having been added on a prior visit/click,
      // not just within the same session.
      async cartAlreadyHasGift() {
        try {
          const rootPath =
            typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.root
              ? window.Shopify.routes.root
              : '/'
          const res = await fetch(`${rootPath}cart.js`)
          if (!res.ok) return false
          const cart = await res.json()
          return (cart.items || []).some((item) => item.properties && item.properties._promotional_source === 'nba-free-gift')
        } catch (err) {
          console.error('[pdp-swiper-nba] cartAlreadyHasGift error:', err)
          return false
        }
      },
      async addNbaSetToCart() {
        if (!this.termsAccepted || this.addToCartLoading || !this.selectedTeam) return
        this.addToCartLoading = true
        try {
          const tosAt = this.termsAcceptedAt
          const items = []

          const pushPairing = (key, qty) => {
            if (qty <= 0) return
            // Fallback-aware — if the team's own diffuser/oil is out of
            // stock, this adds the configured substitute instead of failing,
            // matching what step 2/3 already showed the user.
            const diffuserVariant = this.resolveDiffuserVariantResolved(key, this.selectedTeam).variant
            const oilVariant = this.resolveOilVariantResolved(key, this.selectedTeam).variant
            if (!diffuserVariant) return
            for (let i = 0; i < qty; i++) {
              const bundleId = this.buildBundleId(`${diffuserVariant.id}_u${i}`)
              items.push({
                id: Number(diffuserVariant.id),
                quantity: 1,
                properties: this.buildBundleLineProperties(diffuserVariant, bundleId, tosAt),
              })
              if (oilVariant) {
                const oilLine = {
                  id: Number(oilVariant.id),
                  quantity: 1,
                  properties: this.buildBundleLineProperties(oilVariant, bundleId, tosAt),
                }
                if (oilVariant.sellingPlanId) {
                  oilLine.selling_plan = Number(oilVariant.sellingPlanId)
                  oilLine.properties._notes = 'Initial Subscription Order'
                }
                items.push(oilLine)
              }
            }
          }
          // Iterates every discovered diffuser option, not fixed roles —
          // works regardless of how many diffuser options this product has.
          // effectiveQty(), not getQty() — a selected Bundle quantity is
          // never its own cart line; it's expanded into one of each real
          // diffuser here, on top of whatever was directly selected.
          this.diffuserOptions.forEach((o) => pushPairing(o.key, this.effectiveQty(o.key)))

          // Exactly one gift line, its own standalone bundleId — it is not
          // 1:1 paired with any single diffuser line (see plan: Bundle
          // Construction / Cart Payload). Only ever added once — if the
          // cart already has a line carrying the gift's _promotional_source
          // (from an earlier add), skip pushing another (no messaging for
          // this yet, just silently not duplicating it).
          const gift = this.resolveGiftVariant()
          const alreadyHasGift = await this.cartAlreadyHasGift()
          if (gift && !alreadyHasGift) {
            const giftBundleId = this.buildBundleId(`gift_${gift.variant.id}`)
            const giftProperties = this.buildBundleLineProperties(gift.variant, giftBundleId, tosAt, {
              _promotional_source: 'nba-free-gift',
            })
            // The flash-sale Shopify Function (aroma360-app) gates its
            // "FREE GIFT W/ NBA PURCHASE" discount on
            // `freeDiffuserSetQuantity = sum of cart lines whose
            // attribute_bundle_promo == "free-diffuser-set"` being >= 1 —
            // but that count never excludes the gift line itself. Every
            // line built through buildBundleLineProperties() carries
            // _bundle_promo by default, so leaving it on the gift let the
            // gift satisfy its OWN precondition standalone (confirmed live:
            // adding only the gift line, with no diffuser in the cart at
            // all, still triggered the 100%-off discount). Since the
            // Function itself isn't something we can edit, the fix has to
            // be here: never let the gift carry _bundle_promo, so the
            // discount can only fire when a real diffuser line is also in
            // the cart. _promotional_source must stay the literal
            // 'nba-free-gift' string — the Function matches on that exact
            // value (line 15 of run.ts), not anything URL-derived.
            delete giftProperties._bundle_promo
            items.push({
              id: Number(gift.variant.id),
              quantity: 1,
              properties: giftProperties,
            })
          }

          if (!items.length) return

          const rootPath =
            typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.root
              ? window.Shopify.routes.root
              : '/'

          const res = await fetch(`${rootPath}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ items }),
          })
          const resData = await res.json().catch(() => ({}))
          if (!res.ok || resData.status === 422) {
            console.error('[pdp-swiper-nba] cart/add error:', resData)
            return
          }

          document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'))
          document.dispatchEvent(new CustomEvent('eurus:cart:redirect'))
        } catch (err) {
          console.error('[pdp-swiper-nba] addNbaSetToCart error:', err)
        } finally {
          this.addToCartLoading = false
        }
      },
    }))
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-swiper-quantity-free-diffusers"] && !Shopify.designMode) return;
  try {
    

  // ── External Swiper initialiser ────────────────────────────────────────────
  // Runs at DOMContentLoaded — before Alpine's init() — so Swiper is always
  // created by this function. Slide changes are communicated to Alpine via a
  // custom event on the section root, which Alpine listens for in init().
  const initQtyPdpSwiper = (root) => {
    if (typeof window.Swiper === 'undefined') return

    // Media swipers (left column on slide 0 and review slide)
    root.querySelectorAll('.pdp-swiper__media-swiper').forEach((mediaEl) => {
      if (mediaEl.swiper) return
      new window.Swiper(mediaEl, {
        nested: true,
        slidesPerView: 1,
        speed: 650,
        breakpoints: { 990: { allowTouchMove: false, simulateTouch: false } },
      })
    })

    // Root Swiper — controls all step slides
    const rootEl = root.querySelector('.pdp-swiper__root')
    if (!rootEl || rootEl.swiper) return
    new window.Swiper(rootEl, {
      slidesPerView: 1,
      speed: 700,
      allowTouchMove: false,
      simulateTouch: false,
      autoHeight: true,
      on: {
        slideChange(sw) {
          root.dispatchEvent(
            new CustomEvent('pdp-swiper-qtyfd:slide-change', {
              bubbles: false,
              detail: { activeIndex: sw.activeIndex },
            })
          )
        },
      },
    })
  }

  const _runQtyPdpSwiperInit = () => {
    document.querySelectorAll('.pdp-swiper-qtyfd').forEach(initQtyPdpSwiper)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', _runQtyPdpSwiperInit)
  } else {
    _runQtyPdpSwiperInit()
  }

  // ── Discount / product-type rule parsers ───────────────────────────────────

  const parseDiscountByProductTypeRules = (raw) => {
    if (!raw || typeof raw !== 'string') return []
    return raw
      .replace(/\r\n/g, '\n')
      .split(/[,\n]+/)
      .map((s) => s.trim())
      .filter(Boolean)
      .map((segment) => {
        const idx = segment.lastIndexOf('/')
        if (idx === -1) return null
        const productType = segment.slice(0, idx).trim()
        const percent = segment.slice(idx + 1).trim()
        if (!productType || !percent) return null
        return { productType, percent: Number(percent) }
      })
      .filter(Boolean)
  }

  const parseQtyAddonProductTypeRules = (raw) => {
    if (!raw || typeof raw !== 'string') return []
    return raw
      .replace(/\r\n/g, '\n')
      .split(/[,\n]+/)
      .map((s) => s.trim())
      .filter(Boolean)
      .map((segment) => {
        const parts = segment.split('|').map((p) => p.trim())
        const match = parts[0]
        const productType = parts[1] || ''
        const collectionFilter = parts[2] || null
        if (!match || !productType) return null
        return { match, productType, collectionFilter }
      })
      .filter(Boolean)
  }

  // Display-only: if the option name contains a known color, show just that color name
  // (e.g. "Silver by Aroma360" -> "Silver"). Falls back to the raw name when no known color
  // is found. Never use for variant lookups — option2 stays the source of truth.
  // Lives on window (not in the Alpine state) so it is defined again whenever the theme
  // editor re-renders this section, even though alpine:init only fires once per page load.
  window.pdpSwatchColorLabel = function (name) {
    const raw = String(name || '')
    const lower = raw.toLowerCase()
    // Multi-word colors are listed before their single-word parts so they match first.
    const colors = [
      'space gray', 'space grey', 'rose gold', 'silver', 'black', 'white', 'gold',
      'gray', 'grey', 'bronze', 'copper', 'champagne', 'blue', 'green', 'red', 'pink'
    ]
    const hit = colors.find(c => lower.includes(c))
    return hit ? hit.replace(/\b\w/g, ch => ch.toUpperCase()) : raw
  }

  // Ship status label for a swatch. A populated variant metafield custom.shipping_date (plain
  // text) shows "Ships M/D" (month and day as plain numbers, e.g. 10/28); otherwise "Ships now".
  // Understands "10/28", "10/28/2026", "2026-10-28", "Oct 28", "October 28th" and "28 October";
  // anything else is shown as-is after "Ships" so a bad value is visible rather than hidden.
  window.pdpSwatchShipLabel = function (shippingDate) {
    const raw = String(shippingDate || '').trim()
    if (!raw) return 'Ships now'
    let m = raw.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/)
    if (m) return 'Ships ' + Number(m[2]) + '/' + Number(m[3])
    m = raw.match(/^(\d{1,2})[\/.-](\d{1,2})(?:[\/.-]\d{2,4})?$/)
    if (m) return 'Ships ' + Number(m[1]) + '/' + Number(m[2])
    const months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec']
    const lower = raw.toLowerCase()
    const monthIdx = months.findIndex(mo => new RegExp('\\b' + mo).test(lower))
    const dayMatch = lower.match(/\b(\d{1,2})(?:st|nd|rd|th)?\b/)
    if (monthIdx !== -1 && dayMatch) return 'Ships ' + (monthIdx + 1) + '/' + Number(dayMatch[1])
    return 'Ships ' + raw
  }

  document.addEventListener('alpine:init', () => {
    Alpine.data('pdpSwiperQuantityState', () => ({

      // ── Variant data ────────────────────────────────────────────────
      productHandle: '',
      variantsById: {},
      addonVariantsById: {},
      defaultByOption1: {},
      addonProductTypeMap: '',
      discountByProductTypeMap: '',
      reviewImageMappings: [],
      productFeaturedImage: '',
      bundleVariantId: '',
      bundleOnlyMode: false,
      directAddOption1: '',
      bundleVariant: null,
      bundleSlotsByType: {},

      // ── Step 1 quantity state ────────────────────────────────────────
      // { [option1Key]: 0..3 }
      quantityByOption1: {},

      // ── Step 1 slot color state ──────────────────────────────────────
      // { [option1Key]: [variantId, variantId, ...] }  length === qty
      slotColorByOption1: {},

      // ── Swatch data (baked from Liquid) ──────────────────────────────
      // { [option1Key]: [{ variantId, option2, swatchBg }, ...] }
      swatchesByOption1: {},

      // Ordered list of option1 keys (Liquid render order)
      option1Order: [],

      // ── Bundle list (built on NEXT from Step 1) ──────────────────────
      bundles: [],

      // ── Addon type groups (derived from bundles, drives addon slides) ─
      // [{ productType, count, bundles[], label }]
      addonTypeGroups: [],

      // ── Scent qty per type: { [productType]: { [addonVariantId]: qty } }
      addonQtyByType: {},

      // ── Swiper tracking ──────────────────────────────────────────────
      currentSwiperIndex: 0,
      stepTextTemplate: '',
      hideReviewStep: false,

      // ── Shared UI state ─────────────────────────────────────────────
      termsAccepted: false,
      termsAcceptedAt: null,
      termsModalOpen: false,
      addToCartLoading: false,
      popupOpen: false,
      popupVariant: null,
      popupOption1: null,
      popupSectionsCache: {},
      popupSectionsHtml: '',
      addonPopupOpen: false,
      addonPopupVariant: null,
      addonPopupSectionsCache: {},
      addonPopupSectionsHtml: '',
      allScentsModalOpen: false,
      allScentsSearch: '',
      allScentsInspiredByOpen: true,
      allScentsDrawerOpen: false,
      selectedInspiredByFilters: [],
      _allScentsProductType: null,
      _allScentsCollectionFilter: null,
      pdpSwiperRootEl: null,

      // ── Init ────────────────────────────────────────────────────────
      init() {
        this.pdpSwiperRootEl =
          this.$el && this.$el.closest ? this.$el.closest('.pdp-swiper-qtyfd') : null

        const jsonEl = this.$el.querySelector('[data-pdp-variant-state]')
        if (!jsonEl) return

        let state = null
        try {
          state = JSON.parse(jsonEl.textContent || '{}')
        } catch (e) {
          state = null
        }
        if (!state) return

        // Populate variantsById
        ;(state.variants || []).forEach((v) => {
          this.variantsById[String(v.id)] = v
        })

        // Populate addonVariantsById
        this.addonVariantsById = {}
        ;(state.addonVariants || []).forEach((row) => {
          if (row && row.id != null) {
            this.addonVariantsById[String(row.id)] = row
          }
        })

        this.defaultByOption1 = { ...(state.defaults || {}) }
        this.addonProductTypeMap =
          typeof state.addonProductTypeMap === 'string' ? state.addonProductTypeMap : ''
        this.discountByProductTypeMap =
          typeof state.discountByProductTypeMap === 'string'
            ? state.discountByProductTypeMap
            : ''
        this.reviewImageMappings = Array.isArray(state.reviewImageMappings)
          ? state.reviewImageMappings
          : []
        this.productFeaturedImage = state.productFeaturedImage || ''
        this.productHandle = state.productHandle || ''

        this.bundleVariantId = state.bundleVariantId || ''
        this.bundleOnlyMode = !!state.bundleOnlyMode
        this.directAddOption1 = typeof state.directAddOption1 === 'string' ? state.directAddOption1 : ''
        this.hideReviewStep = !!state.hideReviewStep
        this.bundleVariant = this.bundleVariantId
          ? (Object.values(this.variantsById).find((v) => v.option1 === this.bundleVariantId) || null)
          : null

        // Swatch data per option1 group
        this.swatchesByOption1 =
          state.swatchesByOption1 && typeof state.swatchesByOption1 === 'object'
            ? state.swatchesByOption1
            : {}

        // Ordered option1 keys (Liquid render order for bundle building)
        this.option1Order = Array.isArray(state.option1Order) ? state.option1Order : []

        // Initialize quantityByOption1: all option1 groups start at 0
        const qtyInit = {}
        Object.keys(this.defaultByOption1).forEach((key) => {
          qtyInit[key] = 0
        })
        this.quantityByOption1 = qtyInit
        this.slotColorByOption1 = {}

        // Bundle-only mode: the bundle card is the only purchasable item on Step 1,
        // so pre-select 1 unit (and its default color per component type) instead of
        // landing on an empty page with nothing selected and NEXT disabled.
        if (this.bundleOnlyMode && this.bundleVariant) {
          this.quantityByOption1 = { ...this.quantityByOption1, __bundle__: 1 }
          const typeOrder = this.getBundleTypeOrder()
          const initialSlots = {}
          typeOrder.forEach((t) => {
            initialSlots[t.productType] = [t.swatches.length ? t.swatches[0].variantId : null]
          })
          this.bundleSlotsByType = initialSlots
        }

        // Step text template for addon slides ("Step {step_number}: ...")
        this.stepTextTemplate = typeof state.stepTextTemplate === 'string'
          ? state.stepTextTemplate
          : 'Step {step_number}: Choose your scent.'

        // Listen for slide changes dispatched by the external Swiper init
        const root = this.pdpSwiperRootEl
        if (root) {
          root.addEventListener('pdp-swiper-qtyfd:slide-change', (e) => {
            this.currentSwiperIndex = (e.detail && e.detail.activeIndex != null)
              ? e.detail.activeIndex
              : 0
          })
        }
      },

      // ── Quantity helpers ─────────────────────────────────────────────
      getQty(option1Key) {
        return Number(this.quantityByOption1[option1Key] || 0)
      },

      incrementQty(option1Key) {
        const current = this.getQty(option1Key)
        const weight = option1Key === '__bundle__' ? 3 : 1
        if (this.totalWeightedUnits() + weight > 6) return
        this.quantityByOption1 = { ...this.quantityByOption1, [option1Key]: current + 1 }
        if (option1Key === '__bundle__') {
          const typeOrder = this.getBundleTypeOrder()
          const newSlots = { ...this.bundleSlotsByType }
          typeOrder.forEach((t) => {
            const existing = [...(newSlots[t.productType] || [])]
            existing.push(t.swatches.length ? t.swatches[0].variantId : null)
            newSlots[t.productType] = existing
          })
          this.bundleSlotsByType = newSlots
        } else {
          const existing = [...(this.slotColorByOption1[option1Key] || [])]
          existing.push(this.firstSwatchVariantIdForOption1(option1Key))
          this.slotColorByOption1 = { ...this.slotColorByOption1, [option1Key]: existing }
        }
      },

      decrementQty(option1Key) {
        const current = this.getQty(option1Key)
        if (current <= 0) return
        this.quantityByOption1 = { ...this.quantityByOption1, [option1Key]: current - 1 }
        if (option1Key === '__bundle__') {
          const newSlots = { ...this.bundleSlotsByType }
          Object.keys(newSlots).forEach((pt) => {
            newSlots[pt] = newSlots[pt].slice(0, -1)
          })
          this.bundleSlotsByType = newSlots
        } else {
          const existing = [...(this.slotColorByOption1[option1Key] || [])]
          existing.pop()
          this.slotColorByOption1 = { ...this.slotColorByOption1, [option1Key]: existing }
        }
      },

      totalUnits() {
        return Object.values(this.quantityByOption1).reduce(
          (sum, q) => sum + (Number(q) || 0),
          0
        )
      },

      totalWeightedUnits() {
        const bundleQty = this.getQty('__bundle__')
        const regularQty = Object.entries(this.quantityByOption1)
          .filter(([key]) => key !== '__bundle__')
          .reduce((sum, [, q]) => sum + (Number(q) || 0), 0)
        return regularQty + bundleQty * 3
      },

      canAdvanceFromStep1() {
        if (this.totalUnits() === 0) return false
        const bundleQty = this.getQty('__bundle__')
        if (bundleQty > 0) {
          const typeOrder = this.getBundleTypeOrder()
          for (let ti = 0; ti < typeOrder.length; ti++) {
            const slots = this.bundleSlotsByType[typeOrder[ti].productType] || []
            for (let i = 0; i < bundleQty; i++) {
              if (!slots[i]) return false
            }
          }
        }
        return true
      },

      isDirectAddSelection() {
        const key = this.directAddOption1
        if (!key || this.getQty(key) <= 0) return false
        return Object.entries(this.quantityByOption1).every(([option1Key, qty]) => {
          if (option1Key === key) return true
          return Number(qty) <= 0
        })
      },

      isStep1DirectAdd() {
        return this.currentSwiperIndex === 0 && this.isDirectAddSelection()
      },

      onStep1PrimaryClick() {
        if (this.isDirectAddSelection()) {
          this.addDirectOption1ToCart()
        } else {
          this.buildBundles()
        }
      },

      async addDirectOption1ToCart() {
        const option1Key = this.directAddOption1
        if (!this.isDirectAddSelection() || this.addToCartLoading) return
        this.addToCartLoading = true
        try {
          const qty = this.getQty(option1Key)
          const slots = this.slotColorByOption1[option1Key] || []
          const counts = {}
          for (let i = 0; i < qty; i++) {
            const variantId = slots[i] != null
              ? slots[i]
              : this.firstSwatchVariantIdForOption1(option1Key)
            if (!variantId) continue
            const id = String(variantId)
            counts[id] = (counts[id] || 0) + 1
          }
          const items = Object.keys(counts).map((id) => ({
            id: Number(id),
            quantity: counts[id],
          }))
          if (!items.length) return

          const rootPath =
            typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.root
              ? window.Shopify.routes.root
              : '/'

          const res = await fetch(`${rootPath}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ items }),
          })
          const data = await res.json().catch(() => ({}))
          if (!res.ok || data.status === 422) {
            console.error('[pdp-swiper-qtyfd] direct cart/add error:', data)
          }
        } catch (err) {
          console.error('[pdp-swiper-qtyfd] addDirectOption1ToCart error:', err)
        } finally {
          this.addToCartLoading = false
        }
      },

      // ── Swatch / slot helpers ────────────────────────────────────────
      getSwatchesForOption1(option1Key) {
        const swatches = this.swatchesByOption1[option1Key] || []
        // Every color option containing PINNED_COLOR (case-insensitive) gets pinned to
        // the front of the row, keeping their natural relative order, so the first
        // available matching variant is the first/default one. e.g. "Silver by Aroma360",
        // "Matte Silver", etc. Change this keyword (e.g. 'black') to pin a different color.
        const PINNED_COLOR = 'silver'
        const isPinned = sw => (sw.option2 || '').toLowerCase().includes(PINNED_COLOR)
        if (swatches.some(isPinned)) {
          return [...swatches.filter(isPinned), ...swatches.filter(sw => !isPinned(sw))]
        }
        return swatches
      },

      firstSwatchVariantIdForOption1(option1Key) {
        const swatches = this.getSwatchesForOption1(option1Key)
        if (swatches.length) return swatches[0].variantId
        // Fallback to the defaults map if no swatch data (single-option products)
        return this.defaultByOption1[option1Key] || null
      },

      getSlotVariantId(option1Key, slotIndex) {
        const slots = this.slotColorByOption1[option1Key] || []
        return slots[slotIndex] != null ? slots[slotIndex] : null
      },

      // ── Bundle slot helpers ──────────────────────────────────────────
      getBundleTypeOrder() {
        const rules = parseQtyAddonProductTypeRules(this.addonProductTypeMap)
        const bundleOption1 = this.bundleVariant ? (this.bundleVariant.option1 || '') : ''
        const seen = new Set()
        return this.option1Order
          .filter((o1) => !bundleOption1 || o1 !== bundleOption1)
          .map((o1) => {
            for (let i = 0; i < rules.length; i++) {
              if (o1.indexOf(rules[i].match) !== -1) {
                const rule = rules[i]
                const compositeKey = rule.collectionFilter
                  ? rule.productType + '::' + rule.collectionFilter
                  : rule.productType
                // Use getSwatchesForOption1 (not the raw map) so the pinned-color
                // pin-to-front rule also applies inside bundle slot pickers.
                return { option1: o1, productType: compositeKey, swatches: this.getSwatchesForOption1(o1) }
              }
            }
            return null
          })
          .filter(Boolean)
          .filter((t) => {
            if (seen.has(t.productType)) return false
            seen.add(t.productType)
            return true
          })
      },

      getBundleUnitCount() {
        return this.getQty('__bundle__')
      },

      isBundleSlotSelected(productType, unitIdx, variantId) {
        const slots = this.bundleSlotsByType[productType] || []
        return slots[unitIdx] === variantId
      },

      setBundleSlotColor(productType, unitIdx, variantId) {
        const slots = [...(this.bundleSlotsByType[productType] || [])]
        slots[unitIdx] = variantId
        this.bundleSlotsByType = { ...this.bundleSlotsByType, [productType]: slots }
      },

      getBundleSlotColorName(productType, unitIdx) {
        const slots = this.bundleSlotsByType[productType] || []
        const variantId = slots[unitIdx]
        if (!variantId) return ''
        const v = this.variantsById[String(variantId)]
        return v ? (v.option2 || '') : ''
      },

      setSlotColor(option1Key, slotIndex, variantId) {
        const slots = [...(this.slotColorByOption1[option1Key] || [])]
        slots[slotIndex] = variantId
        this.slotColorByOption1 = { ...this.slotColorByOption1, [option1Key]: slots }
      },

      isSlotSwatchSelected(option1Key, slotIndex, variantId) {
        const current = this.getSlotVariantId(option1Key, slotIndex)
        return Number(current) === Number(variantId)
      },
      getSlotColorName(option1Key, slotIndex) {
        const variantId = this.getSlotVariantId(option1Key, slotIndex)
        const v = variantId ? this.variantsById[String(variantId)] : null
        return v ? (v.option2 || '') : ''
      },

      // ── Build flat bundle list ───────────────────────────────────────
      // Called when user clicks NEXT on Step 1.
      // Produces: [{ bundleId, variantId, option1, option2, productType }, ...]
      buildBundles() {
        const order = this.option1Order.length
          ? this.option1Order
          : Object.keys(this.quantityByOption1)

        const bundles = []
        order.forEach((option1Key) => {
          const qty = this.getQty(option1Key)
          const slots = this.slotColorByOption1[option1Key] || []
          for (let i = 0; i < qty; i++) {
            const variantId =
              slots[i] != null
                ? slots[i]
                : this.firstSwatchVariantIdForOption1(option1Key)
            if (!variantId) continue
            const variant = this.getVariantById(variantId)
            if (!variant) continue
            const bundle = {
              bundleId: `_bundle_qty_${variantId}_s${i}_${Date.now()}_${Math.random()
                .toString(36)
                .slice(2, 7)}`,
              variantId: Number(variantId),
              option1: variant.option1 || option1Key,
              option2: variant.option2 || '',
            }
            bundle.productType = this.expectedAddonProductTypeForBundle(bundle)
            bundles.push(bundle)
          }
        })
        // Bundle card entries — one per type per unit
        const bundleQty = this.getQty('__bundle__')
        if (bundleQty > 0 && this.bundleVariant) {
          const typeOrder = this.getBundleTypeOrder()
          for (let unitIdx = 0; unitIdx < bundleQty; unitIdx++) {
            typeOrder.forEach((t) => {
              const slotVarId = (this.bundleSlotsByType[t.productType] || [])[unitIdx]
                || (t.swatches.length ? t.swatches[0].variantId : null)
              if (!slotVarId) return
              const variant = this.getVariantById(slotVarId)
              if (!variant) return
              const bEntry = {
                bundleId: `_bundle_qty_${slotVarId}_u${unitIdx}_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
                variantId: Number(slotVarId),
                option1: variant.option1 || t.option1,
                option2: variant.option2 || '',
                isBundle: true,
                bundleUnitIdx: unitIdx,
              }
              bEntry.productType = this.expectedAddonProductTypeForBundle(bEntry)
              bundles.push(bEntry)
            })
          }
        }

        this.bundles = bundles
        const newGroups = this.buildAddonTypeGroups(bundles)
        this.addonTypeGroups = newGroups

        // Preserve existing scent selections — clip to new limits, drop removed types
        const preserved = {}
        newGroups.forEach((group) => {
          const existing = this.addonQtyByType[group.productType] || {}
          const limit = group.count
          let total = 0
          const clipped = {}
          Object.entries(existing).forEach(([variantId, qty]) => {
            const q = Number(qty) || 0
            if (q <= 0) return
            const take = Math.min(q, limit - total)
            if (take > 0) { clipped[variantId] = take; total += take }
          })
          preserved[group.productType] = clipped
        })
        this.addonQtyByType = preserved

        // After Alpine renders the new x-for slides, update Swiper and advance to slide 1
        this.$nextTick(() => {
          const root = this.pdpSwiperRootEl
          if (!root) return
          const rootEl = root.querySelector('.pdp-swiper__root')
          if (!rootEl || !rootEl.swiper) return
          rootEl.swiper.update()
          rootEl.swiper.slideTo(1, 700)
          if (typeof window !== 'undefined' && window.matchMedia &&
              window.matchMedia('(max-width: 989px)').matches) {
            window.scrollTo({ top: 0, behavior: 'smooth' })
          }
        })
      },

      // ── Variant lookup helpers ───────────────────────────────────────
      getVariantById(id) {
        if (!id) return null
        return this.variantsById[String(id)] || null
      },

      variantIsAvailable(v) {
        if (!v) return false
        return v.available !== false
      },

      // ── Image URL helper ─────────────────────────────────────────────
      imageUrlWithWidth(url, width) {
        const src = url != null ? String(url).trim() : ''
        const w = Number(width)
        if (!src) return ''
        if (!w || Number.isNaN(w) || w <= 0) return src
        if (src.includes(' width=')) return src
        if (/[?&]width=\d+/.test(src)) {
          return src.replace(/([?&]width=)\d+/, `$1${w}`)
        }
        const sep = src.includes('?') ? '&' : '?'
        return `${src}${sep}width=${w}`
      },

      // ── Card image helpers (used by aside snippet) ───────────────────
      getCardImageForOption1(option1Key) {
        // Returns the default variant's image for this option1 group
        const defaultId = this.firstSwatchVariantIdForOption1(option1Key)
        const v = this.getVariantById(defaultId)
        return v && v.image ? this.imageUrlWithWidth(v.image, 248) : ''
      },

      // ── Money formatters ─────────────────────────────────────────────
      formatPdpMoney(cents) {
        const n = Number(cents)
        if (cents == null || cents === '' || Number.isNaN(n)) return ''
        if (typeof window.formatMoney === 'function') {
          return window.formatMoney(n)
        }
        return String(n)
      },

      // ── Terms modal ──────────────────────────────────────────────────
      onTermsAcceptanceChange() {
        this.termsAcceptedAt = this.termsAccepted ? new Date().toISOString() : null
      },

      openTermsModal() {
        this.termsModalOpen = true
        document.body.style.overflow = 'hidden'
      },

      closeTermsModal() {
        this.termsModalOpen = false
        document.body.style.overflow = ''
      },

      // ── Addon product type resolution ────────────────────────────────
      expectedAddonProductTypeForBundle(bundle) {
        if (!bundle || !bundle.option1) return null
        const title = String(bundle.option1)
        const rules = parseQtyAddonProductTypeRules(this.addonProductTypeMap)
        for (let i = 0; i < rules.length; i++) {
          if (title.indexOf(rules[i].match) !== -1) {
            const rule = rules[i]
            return rule.collectionFilter ? rule.productType + '::' + rule.collectionFilter : rule.productType
          }
        }
        return null
      },

      // ── Swiper navigation helpers ────────────────────────────────────
      slideTo(idx) {
        const root = this.pdpSwiperRootEl
        if (!root) return
        const rootEl = root.querySelector('.pdp-swiper__root')
        if (!rootEl || !rootEl.swiper) return
        rootEl.swiper.slideTo(idx, 700)
      },

      checkoutSlideIndex() {
        if (this.hideReviewStep) return this.addonTypeGroups.length
        return this.addonTypeGroups.length + 1
      },

      isOnCheckoutStep() {
        return this.currentSwiperIndex === this.checkoutSlideIndex() && this.addonTypeGroups.length > 0
      },

      isLastAddonGroup(groupIdx) {
        return Number(groupIdx) === this.addonTypeGroups.length - 1
      },

      advanceAddonStep() {
        if (this.hideReviewStep && this.isOnCheckoutStep()) return
        const root = this.pdpSwiperRootEl
        if (!root) return
        const rootEl = root.querySelector('.pdp-swiper__root')
        if (!rootEl || !rootEl.swiper) return
        rootEl.swiper.slideNext()
        if (typeof window !== 'undefined' && window.matchMedia &&
            window.matchMedia('(max-width: 989px)').matches) {
          window.scrollTo({ top: 0, behavior: 'smooth' })
        }
      },

      // ── Mobile CTA helpers ───────────────────────────────────────────
      mobileNextDisabled() {
        if (this.isOnCheckoutStep()) {
          const group = this.addonTypeGroups[this.addonTypeGroups.length - 1]
          if (this.hideReviewStep) {
            return !this.canAdvanceFromTypeStep(group) || !this.termsAccepted || this.addToCartLoading
          }
          return !this.termsAccepted || this.addToCartLoading
        }
        if (this.currentSwiperIndex === 0) {
          return !this.canAdvanceFromStep1() || this.addToCartLoading
        }
        const group = this.addonTypeGroups[this.currentSwiperIndex - 1]
        if (!group) return true
        return !this.canAdvanceFromTypeStep(group)
      },

      mobileNextClick() {
        if (this.isOnCheckoutStep()) {
          this.addReviewQtySetToCart()
        } else if (this.currentSwiperIndex === 0) {
          this.onStep1PrimaryClick()
        } else {
          this.advanceAddonStep()
        }
      },

      // ── Addon type group builder ─────────────────────────────────────
      buildAddonTypeGroups(bundles) {
        const rules = parseQtyAddonProductTypeRules(this.addonProductTypeMap)
        const seen = []
        const map = {}
        bundles.forEach((bundle) => {
          const compositeKey = bundle.productType || '__none__'
          if (!map[compositeKey]) {
            const o1 = bundle.option1 || ''
            let realProductType = compositeKey
            let collectionFilter = null
            for (let i = 0; i < rules.length; i++) {
              if (o1.indexOf(rules[i].match) !== -1) {
                realProductType = rules[i].productType
                collectionFilter = rules[i].collectionFilter || null
                break
              }
            }
            map[compositeKey] = { productType: compositeKey, realProductType, count: 0, bundles: [], collectionFilter }
            seen.push(compositeKey)
          }
          map[compositeKey].count++
          map[compositeKey].bundles.push(bundle)
        })
        return seen.map((key, idx) => ({
          ...map[key],
          label: 'Oils ' + (idx + 1),
        }))
      },

      // ── Addon step helpers ───────────────────────────────────────────
      getAddonRowsForGroup(group) {
        const productType = group ? (group.realProductType || group.productType) : null
        const collectionFilter = group ? (group.collectionFilter || null) : null
        const rows = Object.values(this.addonVariantsById).filter((row) => row && row.available !== false)
        const filtered = (!productType || productType === '__none__')
          ? rows
          : rows.filter((row) => {
              if (row.productType !== productType) return false
              if (collectionFilter && row.collectionName !== collectionFilter) return false
              return true
            })
        return filtered.slice(0, 5)
      },

      getAddonQty(productType, variantId) {
        const typeMap = this.addonQtyByType[productType] || {}
        return typeMap[String(variantId)] || 0
      },

      incrementAddonQty(productType, variantId) {
        const limit = this.addonTypeLimit(productType)
        if (this.addonTypeTotal(productType) >= limit) return
        const typeMap = { ...(this.addonQtyByType[productType] || {}) }
        typeMap[String(variantId)] = (typeMap[String(variantId)] || 0) + 1
        this.addonQtyByType = { ...this.addonQtyByType, [productType]: typeMap }
      },

      decrementAddonQty(productType, variantId) {
        const typeMap = { ...(this.addonQtyByType[productType] || {}) }
        const current = typeMap[String(variantId)] || 0
        if (current <= 0) return
        typeMap[String(variantId)] = current - 1
        this.addonQtyByType = { ...this.addonQtyByType, [productType]: typeMap }
      },

      addonTypeTotal(productType) {
        const typeMap = this.addonQtyByType[productType] || {}
        return Object.values(typeMap).reduce((sum, q) => sum + (Number(q) || 0), 0)
      },

      addonTypeLimit(productType) {
        const group = this.addonTypeGroups.find((g) => g.productType === productType)
        return group ? group.count : 0
      },

      canAdvanceFromTypeStep(group) {
        if (!group) return false
        return this.addonTypeTotal(group.productType) === this.addonTypeLimit(group.productType)
      },

      addonTypeSubheadline(group) {
        if (!group) return ''
        const n = group.count
        const unit = n === 1 ? 'Oil' : 'Oils'
        const name = group.bundles[0] ? (group.bundles[0].option1 || '') : ''
        return `Choose at least <strong>${n} ${unit}</strong> for the ${name}`
      },

      // ── resolvedPairings: expand addonQtyByType into per-bundle pairs ─
      resolvedPairings() {
        const pairs = []
        this.addonTypeGroups.forEach((group) => {
          const typeMap = this.addonQtyByType[group.productType] || {}
          // Expand qty map into flat ordered list of addonVariantIds
          const scentList = []
          Object.entries(typeMap).forEach(([variantId, qty]) => {
            for (let i = 0; i < qty; i++) scentList.push(Number(variantId))
          })
          // Zip sequentially with bundles
          group.bundles.forEach((bundle, idx) => {
            pairs.push({ bundle, addonVariantId: scentList[idx] || null })
          })
        })
        return pairs
      },

      getBundleDiffuserImage(bundle, width) {
        if (!bundle) return ''
        const variant = this.getVariantById(bundle.variantId)
        if (!variant || !variant.image) return ''
        return this.imageUrlWithWidth(variant.image, width || 2000)
      },

      formatStepText(stepNumber) {
        const tmpl = this.stepTextTemplate || 'Step {step_number}: Choose your scent.'
        return tmpl.replace('{step_number}', String(stepNumber))
      },

      // ── Addon pricing ────────────────────────────────────────────────
      mappedDiscountPercentForType(productType) {
        const pt = productType != null ? String(productType).trim() : ''
        if (!pt) return null
        const rules = parseDiscountByProductTypeRules(this.discountByProductTypeMap)
        for (let i = 0; i < rules.length; i++) {
          if (rules[i].productType === pt) return Number(rules[i].percent)
        }
        return null
      },

      normalizedPricing(v) {
        if (!v) return { price: 0, compareAtPrice: 0 }
        const originalPrice = Number(v.price || 0)
        const originalCompare = Number(v.compareAtPrice || 0)
        const mappedPct = this.mappedDiscountPercentForType(v.productType)
        if (mappedPct == null) return { price: originalPrice, compareAtPrice: originalCompare }
        const hasOriginalCompare = originalCompare > originalPrice && originalCompare > 0
        if (hasOriginalCompare) {
          const currentPct = ((originalCompare - originalPrice) / originalCompare) * 100
          if (currentPct > mappedPct) return { price: originalPrice, compareAtPrice: originalCompare }
        }
        const base = hasOriginalCompare ? originalCompare : originalPrice
        if (base <= 0) return { price: originalPrice, compareAtPrice: originalCompare }
        const discounted = Math.max(0, Math.round((base * (100 - mappedPct)) / 100))
        if (discounted >= base) return { price: originalPrice, compareAtPrice: originalCompare }
        return { price: discounted, compareAtPrice: base }
      },

      addonRowById(variantId) {
        return this.addonVariantsById[String(variantId)] || null
      },

      normalizedAddonRowById(id) {
        const row = this.addonRowById(id)
        if (!row) return null
        return this.normalizedPricing(row)
      },


      addonHasCompare(variantId) {
        const p = this.normalizedAddonRowById(variantId)
        if (!p) return false
        return Number(p.compareAtPrice) > Number(p.price)
      },

      addonDisplayCompare(variantId) {
        const p = this.normalizedAddonRowById(variantId)
        if (!p) return ''
        return this.formatPdpMoney(p.compareAtPrice)
      },

      addonDisplayPrice(variantId) {
        const p = this.normalizedAddonRowById(variantId)
        if (!p) return ''
        return this.formatPdpMoney(p.price)
      },

      addonSavePercent(variantId) {
        const p = this.normalizedAddonRowById(variantId)
        if (!p) return ''
        const compareAt = Number(p.compareAtPrice || 0)
        const price = Number(p.price || 0)
        if (!compareAt || compareAt <= 0 || compareAt <= price) return ''
        return String(Math.round(((compareAt - price) / compareAt) * 100))
      },

      // ── Feature metadata (How it works / Subscription perks / Why Aroma360) ──
      getFeatureMetadata() {
        // Use the first option1 group with qty > 0; fallback to first variant overall
        const activeOption1 = this.option1Order.find(
          (key) => this.getQty(key) > 0
        )
        const variantId = activeOption1
          ? this.defaultByOption1[activeOption1]
          : Object.values(this.defaultByOption1)[0]
        const v = this.getVariantById(variantId)
        if (v && v.featureMetadata && v.featureMetadata.length) return v.featureMetadata
        // Fallback: any variant for the same option1 that has metadata
        const option1 = v ? v.option1 : null
        if (option1) {
          const match = Object.values(this.variantsById).find(
            (vv) => vv.option1 === option1 && vv.featureMetadata && vv.featureMetadata.length
          )
          if (match) return match.featureMetadata
        }
        return []
      },

      // ── Addon scent data ─────────────────────────────────────────────
      getAddonScentProfile(variantId) {
        const row = this.addonRowById(variantId)
        if (!row) return []
        return Array.isArray(row.scentProfile) ? row.scentProfile : []
      },

      getAddonScentMoods(variantId) {
        const row = this.addonRowById(variantId)
        if (!row) return []
        return Array.isArray(row.scentMoods) ? row.scentMoods : []
      },

      // ── Review step helpers ──────────────────────────────────────────

      reviewAddonRowForBundle(bundle) {
        if (!bundle) return null
        const pair = this.resolvedPairings().find(
          (p) => p.bundle.bundleId === bundle.bundleId
        )
        if (!pair || !pair.addonVariantId) return null
        return this.addonRowById(pair.addonVariantId) || null
      },

      reviewSumPriceCents() {
        return this.resolvedPairings().reduce((total, pair) => {
          if (!pair.addonVariantId) return total
          const row = this.normalizedAddonRowById(pair.addonVariantId)
          return total + (row ? Number(row.price) || 0 : 0)
        }, 0)
      },

      reviewSumCompareAtCents() {
        return this.resolvedPairings().reduce((total, pair) => {
          if (!pair.addonVariantId) return total
          const row = this.normalizedAddonRowById(pair.addonVariantId)
          return total + (row ? Number(row.compareAtPrice) || Number(row.price) || 0 : 0)
        }, 0)
      },

      formatPdpMoneyOrFree(cents) {
        const n = Number(cents)
        if (!n || n <= 0) return 'FREE'
        return this.formatPdpMoney(n)
      },

      // ── Cart helpers (mirror existing section) ───────────────────────

      buildBundleId(mainVariantId, addonVariantId) {
        return `_bundle_${mainVariantId}_${addonVariantId}_plan_30_ts_${Date.now()}`
      },

      compareAtCentsString(variantRow) {
        if (!variantRow) return '0'
        const c = Number(variantRow.compareAtPrice || 0)
        if (!c || c <= 0) return '0'
        return String(Math.round(c))
      },

      compareDiscountPercentString(variantRow) {
        if (!variantRow) return '0'
        const cap = Number(variantRow.compareAtPrice || 0)
        const price = Number(variantRow.price || 0)
        if (!cap || cap <= 0 || cap <= price) return '0'
        const pct = Math.round(((cap - price) / cap) * 100)
        return String(Math.max(0, pct))
      },

      buildBundleLineProperties(variantRow, bundleId, tosAcceptedAt) {
        return {
          _bundle_promo: 'free-diffuser-set',
          _bundle_id: bundleId,
          _bundle_identifier: 'true',
          _compare_at_price: this.compareAtCentsString(variantRow),
          _compare_at_price_discount: this.compareDiscountPercentString(variantRow),
          _free_diffuser_tos_aceptance:
            tosAcceptedAt != null && tosAcceptedAt !== '' ? String(tosAcceptedAt) : '',
        }
      },

      // ── Add to cart ──────────────────────────────────────────────────

      async addReviewQtySetToCart() {
        if (!this.termsAccepted || this.addToCartLoading) return
        this.addToCartLoading = true
        try {
          const tosAt = this.termsAcceptedAt
          const items = []

          for (const pair of this.resolvedPairings()) {
            const bundle = pair.bundle
            const mainVariant = this.getVariantById(bundle.variantId)
            if (!mainVariant) continue

            const addonRow = pair.addonVariantId ? this.addonRowById(pair.addonVariantId) : null
            const addonEligible = addonRow && addonRow.available !== false
            const resolvedAddonId = addonEligible ? Number(pair.addonVariantId) : 0

            const bundleId = bundle.bundleId || this.buildBundleId(Number(bundle.variantId), resolvedAddonId)

            // Diffuser line item
            items.push({
              id: Number(bundle.variantId),
              quantity: 1,
              properties: this.buildBundleLineProperties(mainVariant, bundleId, tosAt),
            })

            // Scent line item
            if (addonEligible) {
              const addonLine = {
                id: resolvedAddonId,
                quantity: 1,
                properties: this.buildBundleLineProperties(addonRow, bundleId, tosAt),
              }
              const sp = addonRow.sellingPlanId
              if (sp != null && sp !== '') {
                addonLine.selling_plan = Number(sp)
                addonLine.properties._notes = "Initial Subscription Order";
              }
              items.push(addonLine)
            }
          }

          if (!items.length) return

          const rootPath =
            typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.root
              ? window.Shopify.routes.root
              : '/'

          const res = await fetch(`${rootPath}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ items }),
          })
          const data = await res.json().catch(() => ({}))
          if (!res.ok || data.status === 422) {
            console.error('[pdp-swiper-qtyfd] cart/add error:', data)
            return
          }

        } catch (err) {
          console.error('[pdp-swiper-qtyfd] addReviewQtySetToCart error:', err)
        } finally {
          this.addToCartLoading = false
        }
      },

      // ── Popup (Learn More) ──────────────────────────────────────────
      openVariantPopup(option1Key) {
        this.popupOption1 = option1Key
        const id = this.defaultByOption1[option1Key]
        const v = id ? this.variantsById[String(id)] : null
        if (!v) {
          const fallback = Object.values(this.variantsById).find((vv) => vv.option1 === option1Key)
          if (!fallback) return
          this.popupVariant = fallback
        } else {
          this.popupVariant = v
        }
        this.popupOpen = true
        this.popupSectionsHtml = ''
        this.$nextTick(() => {
          this.fetchPopupSections(this.popupLinkedProductHandle())
          this.fetchMainProductOkendoRating()
        })
      },
      closePopup() {
        this.popupOpen = false
        this.popupVariant = null
        this.popupOption1 = null
      },
      popupAccordionItems() {
        const option1 = this.popupOption1
        const all = Object.values(this.variantsById)
        const match = all.find((v) => v.option1 === option1 && v.accordionItems?.length)
        return match?.accordionItems || this.popupVariant?.accordionItems || []
      },
      popupLinkedProductHandle() {
        const items = this.popupAccordionItems()
        const item = items.find((i) => i.linkedProductHandle)
        if (item?.linkedProductHandle) return item.linkedProductHandle
        if (this.popupVariant?.popupProductHandle) return this.popupVariant.popupProductHandle
        return null
      },
      _initPopupSectionAnimations() {
        const container = this.$refs.popupSections
        if (!container) return
        const store = Alpine.store('xScrollPromotion')
        if (store) {
          const bannerEl = container.querySelector('.el_animate')?.closest('[class*="section-"]')
          if (bannerEl) { store.load(bannerEl) }
        }
        container.querySelectorAll('.el_animate').forEach((el) => {
          el.classList.add('animate-scroll-banner')
        })
        requestAnimationFrame(() => {
          container.querySelectorAll('marquee-text').forEach((el) => {
            const w = el.getBoundingClientRect().width
            if (!w) return
            const speed = parseInt(el.getAttribute('scrolling-speed') || 5)
            const span = el.querySelector('span')
            if (!span) return
            const slowFactor = 1 + (Math.min(1600, w) - 375) / (1600 - 375)
            const duration = (speed * slowFactor * span.clientWidth / w).toFixed(3)
            el.style.setProperty('--marquee-animation-duration', `${duration}s`)
          })
        })
      },
      async fetchPopupSections(handle) {
        if (!handle) return
        if (this.popupSectionsCache[handle] !== undefined) {
          this.popupSectionsHtml = this.popupSectionsCache[handle]
          await this.$nextTick()
          this._initPopupSectionAnimations()
          return
        }
        const items = this.popupAccordionItems()
        const sourceItem = items.find((i) => i.linkedProductHandle === handle)
        let sectionIds = [sourceItem?.popupSection1, sourceItem?.popupSection2].filter(Boolean)
        if (sectionIds.length === 0) {
          const sectionMap = {
            'studio-scent-diffuser': ['scrolling_text_v2_r7QEbL', 'media_with_text_mjPcmV', 'multi_column_HTQGbC', 'media_with_text_GWpp88'],
            'chauffeur-car-diffuser': ['scrolling_text_v2_r7QEbL']
          }
          sectionIds = sectionMap[handle] || (this.popupVariant?.productType === 'Oil' ? ['scrolling_text_v2_r7QEbL'] : [])
        }
        const ratingId = 'pdp-popup-okendo-rating'
        try {
          const res = await fetch(`${window.location.origin}/products/${handle}`)
          const html = await res.text()
          const parser = new DOMParser()
          const doc = parser.parseFromString(html, 'text/html')
          const ratingSection = doc.querySelector(`#shopify-section-${ratingId}`)
          if (ratingSection && this.popupVariant) {
            const tmp = document.createElement('div')
            tmp.innerHTML = ratingSection.outerHTML
            const el = tmp.querySelector('[data-popup-okendo-rating]')
            if (el) {
              try {
                const rd = JSON.parse(el.textContent)
                this.popupVariant = { ...this.popupVariant, reviewCount: rd.reviewCount, reviewRating: rd.reviewRating }
              } catch(e) {}
            }
          }
          let sectionHtml = ''
          sectionIds.forEach((sectionSuffix) => {
            const section = doc.querySelector(`[id*="${sectionSuffix}"]`)
            if (section) sectionHtml += section.outerHTML
          })
          this.popupSectionsCache[handle] = sectionHtml
          this.popupSectionsHtml = sectionHtml
          await this.$nextTick()
          this._initPopupSectionAnimations()
        } catch (e) {
          console.error('Error fetching popup sections:', e)
          this.popupSectionsCache[handle] = ''
          this.popupSectionsHtml = ''
        }
      },
      async fetchMainProductOkendoRating() {
        let mainHandle = 'studio-scent-diffuser'
        const variantTitle = this.popupVariant?.title || ''
        if (variantTitle.includes('Chauffeur')) {
          mainHandle = 'chauffeur-car-diffuser'
        }
        try {
          const res = await fetch(`${window.location.origin}/products/${mainHandle}`)
          const html = await res.text()
          const parser = new DOMParser()
          const doc = parser.parseFromString(html, 'text/html')
          const okendoElement = doc.querySelector('[data-oke-reviews-product-listing-rating]')
          if (okendoElement && this.popupVariant) {
            this.popupVariant = { ...this.popupVariant, okendoSnippetHtml: okendoElement.outerHTML }
          }
        } catch (e) {
          console.error('Error fetching main product Okendo rating:', e)
        }
      },
      popupSelectSwatch(variantId) {
        const v = this.variantsById[String(variantId)]
        if (v) this.popupVariant = v
      },
      popupSwatches() {
        if (!this.popupOption1) return []
        const swatches = []
        const seen = {}
        Object.values(this.variantsById).forEach((v) => {
          if (v.option1 !== this.popupOption1) return
          if (!v.available) return
          if (!v.option2 || seen[v.option2]) return
          seen[v.option2] = true
          swatches.push({ id: v.id, label: v.option2, bg: v.swatchBg || '#e0e0e0' })
        })
        return swatches
      },
      isPopupSwatchActive(variantId) {
        return this.popupVariant && Number(this.popupVariant.id) === Number(variantId)
      },
      popupFeatures() {
        if (!this.popupVariant) return []
        return Array.isArray(this.popupVariant.allFeatures) ? this.popupVariant.allFeatures : []
      },
      popupTitle() {
        if (!this.popupVariant) return ''
        return this.popupVariant.option1 || this.popupVariant.title || ''
      },
      popupImage() {
        if (!this.popupVariant) return ''
        return this.popupVariant.image || ''
      },
      popupShowsRealPrice() {
        if (!this.popupVariant || !this.directAddOption1) return false
        const option1 = this.popupVariant.option1 || this.popupVariant.title || ''
        return option1 === this.directAddOption1
      },
      popupCurrentPrice() {
        if (!this.popupShowsRealPrice()) return '$0'
        return this.formatPdpMoney(Number(this.popupVariant.realPrice || 0))
      },
      popupCompareAtPrice() {
        if (!this.popupVariant) return ''
        const c = Number(this.popupVariant.compareAtPrice || 0)
        const p = Number(this.popupVariant.realPrice || 0)
        if (c > p) return this.formatPdpMoney(c)
        return ''
      },
      richTextToHtml(json) {
        if (!json) return ''
        let tree
        try { tree = typeof json === 'string' ? JSON.parse(json) : json }
        catch (e) { return json }
        function walk(node) {
          if (!node) return ''
          if (node.type === 'text') {
            let t = (node.value || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
            if (node.bold)   t = '<strong>' + t + '</strong>'
            if (node.italic) t = '<em>' + t + '</em>'
            if (node.code)   t = '<code>' + t + '</code>'
            return t
          }
          const inner = (node.children || []).map(walk).join('')
          switch (node.type) {
            case 'root':      return inner
            case 'paragraph': return '<p>' + inner + '</p>'
            case 'heading':   return '<h' + node.level + '>' + inner + '</h' + node.level + '>'
            case 'list':      return node.listType === 'ordered' ? '<ol>' + inner + '</ol>' : '<ul>' + inner + '</ul>'
            case 'list-item': return '<li>' + inner + '</li>'
            case 'link':      return '<a href="' + (node.url || '') + '"' + (node.target ? ' target="' + node.target + '"' : '') + '>' + inner + '</a>'
            default:          return inner
          }
        }
        return walk(tree)
      },

      decodeEscapedHtml(str) {
        if (!str) return ''
        return str
          .replace(/&amp;/g, '&')
          .replace(/&lt;/g, '<')
          .replace(/&gt;/g, '>')
          .replace(/&quot;/g, '"')
          .replace(/&#39;/g, "'")
      },

      formatNotes(val) {
        if (!val) return ''
        const html = this.richTextToHtml(val)
        if (html !== val) return html
        return val.split(/\n|\r\n/).filter(l => l.trim()).map(line => {
          const idx = line.indexOf(':')
          if (idx > -1) {
            const label = line.slice(0, idx).trim()
            const rest  = line.slice(idx + 1).trim()
            return '<p><strong>' + label + '</strong>: ' + rest + '</p>'
          }
          return '<p>' + line + '</p>'
        }).join('')
      },

      // ── Review image ────────────────────────────────────────────────
      reviewMappedImageUrl() {
        const bundles = this.bundles || []
        const option1 = bundles.length ? (bundles[0].option1 || '') : ''
        const rules = parseQtyAddonProductTypeRules(this.addonProductTypeMap)
        let productType = null
        for (let i = 0; i < rules.length; i++) {
          if (option1.indexOf(rules[i].match) !== -1) { productType = rules[i].productType; break }
        }
        const mappings = Array.isArray(this.reviewImageMappings) ? this.reviewImageMappings : []
        for (let i = 0; i < mappings.length; i++) {
          const row = mappings[i] || {}
          const rowRules = parseQtyAddonProductTypeRules(row.map || '')
          for (let j = 0; j < rowRules.length; j++) {
            const matches = productType
              ? rowRules[j].productType === productType
              : option1.indexOf(rowRules[j].match) !== -1
            if (matches && row.imageUrl) return row.imageUrl
          }
        }
        return this.productFeaturedImage || ''
      },

      // ── All-Scents modal ─────────────────────────────────────────────
      currentAddonProductType() {
        return this._allScentsProductType || null
      },
      openAllScentsModal(productType, collectionFilter) {
        this._allScentsProductType = productType || null
        this._allScentsCollectionFilter = collectionFilter || null
        this.allScentsModalOpen = true
        this.allScentsDrawerOpen = false
        document.body.style.overflow = 'hidden'
      },
      closeAllScentsModal() {
        this.allScentsModalOpen = false
        this.allScentsDrawerOpen = false
        document.body.style.overflow = ''
      },
      openAllScentsDrawer() {
        this.allScentsDrawerOpen = true
      },
      closeAllScentsDrawer() {
        this.allScentsDrawerOpen = false
      },
      addonRowById(variantId) {
        return this.addonVariantsById[String(variantId)] || null
      },
      allScentsCardImage(variantId) {
        const row = this.addonRowById(variantId)
        if (!row || !row.cardImage) return ''
        const desktop = typeof window !== 'undefined' && window.matchMedia
          ? window.matchMedia('(min-width: 990px)').matches
          : false
        return this.imageUrlWithWidth(row.cardImage, desktop ? 512 : 248)
      },
      normalizeFilterText(value) {
        if (value == null) return ''
        return String(value).trim().toLowerCase()
      },
      isAddonVariantVisible(addonVariantId) {
        const row = this.addonVariantsById[String(addonVariantId)]
        if (!row) return false
        if (row.available === false) return false
        const sp = row.sellingPlanId
        if (sp == null || sp === '' || Number(sp) <= 0) return false
        const compositeKey = this._allScentsProductType
        if (!compositeKey) return true
        const group = this.addonTypeGroups.find((g) => g.productType === compositeKey)
        const realPt = group ? (group.realProductType || group.productType) : compositeKey
        const rowPt = row.productType != null ? String(row.productType).trim() : ''
        if (rowPt !== realPt) return false
        const cf = this._allScentsCollectionFilter
        if (cf) {
          const rowCn = row.collectionName != null ? String(row.collectionName).trim() : ''
          if (rowCn !== cf) return false
        }
        return true
      },
      availableInspiredByOptions() {
        const out = []
        const seen = {}
        const ids = Object.keys(this.addonVariantsById)
        for (let i = 0; i < ids.length; i++) {
          const id = Number(ids[i])
          if (!this.isAddonVariantVisible(id)) continue
          const row = this.addonVariantsById[String(id)]
          const rawName = row && row.inspiredBy != null ? String(row.inspiredBy).trim() : ''
          if (!rawName) continue
          const key = this.normalizeFilterText(rawName)
          if (seen[key]) continue
          seen[key] = true
          out.push({ name: rawName })
        }
        return out
      },
      isInspiredByFilterSelected(name) {
        return this.selectedInspiredByFilters.includes(this.normalizeFilterText(name))
      },
      toggleInspiredByFilter(name) {
        const key = this.normalizeFilterText(name)
        if (!key) return
        if (this.selectedInspiredByFilters.includes(key)) {
          this.selectedInspiredByFilters = this.selectedInspiredByFilters.filter((x) => x !== key)
        } else {
          this.selectedInspiredByFilters = [...this.selectedInspiredByFilters, key]
        }
      },
      addonMatchesInspiredByFilter(variantId) {
        if (!this.selectedInspiredByFilters.length) return false
        const row = this.addonRowById(variantId)
        const name = this.normalizeFilterText(row && row.inspiredBy != null ? String(row.inspiredBy) : '')
        if (!name) return false
        return this.selectedInspiredByFilters.includes(name)
      },
      addonMatchesSelectedFilters(variantId) {
        if (!this.selectedInspiredByFilters.length) return true
        return this.addonMatchesInspiredByFilter(variantId)
      },
      addonMatchesSearch(row) {
        const q = this.normalizeFilterText(this.allScentsSearch)
        if (!q) return true
        const title = row && row.cardTitle ? this.normalizeFilterText(row.cardTitle) : ''
        const inspiredBy = row && row.inspiredBy ? this.normalizeFilterText(row.inspiredBy) : ''
        return title.includes(q) || inspiredBy.includes(q)
      },
      filteredAddonVariantIds() {
        const ids = Object.keys(this.addonVariantsById)
        const out = []
        for (let i = 0; i < ids.length; i++) {
          const id = Number(ids[i])
          if (!this.isAddonVariantVisible(id)) continue
          const row = this.addonRowById(id)
          if (!row) continue
          if (!this.addonMatchesSearch(row)) continue
          if (!this.addonMatchesSelectedFilters(id)) continue
          out.push(id)
        }
        return out
      },
      allScentsSubheadline() {
        const pt = this._allScentsProductType
        const group = pt ? this.addonTypeGroups.find((g) => g.productType === pt) : null
        return this.addonTypeSubheadline(group)
      },
      selectAddonFromAllScents() {
        this.closeAllScentsModal()
        this.$nextTick(() => {
          this.advanceAddonStep()
        })
      },

      // ── Addon popup ──────────────────────────────────────────────────
      openAddonPopup(addonVariantId) {
        const v = this.addonRowById(addonVariantId)
        if (v) {
          this.addonPopupVariant = v
          this.addonPopupOpen = true
          this.addonPopupSectionsHtml = ''
          this.$nextTick(() => {
            this.fetchAddonPopupSections(v.handle)
          })
        }
      },
      closeAddonPopup() {
        this.addonPopupOpen = false
        this.addonPopupVariant = null
      },
      addonPopupTitle() {
        if (!this.addonPopupVariant) return ''
        return this.addonPopupVariant.cardTitle || ''
      },
      addonPopupImage() {
        if (!this.addonPopupVariant) return ''
        return this.addonPopupVariant.cardImage || ''
      },
      addonPopupPrice() {
        if (!this.addonPopupVariant) return ''
        return this.formatPdpMoney(this.addonPopupVariant.price)
      },
      addonPopupCompareAtPrice() {
        if (!this.addonPopupVariant) return ''
        const c = Number(this.addonPopupVariant.compareAtPrice || 0)
        const p = Number(this.addonPopupVariant.price || 0)
        if (c > p) return this.formatPdpMoney(c)
        return ''
      },
      addonPopupHasCompare() {
        if (!this.addonPopupVariant) return false
        return Number(this.addonPopupVariant.compareAtPrice) > Number(this.addonPopupVariant.price)
      },
      addonPopupSavePercent() {
        if (!this.addonPopupVariant) return ''
        const c = Number(this.addonPopupVariant.compareAtPrice || 0)
        const p = Number(this.addonPopupVariant.price || 0)
        if (c > p && c > 0) return Math.round(((c - p) / c) * 100) + '%'
        return ''
      },
      addonPopupScentProfile() {
        if (!this.addonPopupVariant) return []
        return Array.isArray(this.addonPopupVariant.scentProfile) ? this.addonPopupVariant.scentProfile : []
      },
      addonPopupScentMoods() {
        if (!this.addonPopupVariant) return []
        return Array.isArray(this.addonPopupVariant.scentMoods) ? this.addonPopupVariant.scentMoods : []
      },
      addonPopupInspiredBy() {
        if (!this.addonPopupVariant) return ''
        return this.addonPopupVariant.inspiredBy || ''
      },
      addonPopupDescription() {
        if (!this.addonPopupVariant) return ''
        return this.addonPopupVariant.description || ''
      },
      _initAddonPopupSectionAnimations() {
        const container = this.$refs.addonPopupSections
        if (!container) return
        container.querySelectorAll('.el_animate').forEach(el => {
          el.classList.add('animate-scroll-banner')
        })
      },
      async fetchAddonPopupSections(handle) {
        if (!handle) return
        if (this.addonPopupSectionsCache[handle] !== undefined) {
          this.addonPopupSectionsHtml = this.addonPopupSectionsCache[handle]
          await this.$nextTick()
          this._initAddonPopupSectionAnimations()
          return
        }
        const sectionIds = ['scrolling_banner_3aBXMF', 'image_with_text_LtBR7i']
        try {
          const url = `${window.location.origin}/products/${handle}`
          const res = await fetch(url)
          const html = await res.text()
          const parser = new DOMParser()
          const doc = parser.parseFromString(html, 'text/html')
          let sectionHtml = ''
          sectionIds.forEach(sectionSuffix => {
            const section = doc.querySelector(`[id*="${sectionSuffix}"]`)
            if (section) sectionHtml += section.outerHTML
          })
          this.addonPopupSectionsCache[handle] = sectionHtml
          this.addonPopupSectionsHtml = sectionHtml
          await this.$nextTick()
          this._initAddonPopupSectionAnimations()
        } catch (e) {
          this.addonPopupSectionsCache[handle] = ''
          this.addonPopupSectionsHtml = ''
        }
      },

    }))
  })


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-swiper-quantity"] && !Shopify.designMode) return;
  try {
    

  // ── External Swiper initialiser ────────────────────────────────────────────
  // Runs at DOMContentLoaded — before Alpine's init() — so Swiper is always
  // created by this function. Slide changes are communicated to Alpine via a
  // custom event on the section root, which Alpine listens for in init().
  const initQtyPdpSwiper = (root) => {
    if (typeof window.Swiper === 'undefined') return

    // Media swipers (left column on slide 0 and review slide)
    root.querySelectorAll('.pdp-swiper__media-swiper').forEach((mediaEl) => {
      if (mediaEl.swiper) return
      new window.Swiper(mediaEl, {
        nested: true,
        slidesPerView: 1,
        speed: 650,
        breakpoints: { 990: { allowTouchMove: false, simulateTouch: false } },
      })
    })

    // Root Swiper — controls all step slides
    const rootEl = root.querySelector('.pdp-swiper__root')
    if (!rootEl || rootEl.swiper) return
    new window.Swiper(rootEl, {
      slidesPerView: 1,
      speed: 700,
      allowTouchMove: false,
      simulateTouch: false,
      autoHeight: true,
      on: {
        slideChange(sw) {
          root.dispatchEvent(
            new CustomEvent('pdp-swiper-qty:slide-change', {
              bubbles: false,
              detail: { activeIndex: sw.activeIndex },
            })
          )
        },
      },
    })
  }

  const _runQtyPdpSwiperInit = () => {
    document.querySelectorAll('.pdp-swiper-qty').forEach(initQtyPdpSwiper)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', _runQtyPdpSwiperInit)
  } else {
    _runQtyPdpSwiperInit()
  }

  // ── Discount / product-type rule parsers ───────────────────────────────────

  const parseDiscountByProductTypeRules = (raw) => {
    if (!raw || typeof raw !== 'string') return []
    return raw
      .replace(/\r\n/g, '\n')
      .split(/[,\n]+/)
      .map((s) => s.trim())
      .filter(Boolean)
      .map((segment) => {
        const idx = segment.lastIndexOf('/')
        if (idx === -1) return null
        const productType = segment.slice(0, idx).trim()
        const percent = segment.slice(idx + 1).trim()
        if (!productType || !percent) return null
        return { productType, percent: Number(percent) }
      })
      .filter(Boolean)
  }

  const parseQtyAddonProductTypeRules = (raw) => {
    if (!raw || typeof raw !== 'string') return []
    return raw
      .replace(/\r\n/g, '\n')
      .split(/[,\n]+/)
      .map((s) => s.trim())
      .filter(Boolean)
      .map((segment) => {
        const parts = segment.split('|').map((p) => p.trim())
        const match = parts[0]
        const productType = parts[1] || ''
        const collectionFilter = parts[2] || null
        if (!match || !productType) return null
        return { match, productType, collectionFilter }
      })
      .filter(Boolean)
  }

  document.addEventListener('alpine:init', () => {
    Alpine.data('pdpSwiperQuantityState', () => ({

      // ── Variant data ────────────────────────────────────────────────
      productHandle: '',
      variantsById: {},
      addonVariantsById: {},
      defaultByOption1: {},
      addonProductTypeMap: '',
      discountByProductTypeMap: '',
      reviewImageMappings: [],
      productFeaturedImage: '',
      bundleVariantId: '',
      bundleOnlyMode: false,
      directAddOption1: '',
      bundleVariant: null,
      bundleSlotsByType: {},

      // ── Step 1 quantity state ────────────────────────────────────────
      // { [option1Key]: 0..3 }
      quantityByOption1: {},

      // ── Step 1 slot color state ──────────────────────────────────────
      // { [option1Key]: [variantId, variantId, ...] }  length === qty
      slotColorByOption1: {},

      // ── Swatch data (baked from Liquid) ──────────────────────────────
      // { [option1Key]: [{ variantId, option2, swatchBg }, ...] }
      swatchesByOption1: {},

      // Ordered list of option1 keys (Liquid render order)
      option1Order: [],

      // ── Bundle list (built on NEXT from Step 1) ──────────────────────
      bundles: [],

      // ── Addon type groups (derived from bundles, drives addon slides) ─
      // [{ productType, count, bundles[], label }]
      addonTypeGroups: [],

      // ── Scent qty per type: { [productType]: { [addonVariantId]: qty } }
      addonQtyByType: {},

      // ── Swiper tracking ──────────────────────────────────────────────
      currentSwiperIndex: 0,
      stepTextTemplate: '',
      hideReviewStep: false,

      // ── Shared UI state ─────────────────────────────────────────────
      termsAccepted: false,
      termsAcceptedAt: null,
      termsModalOpen: false,
      addToCartLoading: false,
      popupOpen: false,
      popupVariant: null,
      popupOption1: null,
      popupSectionsCache: {},
      popupSectionsHtml: '',
      addonPopupOpen: false,
      addonPopupVariant: null,
      addonPopupSectionsCache: {},
      addonPopupSectionsHtml: '',
      allScentsModalOpen: false,
      allScentsSearch: '',
      allScentsInspiredByOpen: true,
      allScentsDrawerOpen: false,
      selectedInspiredByFilters: [],
      _allScentsProductType: null,
      _allScentsCollectionFilter: null,
      pdpSwiperRootEl: null,

      // ── Init ────────────────────────────────────────────────────────
      init() {
        this.pdpSwiperRootEl =
          this.$el && this.$el.closest ? this.$el.closest('.pdp-swiper-qty') : null

        const jsonEl = this.$el.querySelector('[data-pdp-variant-state]')
        if (!jsonEl) return

        let state = null
        try {
          state = JSON.parse(jsonEl.textContent || '{}')
        } catch (e) {
          state = null
        }
        if (!state) return

        // Populate variantsById
        ;(state.variants || []).forEach((v) => {
          this.variantsById[String(v.id)] = v
        })

        // Populate addonVariantsById
        this.addonVariantsById = {}
        ;(state.addonVariants || []).forEach((row) => {
          if (row && row.id != null) {
            this.addonVariantsById[String(row.id)] = row
          }
        })

        this.defaultByOption1 = { ...(state.defaults || {}) }
        this.addonProductTypeMap =
          typeof state.addonProductTypeMap === 'string' ? state.addonProductTypeMap : ''
        this.discountByProductTypeMap =
          typeof state.discountByProductTypeMap === 'string'
            ? state.discountByProductTypeMap
            : ''
        this.reviewImageMappings = Array.isArray(state.reviewImageMappings)
          ? state.reviewImageMappings
          : []
        this.productFeaturedImage = state.productFeaturedImage || ''
        this.productHandle = state.productHandle || ''

        this.bundleVariantId = state.bundleVariantId || ''
        this.bundleOnlyMode = !!state.bundleOnlyMode
        this.directAddOption1 = typeof state.directAddOption1 === 'string' ? state.directAddOption1 : ''
        this.hideReviewStep = !!state.hideReviewStep
        this.bundleVariant = this.bundleVariantId
          ? (Object.values(this.variantsById).find((v) => v.option1 === this.bundleVariantId) || null)
          : null

        // Swatch data per option1 group
        this.swatchesByOption1 =
          state.swatchesByOption1 && typeof state.swatchesByOption1 === 'object'
            ? state.swatchesByOption1
            : {}

        // Ordered option1 keys (Liquid render order for bundle building)
        this.option1Order = Array.isArray(state.option1Order) ? state.option1Order : []

        // Initialize quantityByOption1: all option1 groups start at 0
        const qtyInit = {}
        Object.keys(this.defaultByOption1).forEach((key) => {
          qtyInit[key] = 0
        })
        this.quantityByOption1 = qtyInit
        this.slotColorByOption1 = {}

        // Bundle-only mode: the bundle card is the only purchasable item on Step 1,
        // so pre-select 1 unit (and its default color per component type) instead of
        // landing on an empty page with nothing selected and NEXT disabled.
        if (this.bundleOnlyMode && this.bundleVariant) {
          this.quantityByOption1 = { ...this.quantityByOption1, __bundle__: 1 }
          const typeOrder = this.getBundleTypeOrder()
          const initialSlots = {}
          typeOrder.forEach((t) => {
            initialSlots[t.productType] = [t.swatches.length ? t.swatches[0].variantId : null]
          })
          this.bundleSlotsByType = initialSlots
        }

        // Step text template for addon slides ("Step {step_number}: ...")
        this.stepTextTemplate = typeof state.stepTextTemplate === 'string'
          ? state.stepTextTemplate
          : 'Step {step_number}: Choose your scent.'

        // Listen for slide changes dispatched by the external Swiper init
        const root = this.pdpSwiperRootEl
        if (root) {
          root.addEventListener('pdp-swiper-qty:slide-change', (e) => {
            this.currentSwiperIndex = (e.detail && e.detail.activeIndex != null)
              ? e.detail.activeIndex
              : 0
          })
        }
      },

      // ── Quantity helpers ─────────────────────────────────────────────
      getQty(option1Key) {
        return Number(this.quantityByOption1[option1Key] || 0)
      },

      incrementQty(option1Key) {
        const current = this.getQty(option1Key)
        const weight = option1Key === '__bundle__' ? 3 : 1
        if (this.totalWeightedUnits() + weight > 6) return
        this.quantityByOption1 = { ...this.quantityByOption1, [option1Key]: current + 1 }
        if (option1Key === '__bundle__') {
          const typeOrder = this.getBundleTypeOrder()
          const newSlots = { ...this.bundleSlotsByType }
          typeOrder.forEach((t) => {
            const existing = [...(newSlots[t.productType] || [])]
            existing.push(t.swatches.length ? t.swatches[0].variantId : null)
            newSlots[t.productType] = existing
          })
          this.bundleSlotsByType = newSlots
        } else {
          const existing = [...(this.slotColorByOption1[option1Key] || [])]
          existing.push(this.firstSwatchVariantIdForOption1(option1Key))
          this.slotColorByOption1 = { ...this.slotColorByOption1, [option1Key]: existing }
        }
      },

      decrementQty(option1Key) {
        const current = this.getQty(option1Key)
        if (current <= 0) return
        this.quantityByOption1 = { ...this.quantityByOption1, [option1Key]: current - 1 }
        if (option1Key === '__bundle__') {
          const newSlots = { ...this.bundleSlotsByType }
          Object.keys(newSlots).forEach((pt) => {
            newSlots[pt] = newSlots[pt].slice(0, -1)
          })
          this.bundleSlotsByType = newSlots
        } else {
          const existing = [...(this.slotColorByOption1[option1Key] || [])]
          existing.pop()
          this.slotColorByOption1 = { ...this.slotColorByOption1, [option1Key]: existing }
        }
      },

      totalUnits() {
        return Object.values(this.quantityByOption1).reduce(
          (sum, q) => sum + (Number(q) || 0),
          0
        )
      },

      totalWeightedUnits() {
        const bundleQty = this.getQty('__bundle__')
        const regularQty = Object.entries(this.quantityByOption1)
          .filter(([key]) => key !== '__bundle__')
          .reduce((sum, [, q]) => sum + (Number(q) || 0), 0)
        return regularQty + bundleQty * 3
      },

      canAdvanceFromStep1() {
        if (this.totalUnits() === 0) return false
        const bundleQty = this.getQty('__bundle__')
        if (bundleQty > 0) {
          const typeOrder = this.getBundleTypeOrder()
          for (let ti = 0; ti < typeOrder.length; ti++) {
            const slots = this.bundleSlotsByType[typeOrder[ti].productType] || []
            for (let i = 0; i < bundleQty; i++) {
              if (!slots[i]) return false
            }
          }
        }
        return true
      },

      isDirectAddSelection() {
        const key = this.directAddOption1
        if (!key || this.getQty(key) <= 0) return false
        return Object.entries(this.quantityByOption1).every(([option1Key, qty]) => {
          if (option1Key === key) return true
          return Number(qty) <= 0
        })
      },

      isStep1DirectAdd() {
        return this.currentSwiperIndex === 0 && this.isDirectAddSelection()
      },

      onStep1PrimaryClick() {
        if (this.isDirectAddSelection()) {
          this.addDirectOption1ToCart()
        } else {
          this.buildBundles()
        }
      },

      async addDirectOption1ToCart() {
        const option1Key = this.directAddOption1
        if (!this.isDirectAddSelection() || this.addToCartLoading) return
        this.addToCartLoading = true
        try {
          const qty = this.getQty(option1Key)
          const slots = this.slotColorByOption1[option1Key] || []
          const counts = {}
          for (let i = 0; i < qty; i++) {
            const variantId = slots[i] != null
              ? slots[i]
              : this.firstSwatchVariantIdForOption1(option1Key)
            if (!variantId) continue
            const id = String(variantId)
            counts[id] = (counts[id] || 0) + 1
          }
          const items = Object.keys(counts).map((id) => ({
            id: Number(id),
            quantity: counts[id],
          }))
          if (!items.length) return

          const rootPath =
            typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.root
              ? window.Shopify.routes.root
              : '/'

          const res = await fetch(`${rootPath}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ items }),
          })
          const data = await res.json().catch(() => ({}))
          if (!res.ok || data.status === 422) {
            console.error('[pdp-swiper-qty] direct cart/add error:', data)
          }
        } catch (err) {
          console.error('[pdp-swiper-qty] addDirectOption1ToCart error:', err)
        } finally {
          this.addToCartLoading = false
        }
      },

      // ── Swatch / slot helpers ────────────────────────────────────────
      getSwatchesForOption1(option1Key) {
        const swatches = this.swatchesByOption1[option1Key] || []
        // Every color option containing PINNED_COLOR (case-insensitive) gets pinned to
        // the front of the row, keeping their natural relative order, so the first
        // available matching variant is the first/default one. e.g. "Silver by Aroma360",
        // "Matte Silver", etc. Change this keyword (e.g. 'black') to pin a different color.
        const PINNED_COLOR = 'silver'
        const isPinned = sw => (sw.option2 || '').toLowerCase().includes(PINNED_COLOR)
        if (swatches.some(isPinned)) {
          return [...swatches.filter(isPinned), ...swatches.filter(sw => !isPinned(sw))]
        }
        return swatches
      },

      firstSwatchVariantIdForOption1(option1Key) {
        const swatches = this.getSwatchesForOption1(option1Key)
        if (swatches.length) return swatches[0].variantId
        // Fallback to the defaults map if no swatch data (single-option products)
        return this.defaultByOption1[option1Key] || null
      },

      getSlotVariantId(option1Key, slotIndex) {
        const slots = this.slotColorByOption1[option1Key] || []
        return slots[slotIndex] != null ? slots[slotIndex] : null
      },

      // ── Bundle slot helpers ──────────────────────────────────────────
      getBundleTypeOrder() {
        const rules = parseQtyAddonProductTypeRules(this.addonProductTypeMap)
        const bundleOption1 = this.bundleVariant ? (this.bundleVariant.option1 || '') : ''
        const seen = new Set()
        return this.option1Order
          .filter((o1) => !bundleOption1 || o1 !== bundleOption1)
          .map((o1) => {
            for (let i = 0; i < rules.length; i++) {
              if (o1.indexOf(rules[i].match) !== -1) {
                const rule = rules[i]
                const compositeKey = rule.collectionFilter
                  ? rule.productType + '::' + rule.collectionFilter
                  : rule.productType
                // Use getSwatchesForOption1 (not the raw map) so the pinned-color
                // pin-to-front rule also applies inside bundle slot pickers.
                return { option1: o1, productType: compositeKey, swatches: this.getSwatchesForOption1(o1) }
              }
            }
            return null
          })
          .filter(Boolean)
          .filter((t) => {
            if (seen.has(t.productType)) return false
            seen.add(t.productType)
            return true
          })
      },

      getBundleUnitCount() {
        return this.getQty('__bundle__')
      },

      isBundleSlotSelected(productType, unitIdx, variantId) {
        const slots = this.bundleSlotsByType[productType] || []
        return slots[unitIdx] === variantId
      },

      setBundleSlotColor(productType, unitIdx, variantId) {
        const slots = [...(this.bundleSlotsByType[productType] || [])]
        slots[unitIdx] = variantId
        this.bundleSlotsByType = { ...this.bundleSlotsByType, [productType]: slots }
      },

      getBundleSlotColorName(productType, unitIdx) {
        const slots = this.bundleSlotsByType[productType] || []
        const variantId = slots[unitIdx]
        if (!variantId) return ''
        const v = this.variantsById[String(variantId)]
        return v ? (v.option2 || '') : ''
      },

      setSlotColor(option1Key, slotIndex, variantId) {
        const slots = [...(this.slotColorByOption1[option1Key] || [])]
        slots[slotIndex] = variantId
        this.slotColorByOption1 = { ...this.slotColorByOption1, [option1Key]: slots }
      },

      isSlotSwatchSelected(option1Key, slotIndex, variantId) {
        const current = this.getSlotVariantId(option1Key, slotIndex)
        return Number(current) === Number(variantId)
      },
      // Ship-date note under the swatches. Driven by the variant metafield custom.shipping_date
      // (set only on the variants that ship later, e.g. the black ones): "11/20" -> "Ships 11/20".
      // Empty metafield -> no note.
      shipLabelForVariant(variantId) {
        const v = variantId ? this.variantsById[String(variantId)] : null
        const raw = v ? String(v.shippingDate || '').trim() : ''
        if (!raw) return ''
        let m = raw.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/)
        if (m) return 'Ships ' + Number(m[2]) + '/' + Number(m[3])
        m = raw.match(/^(\d{1,2})[\/.-](\d{1,2})(?:[\/.-]\d{2,4})?$/)
        if (m) return 'Ships ' + Number(m[1]) + '/' + Number(m[2])
        return 'Ships ' + raw
      },
      getSlotShipLabel(option1Key, slotIndex) {
        return this.shipLabelForVariant(this.getSlotVariantId(option1Key, slotIndex))
      },
      getBundleSlotShipLabel(productType, unitIdx) {
        const slots = this.bundleSlotsByType[productType] || []
        return this.shipLabelForVariant(slots[unitIdx])
      },
      getSlotColorName(option1Key, slotIndex) {
        const variantId = this.getSlotVariantId(option1Key, slotIndex)
        const v = variantId ? this.variantsById[String(variantId)] : null
        return v ? (v.option2 || '') : ''
      },

      // ── Build flat bundle list ───────────────────────────────────────
      // Called when user clicks NEXT on Step 1.
      // Produces: [{ bundleId, variantId, option1, option2, productType }, ...]
      buildBundles() {
        const order = this.option1Order.length
          ? this.option1Order
          : Object.keys(this.quantityByOption1)

        const bundles = []
        order.forEach((option1Key) => {
          const qty = this.getQty(option1Key)
          const slots = this.slotColorByOption1[option1Key] || []
          for (let i = 0; i < qty; i++) {
            const variantId =
              slots[i] != null
                ? slots[i]
                : this.firstSwatchVariantIdForOption1(option1Key)
            if (!variantId) continue
            const variant = this.getVariantById(variantId)
            if (!variant) continue
            const bundle = {
              bundleId: `_bundle_qty_${variantId}_s${i}_${Date.now()}_${Math.random()
                .toString(36)
                .slice(2, 7)}`,
              variantId: Number(variantId),
              option1: variant.option1 || option1Key,
              option2: variant.option2 || '',
            }
            bundle.productType = this.expectedAddonProductTypeForBundle(bundle)
            bundles.push(bundle)
          }
        })
        // Bundle card entries — one per type per unit
        const bundleQty = this.getQty('__bundle__')
        if (bundleQty > 0 && this.bundleVariant) {
          const typeOrder = this.getBundleTypeOrder()
          for (let unitIdx = 0; unitIdx < bundleQty; unitIdx++) {
            typeOrder.forEach((t) => {
              const slotVarId = (this.bundleSlotsByType[t.productType] || [])[unitIdx]
                || (t.swatches.length ? t.swatches[0].variantId : null)
              if (!slotVarId) return
              const variant = this.getVariantById(slotVarId)
              if (!variant) return
              const bEntry = {
                bundleId: `_bundle_qty_${slotVarId}_u${unitIdx}_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
                variantId: Number(slotVarId),
                option1: variant.option1 || t.option1,
                option2: variant.option2 || '',
                isBundle: true,
                bundleUnitIdx: unitIdx,
              }
              bEntry.productType = this.expectedAddonProductTypeForBundle(bEntry)
              bundles.push(bEntry)
            })
          }
        }

        this.bundles = bundles
        const newGroups = this.buildAddonTypeGroups(bundles)
        this.addonTypeGroups = newGroups

        // Preserve existing scent selections — clip to new limits, drop removed types
        const preserved = {}
        newGroups.forEach((group) => {
          const existing = this.addonQtyByType[group.productType] || {}
          const limit = group.count
          let total = 0
          const clipped = {}
          Object.entries(existing).forEach(([variantId, qty]) => {
            const q = Number(qty) || 0
            if (q <= 0) return
            const take = Math.min(q, limit - total)
            if (take > 0) { clipped[variantId] = take; total += take }
          })
          preserved[group.productType] = clipped
        })
        this.addonQtyByType = preserved

        // After Alpine renders the new x-for slides, update Swiper and advance to slide 1
        this.$nextTick(() => {
          const root = this.pdpSwiperRootEl
          if (!root) return
          const rootEl = root.querySelector('.pdp-swiper__root')
          if (!rootEl || !rootEl.swiper) return
          rootEl.swiper.update()
          rootEl.swiper.slideTo(1, 700)
          if (typeof window !== 'undefined' && window.matchMedia &&
              window.matchMedia('(max-width: 989px)').matches) {
            window.scrollTo({ top: 0, behavior: 'smooth' })
          }
        })
      },

      // ── Variant lookup helpers ───────────────────────────────────────
      getVariantById(id) {
        if (!id) return null
        return this.variantsById[String(id)] || null
      },

      variantIsAvailable(v) {
        if (!v) return false
        return v.available !== false
      },

      // ── Image URL helper ─────────────────────────────────────────────
      imageUrlWithWidth(url, width) {
        const src = url != null ? String(url).trim() : ''
        const w = Number(width)
        if (!src) return ''
        if (!w || Number.isNaN(w) || w <= 0) return src
        if (src.includes(' width=')) return src
        if (/[?&]width=\d+/.test(src)) {
          return src.replace(/([?&]width=)\d+/, `$1${w}`)
        }
        const sep = src.includes('?') ? '&' : '?'
        return `${src}${sep}width=${w}`
      },

      // ── Card image helpers (used by aside snippet) ───────────────────
      getCardImageForOption1(option1Key) {
        // Returns the default variant's image for this option1 group
        const defaultId = this.firstSwatchVariantIdForOption1(option1Key)
        const v = this.getVariantById(defaultId)
        return v && v.image ? this.imageUrlWithWidth(v.image, 248) : ''
      },

      // ── Money formatters ─────────────────────────────────────────────
      formatPdpMoney(cents) {
        const n = Number(cents)
        if (cents == null || cents === '' || Number.isNaN(n)) return ''
        if (typeof window.formatMoney === 'function') {
          return window.formatMoney(n)
        }
        return String(n)
      },

      // ── Terms modal ──────────────────────────────────────────────────
      onTermsAcceptanceChange() {
        this.termsAcceptedAt = this.termsAccepted ? new Date().toISOString() : null
      },

      openTermsModal() {
        this.termsModalOpen = true
        document.body.style.overflow = 'hidden'
      },

      closeTermsModal() {
        this.termsModalOpen = false
        document.body.style.overflow = ''
      },

      // ── Addon product type resolution ────────────────────────────────
      expectedAddonProductTypeForBundle(bundle) {
        if (!bundle || !bundle.option1) return null
        const title = String(bundle.option1)
        const rules = parseQtyAddonProductTypeRules(this.addonProductTypeMap)
        for (let i = 0; i < rules.length; i++) {
          if (title.indexOf(rules[i].match) !== -1) {
            const rule = rules[i]
            return rule.collectionFilter ? rule.productType + '::' + rule.collectionFilter : rule.productType
          }
        }
        return null
      },

      // ── Swiper navigation helpers ────────────────────────────────────
      slideTo(idx) {
        const root = this.pdpSwiperRootEl
        if (!root) return
        const rootEl = root.querySelector('.pdp-swiper__root')
        if (!rootEl || !rootEl.swiper) return
        rootEl.swiper.slideTo(idx, 700)
      },

      checkoutSlideIndex() {
        if (this.hideReviewStep) return this.addonTypeGroups.length
        return this.addonTypeGroups.length + 1
      },

      isOnCheckoutStep() {
        return this.currentSwiperIndex === this.checkoutSlideIndex() && this.addonTypeGroups.length > 0
      },

      isLastAddonGroup(groupIdx) {
        return Number(groupIdx) === this.addonTypeGroups.length - 1
      },

      advanceAddonStep() {
        if (this.hideReviewStep && this.isOnCheckoutStep()) return
        const root = this.pdpSwiperRootEl
        if (!root) return
        const rootEl = root.querySelector('.pdp-swiper__root')
        if (!rootEl || !rootEl.swiper) return
        rootEl.swiper.slideNext()
        if (typeof window !== 'undefined' && window.matchMedia &&
            window.matchMedia('(max-width: 989px)').matches) {
          window.scrollTo({ top: 0, behavior: 'smooth' })
        }
      },

      // ── Mobile CTA helpers ───────────────────────────────────────────
      mobileNextDisabled() {
        if (this.isOnCheckoutStep()) {
          const group = this.addonTypeGroups[this.addonTypeGroups.length - 1]
          if (this.hideReviewStep) {
            return !this.canAdvanceFromTypeStep(group) || !this.termsAccepted || this.addToCartLoading
          }
          return !this.termsAccepted || this.addToCartLoading
        }
        if (this.currentSwiperIndex === 0) {
          return !this.canAdvanceFromStep1() || this.addToCartLoading
        }
        const group = this.addonTypeGroups[this.currentSwiperIndex - 1]
        if (!group) return true
        return !this.canAdvanceFromTypeStep(group)
      },

      mobileNextClick() {
        if (this.isOnCheckoutStep()) {
          this.addReviewQtySetToCart()
        } else if (this.currentSwiperIndex === 0) {
          this.onStep1PrimaryClick()
        } else {
          this.advanceAddonStep()
        }
      },

      // ── Addon type group builder ─────────────────────────────────────
      buildAddonTypeGroups(bundles) {
        const rules = parseQtyAddonProductTypeRules(this.addonProductTypeMap)
        const seen = []
        const map = {}
        bundles.forEach((bundle) => {
          const compositeKey = bundle.productType || '__none__'
          if (!map[compositeKey]) {
            const o1 = bundle.option1 || ''
            let realProductType = compositeKey
            let collectionFilter = null
            for (let i = 0; i < rules.length; i++) {
              if (o1.indexOf(rules[i].match) !== -1) {
                realProductType = rules[i].productType
                collectionFilter = rules[i].collectionFilter || null
                break
              }
            }
            map[compositeKey] = { productType: compositeKey, realProductType, count: 0, bundles: [], collectionFilter }
            seen.push(compositeKey)
          }
          map[compositeKey].count++
          map[compositeKey].bundles.push(bundle)
        })
        return seen.map((key, idx) => ({
          ...map[key],
          label: 'Oils ' + (idx + 1),
        }))
      },

      // ── Addon step helpers ───────────────────────────────────────────
      getAddonRowsForGroup(group) {
        const productType = group ? (group.realProductType || group.productType) : null
        const collectionFilter = group ? (group.collectionFilter || null) : null
        const rows = Object.values(this.addonVariantsById).filter((row) => row && row.available !== false)
        const filtered = (!productType || productType === '__none__')
          ? rows
          : rows.filter((row) => {
              if (row.productType !== productType) return false
              if (collectionFilter && row.collectionName !== collectionFilter) return false
              return true
            })
        return filtered.slice(0, 5)
      },

      getAddonQty(productType, variantId) {
        const typeMap = this.addonQtyByType[productType] || {}
        return typeMap[String(variantId)] || 0
      },

      incrementAddonQty(productType, variantId) {
        const limit = this.addonTypeLimit(productType)
        if (this.addonTypeTotal(productType) >= limit) return
        const typeMap = { ...(this.addonQtyByType[productType] || {}) }
        typeMap[String(variantId)] = (typeMap[String(variantId)] || 0) + 1
        this.addonQtyByType = { ...this.addonQtyByType, [productType]: typeMap }
      },

      decrementAddonQty(productType, variantId) {
        const typeMap = { ...(this.addonQtyByType[productType] || {}) }
        const current = typeMap[String(variantId)] || 0
        if (current <= 0) return
        typeMap[String(variantId)] = current - 1
        this.addonQtyByType = { ...this.addonQtyByType, [productType]: typeMap }
      },

      addonTypeTotal(productType) {
        const typeMap = this.addonQtyByType[productType] || {}
        return Object.values(typeMap).reduce((sum, q) => sum + (Number(q) || 0), 0)
      },

      addonTypeLimit(productType) {
        const group = this.addonTypeGroups.find((g) => g.productType === productType)
        return group ? group.count : 0
      },

      canAdvanceFromTypeStep(group) {
        if (!group) return false
        return this.addonTypeTotal(group.productType) === this.addonTypeLimit(group.productType)
      },

      addonTypeSubheadline(group) {
        if (!group) return ''
        const n = group.count
        const unit = n === 1 ? 'Oil' : 'Oils'
        const name = group.bundles[0] ? (group.bundles[0].option1 || '') : ''
        return `Choose at least <strong>${n} ${unit}</strong> for the ${name}`
      },

      // ── resolvedPairings: expand addonQtyByType into per-bundle pairs ─
      resolvedPairings() {
        const pairs = []
        this.addonTypeGroups.forEach((group) => {
          const typeMap = this.addonQtyByType[group.productType] || {}
          // Expand qty map into flat ordered list of addonVariantIds
          const scentList = []
          Object.entries(typeMap).forEach(([variantId, qty]) => {
            for (let i = 0; i < qty; i++) scentList.push(Number(variantId))
          })
          // Zip sequentially with bundles
          group.bundles.forEach((bundle, idx) => {
            pairs.push({ bundle, addonVariantId: scentList[idx] || null })
          })
        })
        return pairs
      },

      getBundleDiffuserImage(bundle, width) {
        if (!bundle) return ''
        const variant = this.getVariantById(bundle.variantId)
        if (!variant || !variant.image) return ''
        return this.imageUrlWithWidth(variant.image, width || 2000)
      },

      formatStepText(stepNumber) {
        const tmpl = this.stepTextTemplate || 'Step {step_number}: Choose your scent.'
        return tmpl.replace('{step_number}', String(stepNumber))
      },

      // ── Addon pricing ────────────────────────────────────────────────
      mappedDiscountPercentForType(productType) {
        const pt = productType != null ? String(productType).trim() : ''
        if (!pt) return null
        const rules = parseDiscountByProductTypeRules(this.discountByProductTypeMap)
        for (let i = 0; i < rules.length; i++) {
          if (rules[i].productType === pt) return Number(rules[i].percent)
        }
        return null
      },

      normalizedPricing(v) {
        if (!v) return { price: 0, compareAtPrice: 0 }
        const originalPrice = Number(v.price || 0)
        const originalCompare = Number(v.compareAtPrice || 0)
        const mappedPct = this.mappedDiscountPercentForType(v.productType)
        if (mappedPct == null) return { price: originalPrice, compareAtPrice: originalCompare }
        const hasOriginalCompare = originalCompare > originalPrice && originalCompare > 0
        if (hasOriginalCompare) {
          const currentPct = ((originalCompare - originalPrice) / originalCompare) * 100
          if (currentPct > mappedPct) return { price: originalPrice, compareAtPrice: originalCompare }
        }
        const base = hasOriginalCompare ? originalCompare : originalPrice
        if (base <= 0) return { price: originalPrice, compareAtPrice: originalCompare }
        const discounted = Math.max(0, Math.round((base * (100 - mappedPct)) / 100))
        if (discounted >= base) return { price: originalPrice, compareAtPrice: originalCompare }
        return { price: discounted, compareAtPrice: base }
      },

      addonRowById(variantId) {
        return this.addonVariantsById[String(variantId)] || null
      },

      normalizedAddonRowById(id) {
        const row = this.addonRowById(id)
        if (!row) return null
        return this.normalizedPricing(row)
      },


      addonHasCompare(variantId) {
        const p = this.normalizedAddonRowById(variantId)
        if (!p) return false
        return Number(p.compareAtPrice) > Number(p.price)
      },

      addonDisplayCompare(variantId) {
        const p = this.normalizedAddonRowById(variantId)
        if (!p) return ''
        return this.formatPdpMoney(p.compareAtPrice)
      },

      addonDisplayPrice(variantId) {
        const p = this.normalizedAddonRowById(variantId)
        if (!p) return ''
        return this.formatPdpMoney(p.price)
      },

      addonSavePercent(variantId) {
        const p = this.normalizedAddonRowById(variantId)
        if (!p) return ''
        const compareAt = Number(p.compareAtPrice || 0)
        const price = Number(p.price || 0)
        if (!compareAt || compareAt <= 0 || compareAt <= price) return ''
        return String(Math.round(((compareAt - price) / compareAt) * 100))
      },

      // ── Feature metadata (How it works / Subscription perks / Why Aroma360) ──
      getFeatureMetadata() {
        // Use the first option1 group with qty > 0; fallback to first variant overall
        const activeOption1 = this.option1Order.find(
          (key) => this.getQty(key) > 0
        )
        const variantId = activeOption1
          ? this.defaultByOption1[activeOption1]
          : Object.values(this.defaultByOption1)[0]
        const v = this.getVariantById(variantId)
        if (v && v.featureMetadata && v.featureMetadata.length) return v.featureMetadata
        // Fallback: any variant for the same option1 that has metadata
        const option1 = v ? v.option1 : null
        if (option1) {
          const match = Object.values(this.variantsById).find(
            (vv) => vv.option1 === option1 && vv.featureMetadata && vv.featureMetadata.length
          )
          if (match) return match.featureMetadata
        }
        return []
      },

      // ── Addon scent data ─────────────────────────────────────────────
      getAddonScentProfile(variantId) {
        const row = this.addonRowById(variantId)
        if (!row) return []
        return Array.isArray(row.scentProfile) ? row.scentProfile : []
      },

      getAddonScentMoods(variantId) {
        const row = this.addonRowById(variantId)
        if (!row) return []
        return Array.isArray(row.scentMoods) ? row.scentMoods : []
      },

      // ── Review step helpers ──────────────────────────────────────────

      reviewAddonRowForBundle(bundle) {
        if (!bundle) return null
        const pair = this.resolvedPairings().find(
          (p) => p.bundle.bundleId === bundle.bundleId
        )
        if (!pair || !pair.addonVariantId) return null
        return this.addonRowById(pair.addonVariantId) || null
      },

      reviewSumPriceCents() {
        return this.resolvedPairings().reduce((total, pair) => {
          if (!pair.addonVariantId) return total
          const row = this.normalizedAddonRowById(pair.addonVariantId)
          return total + (row ? Number(row.price) || 0 : 0)
        }, 0)
      },

      reviewSumCompareAtCents() {
        return this.resolvedPairings().reduce((total, pair) => {
          if (!pair.addonVariantId) return total
          const row = this.normalizedAddonRowById(pair.addonVariantId)
          return total + (row ? Number(row.compareAtPrice) || Number(row.price) || 0 : 0)
        }, 0)
      },

      formatPdpMoneyOrFree(cents) {
        const n = Number(cents)
        if (!n || n <= 0) return 'FREE'
        return this.formatPdpMoney(n)
      },

      // ── Cart helpers (mirror existing section) ───────────────────────

      buildBundleId(mainVariantId, addonVariantId) {
        return `_bundle_${mainVariantId}_${addonVariantId}_plan_30_ts_${Date.now()}`
      },

      compareAtCentsString(variantRow) {
        if (!variantRow) return '0'
        const c = Number(variantRow.compareAtPrice || 0)
        if (!c || c <= 0) return '0'
        return String(Math.round(c))
      },

      compareDiscountPercentString(variantRow) {
        if (!variantRow) return '0'
        const cap = Number(variantRow.compareAtPrice || 0)
        const price = Number(variantRow.price || 0)
        if (!cap || cap <= 0 || cap <= price) return '0'
        const pct = Math.round(((cap - price) / cap) * 100)
        return String(Math.max(0, pct))
      },

      buildBundleLineProperties(variantRow, bundleId, tosAcceptedAt) {
        return {
          _bundle_promo: 'free-diffuser-set',
          _bundle_id: bundleId,
          _bundle_identifier: 'true',
          _compare_at_price: this.compareAtCentsString(variantRow),
          _compare_at_price_discount: this.compareDiscountPercentString(variantRow),
          _free_diffuser_tos_aceptance:
            tosAcceptedAt != null && tosAcceptedAt !== '' ? String(tosAcceptedAt) : '',
        }
      },

      // ── Add to cart ──────────────────────────────────────────────────

      async addReviewQtySetToCart() {
        if (!this.termsAccepted || this.addToCartLoading) return
        this.addToCartLoading = true
        try {
          const tosAt = this.termsAcceptedAt
          const items = []

          for (const pair of this.resolvedPairings()) {
            const bundle = pair.bundle
            const mainVariant = this.getVariantById(bundle.variantId)
            if (!mainVariant) continue

            const addonRow = pair.addonVariantId ? this.addonRowById(pair.addonVariantId) : null
            const addonEligible = addonRow && addonRow.available !== false
            const resolvedAddonId = addonEligible ? Number(pair.addonVariantId) : 0

            const bundleId = bundle.bundleId || this.buildBundleId(Number(bundle.variantId), resolvedAddonId)

            // Diffuser line item
            items.push({
              id: Number(bundle.variantId),
              quantity: 1,
              properties: this.buildBundleLineProperties(mainVariant, bundleId, tosAt),
            })

            // Scent line item
            if (addonEligible) {
              const addonLine = {
                id: resolvedAddonId,
                quantity: 1,
                properties: this.buildBundleLineProperties(addonRow, bundleId, tosAt),
              }
              const sp = addonRow.sellingPlanId
              if (sp != null && sp !== '') {
                addonLine.selling_plan = Number(sp)
                addonLine.properties._notes = "Initial Subscription Order";
              }
              items.push(addonLine)
            }
          }

          if (!items.length) return

          const rootPath =
            typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.root
              ? window.Shopify.routes.root
              : '/'

          const res = await fetch(`${rootPath}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ items }),
          })
          const data = await res.json().catch(() => ({}))
          if (!res.ok || data.status === 422) {
            console.error('[pdp-swiper-qty] cart/add error:', data)
            return
          }

        } catch (err) {
          console.error('[pdp-swiper-qty] addReviewQtySetToCart error:', err)
        } finally {
          this.addToCartLoading = false
        }
      },

      // ── Popup (Learn More) ──────────────────────────────────────────
      openVariantPopup(option1Key) {
        this.popupOption1 = option1Key
        const id = this.defaultByOption1[option1Key]
        const v = id ? this.variantsById[String(id)] : null
        if (!v) {
          const fallback = Object.values(this.variantsById).find((vv) => vv.option1 === option1Key)
          if (!fallback) return
          this.popupVariant = fallback
        } else {
          this.popupVariant = v
        }
        this.popupOpen = true
        this.popupSectionsHtml = ''
        this.$nextTick(() => {
          this.fetchPopupSections(this.popupLinkedProductHandle())
          this.fetchMainProductOkendoRating()
        })
      },
      closePopup() {
        this.popupOpen = false
        this.popupVariant = null
        this.popupOption1 = null
      },
      popupAccordionItems() {
        const option1 = this.popupOption1
        const all = Object.values(this.variantsById)
        const match = all.find((v) => v.option1 === option1 && v.accordionItems?.length)
        return match?.accordionItems || this.popupVariant?.accordionItems || []
      },
      popupLinkedProductHandle() {
        const items = this.popupAccordionItems()
        const item = items.find((i) => i.linkedProductHandle)
        if (item?.linkedProductHandle) return item.linkedProductHandle
        if (this.popupVariant?.popupProductHandle) return this.popupVariant.popupProductHandle
        return null
      },
      _initPopupSectionAnimations() {
        const container = this.$refs.popupSections
        if (!container) return
        const store = Alpine.store('xScrollPromotion')
        if (store) {
          const bannerEl = container.querySelector('.el_animate')?.closest('[class*="section-"]')
          if (bannerEl) { store.load(bannerEl) }
        }
        container.querySelectorAll('.el_animate').forEach((el) => {
          el.classList.add('animate-scroll-banner')
        })
        requestAnimationFrame(() => {
          container.querySelectorAll('marquee-text').forEach((el) => {
            const w = el.getBoundingClientRect().width
            if (!w) return
            const speed = parseInt(el.getAttribute('scrolling-speed') || 5)
            const span = el.querySelector('span')
            if (!span) return
            const slowFactor = 1 + (Math.min(1600, w) - 375) / (1600 - 375)
            const duration = (speed * slowFactor * span.clientWidth / w).toFixed(3)
            el.style.setProperty('--marquee-animation-duration', `${duration}s`)
          })
        })
      },
      async fetchPopupSections(handle) {
        if (!handle) return
        if (this.popupSectionsCache[handle] !== undefined) {
          this.popupSectionsHtml = this.popupSectionsCache[handle]
          await this.$nextTick()
          this._initPopupSectionAnimations()
          return
        }
        const items = this.popupAccordionItems()
        const sourceItem = items.find((i) => i.linkedProductHandle === handle)
        let sectionIds = [sourceItem?.popupSection1, sourceItem?.popupSection2].filter(Boolean)
        if (sectionIds.length === 0) {
          const sectionMap = {
            'studio-scent-diffuser': ['scrolling_text_v2_r7QEbL', 'media_with_text_mjPcmV', 'multi_column_HTQGbC', 'media_with_text_GWpp88'],
            'chauffeur-car-diffuser': ['scrolling_text_v2_r7QEbL']
          }
          sectionIds = sectionMap[handle] || (this.popupVariant?.productType === 'Oil' ? ['scrolling_text_v2_r7QEbL'] : [])
        }
        const ratingId = 'pdp-popup-okendo-rating'
        try {
          const res = await fetch(`${window.location.origin}/products/${handle}`)
          const html = await res.text()
          const parser = new DOMParser()
          const doc = parser.parseFromString(html, 'text/html')
          const ratingSection = doc.querySelector(`#shopify-section-${ratingId}`)
          if (ratingSection && this.popupVariant) {
            const tmp = document.createElement('div')
            tmp.innerHTML = ratingSection.outerHTML
            const el = tmp.querySelector('[data-popup-okendo-rating]')
            if (el) {
              try {
                const rd = JSON.parse(el.textContent)
                this.popupVariant = { ...this.popupVariant, reviewCount: rd.reviewCount, reviewRating: rd.reviewRating }
              } catch(e) {}
            }
          }
          let sectionHtml = ''
          sectionIds.forEach((sectionSuffix) => {
            const section = doc.querySelector(`[id*="${sectionSuffix}"]`)
            if (section) sectionHtml += section.outerHTML
          })
          this.popupSectionsCache[handle] = sectionHtml
          this.popupSectionsHtml = sectionHtml
          await this.$nextTick()
          this._initPopupSectionAnimations()
        } catch (e) {
          console.error('Error fetching popup sections:', e)
          this.popupSectionsCache[handle] = ''
          this.popupSectionsHtml = ''
        }
      },
      async fetchMainProductOkendoRating() {
        let mainHandle = 'studio-scent-diffuser'
        const variantTitle = this.popupVariant?.title || ''
        if (variantTitle.includes('Chauffeur')) {
          mainHandle = 'chauffeur-car-diffuser'
        }
        try {
          const res = await fetch(`${window.location.origin}/products/${mainHandle}`)
          const html = await res.text()
          const parser = new DOMParser()
          const doc = parser.parseFromString(html, 'text/html')
          const okendoElement = doc.querySelector('[data-oke-reviews-product-listing-rating]')
          if (okendoElement && this.popupVariant) {
            this.popupVariant = { ...this.popupVariant, okendoSnippetHtml: okendoElement.outerHTML }
          }
        } catch (e) {
          console.error('Error fetching main product Okendo rating:', e)
        }
      },
      popupSelectSwatch(variantId) {
        const v = this.variantsById[String(variantId)]
        if (v) this.popupVariant = v
      },
      popupSwatches() {
        if (!this.popupOption1) return []
        const swatches = []
        const seen = {}
        Object.values(this.variantsById).forEach((v) => {
          if (v.option1 !== this.popupOption1) return
          if (!v.available) return
          if (!v.option2 || seen[v.option2]) return
          seen[v.option2] = true
          swatches.push({ id: v.id, label: v.option2, bg: v.swatchBg || '#e0e0e0' })
        })
        return swatches
      },
      isPopupSwatchActive(variantId) {
        return this.popupVariant && Number(this.popupVariant.id) === Number(variantId)
      },
      popupFeatures() {
        if (!this.popupVariant) return []
        return Array.isArray(this.popupVariant.allFeatures) ? this.popupVariant.allFeatures : []
      },
      popupTitle() {
        if (!this.popupVariant) return ''
        return this.popupVariant.option1 || this.popupVariant.title || ''
      },
      popupImage() {
        if (!this.popupVariant) return ''
        return this.popupVariant.image || ''
      },
      popupShowsRealPrice() {
        if (!this.popupVariant || !this.directAddOption1) return false
        const option1 = this.popupVariant.option1 || this.popupVariant.title || ''
        return option1 === this.directAddOption1
      },
      popupCurrentPrice() {
        if (!this.popupShowsRealPrice()) return '$0'
        return this.formatPdpMoney(Number(this.popupVariant.realPrice || 0))
      },
      popupCompareAtPrice() {
        if (!this.popupVariant) return ''
        const c = Number(this.popupVariant.compareAtPrice || 0)
        const p = Number(this.popupVariant.realPrice || 0)
        if (c > p) return this.formatPdpMoney(c)
        return ''
      },
      richTextToHtml(json) {
        if (!json) return ''
        let tree
        try { tree = typeof json === 'string' ? JSON.parse(json) : json }
        catch (e) { return json }
        function walk(node) {
          if (!node) return ''
          if (node.type === 'text') {
            let t = (node.value || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
            if (node.bold)   t = '<strong>' + t + '</strong>'
            if (node.italic) t = '<em>' + t + '</em>'
            if (node.code)   t = '<code>' + t + '</code>'
            return t
          }
          const inner = (node.children || []).map(walk).join('')
          switch (node.type) {
            case 'root':      return inner
            case 'paragraph': return '<p>' + inner + '</p>'
            case 'heading':   return '<h' + node.level + '>' + inner + '</h' + node.level + '>'
            case 'list':      return node.listType === 'ordered' ? '<ol>' + inner + '</ol>' : '<ul>' + inner + '</ul>'
            case 'list-item': return '<li>' + inner + '</li>'
            case 'link':      return '<a href="' + (node.url || '') + '"' + (node.target ? ' target="' + node.target + '"' : '') + '>' + inner + '</a>'
            default:          return inner
          }
        }
        return walk(tree)
      },

      decodeEscapedHtml(str) {
        if (!str) return ''
        return str
          .replace(/&amp;/g, '&')
          .replace(/&lt;/g, '<')
          .replace(/&gt;/g, '>')
          .replace(/&quot;/g, '"')
          .replace(/&#39;/g, "'")
      },

      formatNotes(val) {
        if (!val) return ''
        const html = this.richTextToHtml(val)
        if (html !== val) return html
        return val.split(/\n|\r\n/).filter(l => l.trim()).map(line => {
          const idx = line.indexOf(':')
          if (idx > -1) {
            const label = line.slice(0, idx).trim()
            const rest  = line.slice(idx + 1).trim()
            return '<p><strong>' + label + '</strong>: ' + rest + '</p>'
          }
          return '<p>' + line + '</p>'
        }).join('')
      },

      // ── Review image ────────────────────────────────────────────────
      reviewMappedImageUrl() {
        const bundles = this.bundles || []
        const option1 = bundles.length ? (bundles[0].option1 || '') : ''
        const rules = parseQtyAddonProductTypeRules(this.addonProductTypeMap)
        let productType = null
        for (let i = 0; i < rules.length; i++) {
          if (option1.indexOf(rules[i].match) !== -1) { productType = rules[i].productType; break }
        }
        const mappings = Array.isArray(this.reviewImageMappings) ? this.reviewImageMappings : []
        for (let i = 0; i < mappings.length; i++) {
          const row = mappings[i] || {}
          const rowRules = parseQtyAddonProductTypeRules(row.map || '')
          for (let j = 0; j < rowRules.length; j++) {
            const matches = productType
              ? rowRules[j].productType === productType
              : option1.indexOf(rowRules[j].match) !== -1
            if (matches && row.imageUrl) return row.imageUrl
          }
        }
        return this.productFeaturedImage || ''
      },

      // ── All-Scents modal ─────────────────────────────────────────────
      currentAddonProductType() {
        return this._allScentsProductType || null
      },
      openAllScentsModal(productType, collectionFilter) {
        this._allScentsProductType = productType || null
        this._allScentsCollectionFilter = collectionFilter || null
        this.allScentsModalOpen = true
        this.allScentsDrawerOpen = false
        document.body.style.overflow = 'hidden'
      },
      closeAllScentsModal() {
        this.allScentsModalOpen = false
        this.allScentsDrawerOpen = false
        document.body.style.overflow = ''
      },
      openAllScentsDrawer() {
        this.allScentsDrawerOpen = true
      },
      closeAllScentsDrawer() {
        this.allScentsDrawerOpen = false
      },
      addonRowById(variantId) {
        return this.addonVariantsById[String(variantId)] || null
      },
      allScentsCardImage(variantId) {
        const row = this.addonRowById(variantId)
        if (!row || !row.cardImage) return ''
        const desktop = typeof window !== 'undefined' && window.matchMedia
          ? window.matchMedia('(min-width: 990px)').matches
          : false
        return this.imageUrlWithWidth(row.cardImage, desktop ? 512 : 248)
      },
      normalizeFilterText(value) {
        if (value == null) return ''
        return String(value).trim().toLowerCase()
      },
      isAddonVariantVisible(addonVariantId) {
        const row = this.addonVariantsById[String(addonVariantId)]
        if (!row) return false
        if (row.available === false) return false
        const sp = row.sellingPlanId
        if (sp == null || sp === '' || Number(sp) <= 0) return false
        const compositeKey = this._allScentsProductType
        if (!compositeKey) return true
        const group = this.addonTypeGroups.find((g) => g.productType === compositeKey)
        const realPt = group ? (group.realProductType || group.productType) : compositeKey
        const rowPt = row.productType != null ? String(row.productType).trim() : ''
        if (rowPt !== realPt) return false
        const cf = this._allScentsCollectionFilter
        if (cf) {
          const rowCn = row.collectionName != null ? String(row.collectionName).trim() : ''
          if (rowCn !== cf) return false
        }
        return true
      },
      availableInspiredByOptions() {
        const out = []
        const seen = {}
        const ids = Object.keys(this.addonVariantsById)
        for (let i = 0; i < ids.length; i++) {
          const id = Number(ids[i])
          if (!this.isAddonVariantVisible(id)) continue
          const row = this.addonVariantsById[String(id)]
          const rawName = row && row.inspiredBy != null ? String(row.inspiredBy).trim() : ''
          if (!rawName) continue
          const key = this.normalizeFilterText(rawName)
          if (seen[key]) continue
          seen[key] = true
          out.push({ name: rawName })
        }
        return out
      },
      isInspiredByFilterSelected(name) {
        return this.selectedInspiredByFilters.includes(this.normalizeFilterText(name))
      },
      toggleInspiredByFilter(name) {
        const key = this.normalizeFilterText(name)
        if (!key) return
        if (this.selectedInspiredByFilters.includes(key)) {
          this.selectedInspiredByFilters = this.selectedInspiredByFilters.filter((x) => x !== key)
        } else {
          this.selectedInspiredByFilters = [...this.selectedInspiredByFilters, key]
        }
      },
      addonMatchesInspiredByFilter(variantId) {
        if (!this.selectedInspiredByFilters.length) return false
        const row = this.addonRowById(variantId)
        const name = this.normalizeFilterText(row && row.inspiredBy != null ? String(row.inspiredBy) : '')
        if (!name) return false
        return this.selectedInspiredByFilters.includes(name)
      },
      addonMatchesSelectedFilters(variantId) {
        if (!this.selectedInspiredByFilters.length) return true
        return this.addonMatchesInspiredByFilter(variantId)
      },
      addonMatchesSearch(row) {
        const q = this.normalizeFilterText(this.allScentsSearch)
        if (!q) return true
        const title = row && row.cardTitle ? this.normalizeFilterText(row.cardTitle) : ''
        const inspiredBy = row && row.inspiredBy ? this.normalizeFilterText(row.inspiredBy) : ''
        return title.includes(q) || inspiredBy.includes(q)
      },
      filteredAddonVariantIds() {
        const ids = Object.keys(this.addonVariantsById)
        const out = []
        for (let i = 0; i < ids.length; i++) {
          const id = Number(ids[i])
          if (!this.isAddonVariantVisible(id)) continue
          const row = this.addonRowById(id)
          if (!row) continue
          if (!this.addonMatchesSearch(row)) continue
          if (!this.addonMatchesSelectedFilters(id)) continue
          out.push(id)
        }
        return out
      },
      allScentsSubheadline() {
        const pt = this._allScentsProductType
        const group = pt ? this.addonTypeGroups.find((g) => g.productType === pt) : null
        return this.addonTypeSubheadline(group)
      },
      selectAddonFromAllScents() {
        this.closeAllScentsModal()
        this.$nextTick(() => {
          this.advanceAddonStep()
        })
      },

      // ── Addon popup ──────────────────────────────────────────────────
      openAddonPopup(addonVariantId) {
        const v = this.addonRowById(addonVariantId)
        if (v) {
          this.addonPopupVariant = v
          this.addonPopupOpen = true
          this.addonPopupSectionsHtml = ''
          this.$nextTick(() => {
            this.fetchAddonPopupSections(v.handle)
          })
        }
      },
      closeAddonPopup() {
        this.addonPopupOpen = false
        this.addonPopupVariant = null
      },
      addonPopupTitle() {
        if (!this.addonPopupVariant) return ''
        return this.addonPopupVariant.cardTitle || ''
      },
      addonPopupImage() {
        if (!this.addonPopupVariant) return ''
        return this.addonPopupVariant.cardImage || ''
      },
      addonPopupPrice() {
        if (!this.addonPopupVariant) return ''
        return this.formatPdpMoney(this.addonPopupVariant.price)
      },
      addonPopupCompareAtPrice() {
        if (!this.addonPopupVariant) return ''
        const c = Number(this.addonPopupVariant.compareAtPrice || 0)
        const p = Number(this.addonPopupVariant.price || 0)
        if (c > p) return this.formatPdpMoney(c)
        return ''
      },
      addonPopupHasCompare() {
        if (!this.addonPopupVariant) return false
        return Number(this.addonPopupVariant.compareAtPrice) > Number(this.addonPopupVariant.price)
      },
      addonPopupSavePercent() {
        if (!this.addonPopupVariant) return ''
        const c = Number(this.addonPopupVariant.compareAtPrice || 0)
        const p = Number(this.addonPopupVariant.price || 0)
        if (c > p && c > 0) return Math.round(((c - p) / c) * 100) + '%'
        return ''
      },
      addonPopupScentProfile() {
        if (!this.addonPopupVariant) return []
        return Array.isArray(this.addonPopupVariant.scentProfile) ? this.addonPopupVariant.scentProfile : []
      },
      addonPopupScentMoods() {
        if (!this.addonPopupVariant) return []
        return Array.isArray(this.addonPopupVariant.scentMoods) ? this.addonPopupVariant.scentMoods : []
      },
      addonPopupInspiredBy() {
        if (!this.addonPopupVariant) return ''
        return this.addonPopupVariant.inspiredBy || ''
      },
      addonPopupDescription() {
        if (!this.addonPopupVariant) return ''
        return this.addonPopupVariant.description || ''
      },
      _initAddonPopupSectionAnimations() {
        const container = this.$refs.addonPopupSections
        if (!container) return
        container.querySelectorAll('.el_animate').forEach(el => {
          el.classList.add('animate-scroll-banner')
        })
      },
      async fetchAddonPopupSections(handle) {
        if (!handle) return
        if (this.addonPopupSectionsCache[handle] !== undefined) {
          this.addonPopupSectionsHtml = this.addonPopupSectionsCache[handle]
          await this.$nextTick()
          this._initAddonPopupSectionAnimations()
          return
        }
        const sectionIds = ['scrolling_banner_3aBXMF', 'image_with_text_LtBR7i']
        try {
          const url = `${window.location.origin}/products/${handle}`
          const res = await fetch(url)
          const html = await res.text()
          const parser = new DOMParser()
          const doc = parser.parseFromString(html, 'text/html')
          let sectionHtml = ''
          sectionIds.forEach(sectionSuffix => {
            const section = doc.querySelector(`[id*="${sectionSuffix}"]`)
            if (section) sectionHtml += section.outerHTML
          })
          this.addonPopupSectionsCache[handle] = sectionHtml
          this.addonPopupSectionsHtml = sectionHtml
          await this.$nextTick()
          this._initAddonPopupSectionAnimations()
        } catch (e) {
          this.addonPopupSectionsCache[handle] = ''
          this.addonPopupSectionsHtml = ''
        }
      },

    }))
  })


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-swiper"] && !Shopify.designMode) return;
  try {
    
    const syncStepState = (swiper) => {
      const root = swiper.el.closest('.pdp-swiper')
      if (!root) return
      const active = swiper.activeIndex
      root.setAttribute('data-active-step', String(active))
      root.querySelectorAll('[data-pdp-step]').forEach((btn) => {
        const idx = Number(btn.getAttribute('data-pdp-step'))
        btn.classList.toggle('is-active', idx === active)
      })
  
      const stepNumber = String(active + 1)
      root.querySelectorAll('[data-step-text-template]').forEach((stepText) => {
        const rawTemplate = stepText.getAttribute('data-step-text-template') || ''
        if (active === 1) {
          stepText.textContent = `Step ${stepNumber}: Choose your scent subscription`
        } else {
          stepText.textContent = rawTemplate.replace(/\{step_number\}/g, stepNumber)
        }
      })
    }
  
    const bindStepClicks = (swiper) => {
      const root = swiper.el.closest('.pdp-swiper')
      if (!root) return
      root.querySelectorAll('[data-pdp-step]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const idx = Number(btn.getAttribute('data-pdp-step'))
          if (Number.isNaN(idx)) return
          swiper.slideTo(idx)
        })
      })
    }
  
    const syncMediaSwipersToVariant = (root, variantId) => {
      if (!root || !variantId) return
      const variantIdString = String(variantId)
      root.querySelectorAll('.pdp-swiper__media-swiper').forEach((mediaEl) => {
        const mediaSwiper = mediaEl.swiper
        if (!mediaSwiper) return
        const targetIndex = mediaSwiper.slides.findIndex(
          (slide) => {
            const csv = slide.getAttribute('data-variant-ids') || ''
            if (!csv) return false
            return csv.split(',').map((id) => id.trim()).includes(variantIdString)
          }
        )
        if (targetIndex >= 0 && targetIndex !== mediaSwiper.activeIndex) {
          mediaSwiper.slideTo(targetIndex)
        }
      })
    }
  
    const initPdpSwipers = () => {
      if (typeof window.Swiper === 'undefined') return
      document.querySelectorAll('.pdp-swiper').forEach((root) => {
        root.querySelectorAll('.pdp-swiper__media-swiper').forEach((mediaEl) => {
          if (mediaEl.swiper) return
          new Swiper(mediaEl, {
            nested: true,
            slidesPerView: 1,
            speed: 650,
            breakpoints: {
              990: {
                allowTouchMove: false,
                simulateTouch: false,
              },
            },
          })
        })
  
        const rootSwiperEl = root.querySelector('.pdp-swiper__root')
        if (!rootSwiperEl || rootSwiperEl.swiper) return
  
        const rootSwiper = new Swiper(rootSwiperEl, {
          slidesPerView: 1,
          speed: 700,
          allowTouchMove: false,
          simulateTouch: false,
          autoHeight: true,
          breakpoints: {
            990: {
              autoHeight: false,
            },
          },
          resistanceRatio: 0.5,
          longSwipesRatio: 0.2,
          on: {
            init(sw) {
              syncStepState(sw)
              bindStepClicks(sw)
            },
            slideChange(sw) {
              syncStepState(sw)
            },
          },
        })
  
        root.querySelectorAll('.pdp-swiper__next-slide:not(.pdp-swiper__next-slide--atc)').forEach((btn) => {
          btn.addEventListener('click', () => {
            rootSwiper.slideNext()
            if (typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(max-width: 989px)').matches) {
              window.scrollTo({ top: 0, behavior: 'smooth' })
            }
          })
        })
  
        const stateWrapper = root.closest('[x-data]') || root.querySelector('.swiper-wrapper')
        if (stateWrapper) {
          const jsonEl = stateWrapper.querySelector('[data-pdp-variant-state]')
          if (jsonEl) {
            try {
              const state = JSON.parse(jsonEl.textContent || '{}')
              syncMediaSwipersToVariant(root, state.initialSelectedVariantId)
            } catch (e) {
            }
          }
        }
      })
    }
  
    const initVariantsRowDrag = () => {
      let isDown = false
      let startY = 0
      let scrollTop = 0
      let activeElement = null
  
      document.addEventListener('mousedown', (e) => {
        const variantsRow = e.target.closest('.pdp-swiper__variants-row')
        if (!variantsRow) return
  
        isDown = true
        startY = e.clientY
        scrollTop = variantsRow.scrollTop
        activeElement = variantsRow
        variantsRow.classList.add('is-grabbing')
      })
  
      document.addEventListener('mousemove', (e) => {
        if (!isDown || !activeElement) return
        const y = e.clientY
        const walk = (y - startY) * 0.5
        activeElement.scrollTop = scrollTop - walk
      })
  
      document.addEventListener('mouseup', () => {
        if (activeElement) {
          activeElement.classList.remove('is-grabbing')
        }
        isDown = false
        activeElement = null
      })
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initPdpSwipers()
        initVariantsRowDrag()
      }, { once: true })
    } else {
      initPdpSwipers()
      initVariantsRowDrag()
    }
  
    document.addEventListener('pdp-swiper-variant-changed', (event) => {
      const root = event.target.closest('.pdp-swiper')
      if (!root) return
      const variantId = event.detail && event.detail.variantId
      syncMediaSwipersToVariant(root, variantId)
    })
  
    const parseAddonProductTypeRules = (raw) => {
      if (!raw || typeof raw !== 'string') return []
      return raw
        .replace(/\r\n/g, '\n')
        .split(/[,\n]+/)
        .map((s) => s.trim())
        .filter(Boolean)
        .map((segment) => {
          const parts = segment.split('/').map((p) => p.trim())
          const match = parts[0] || ''
          const productType = parts[1] || ''
          const addonGroupHandle = parts[2] || null
          if (!match || !productType) return null
          return { match, productType, addonGroupHandle }
        })
        .filter(Boolean)
    }
  
    const parseDiscountByProductTypeRules = (raw) => {
      if (!raw || typeof raw !== 'string') return []
      return raw
        .replace(/\r\n/g, '\n')
        .split(/[,\n]+/)
        .map((s) => s.trim())
        .filter(Boolean)
        .map((segment) => {
          const idx = segment.indexOf('/')
          if (idx === -1) return null
          const productType = segment.slice(0, idx).trim()
          const pctRaw = segment.slice(idx + 1).trim()
          const pct = Number(pctRaw)
          if (!productType || Number.isNaN(pct)) return null
          return { productType, percent: Math.max(0, Math.min(100, pct)) }
        })
        .filter(Boolean)
    }
  
    document.addEventListener('alpine:init', () => {
      Alpine.data('pdpSwiperState', () => ({
        variantsById: {},
        defaultByOption1: {},
        activeVariantId: null,
        selectedAddonVariantId: null,
        addonVariantsById: {},
        addonProductTypeMap: '',
        popupOpen: false,
        popupVariant: null,
        popupOption1: null,
        popupSectionsCache: {},
        popupSectionsHtml: '',
        addonPopupOpen: false,
        addonPopupVariant: null,
        addonPopupSectionsCache: {},
        addonPopupSectionsHtml: '',
        discountByProductTypeMap: '',
        termsAccepted: false,
        termsAcceptedAt: null,
        termsModalOpen: false,
        allScentsModalOpen: false,
        allScentsSearch: '',
        allScentsProfileOpen: true,
        allScentsMoodOpen: true,
        allScentsCollectionsOpen: false,
        allScentsDrawerOpen: false,
        selectedScentProfileFilters: [],
        selectedScentMoodFilters: [],
        selectedCollectionFilters: [],
        reviewImageMappings: [],
        hideReviewStep: false,
        pdpSwiperRootEl: null,
        addToCartLoading: false,
        init() {
          this.pdpSwiperRootEl = this.$el && this.$el.closest ? this.$el.closest('.pdp-swiper') : null
          const jsonEl = this.$el.querySelector('[data-pdp-variant-state]')
          if (!jsonEl) return
          let state = null
          try {
            state = JSON.parse(jsonEl.textContent || '{}')
          } catch (e) {
            state = null
          }
          if (!state) return
          ;(state.variants || []).forEach((v) => {
            this.variantsById[String(v.id)] = v
          })
          this.addonVariantsById = {}
          ;(state.addonVariants || []).forEach((row) => {
            if (row && row.id != null) {
              this.addonVariantsById[String(row.id)] = row
            }
          })
          this.addonProductTypeMap =
            typeof state.addonProductTypeMap === 'string' ? state.addonProductTypeMap : ''
          this.discountByProductTypeMap =
            typeof state.discountByProductTypeMap === 'string' ? state.discountByProductTypeMap : ''
          this.reviewImageMappings = Array.isArray(state.reviewImageMappings) ? state.reviewImageMappings : []
          this.hideReviewStep = Boolean(state.hideReviewStep)
          this.defaultByOption1 = { ...(state.defaults || {}) }
          let mainId = state.initialSelectedVariantId || null
          if (!this.variantIsAvailable(this.getVariantById(mainId))) {
            mainId = null
          }
          if (mainId == null) {
            const defIds = Object.values(this.defaultByOption1)
            for (let i = 0; i < defIds.length; i++) {
              const cand = defIds[i]
              if (this.variantIsAvailable(this.getVariantById(cand))) {
                mainId = cand
                break
              }
            }
          }
          if (mainId == null) {
            mainId = this.firstAvailableVariantIdGlobally()
          }
          this.activeVariantId = mainId
          this.selectedAddonVariantId = state.initialAddonVariantId || null
          this.pruneAddonSelection()
          this.$nextTick(() => {
            this.$dispatch('pdp-swiper-variant-changed', { variantId: this.activeVariantId })
          })
        },
        onTermsAcceptanceChange() {
          if (this.termsAccepted) {
            this.termsAcceptedAt = new Date().toISOString()
          } else {
            this.termsAcceptedAt = null
          }
        },
        openTermsModal() {
          this.termsModalOpen = true
          this.updateBodyScrollLock()
        },
        closeTermsModal() {
          this.termsModalOpen = false
          this.updateBodyScrollLock()
        },
        openAllScentsModal() {
          this.allScentsModalOpen = true
          this.allScentsDrawerOpen = false
          this.updateBodyScrollLock()
        },
        closeAllScentsModal() {
          this.allScentsModalOpen = false
          this.allScentsDrawerOpen = false
          this.updateBodyScrollLock()
        },
        openAllScentsDrawer() {
          this.allScentsDrawerOpen = true
        },
        closeAllScentsDrawer() {
          this.allScentsDrawerOpen = false
        },
        updateBodyScrollLock() {
          const lock = this.termsModalOpen || this.allScentsModalOpen
          document.body.style.overflow = lock ? 'hidden' : ''
        },
        buildBundleId(mainVariantId, addonVariantId) {
          return `_bundle_${mainVariantId}_${addonVariantId}_plan_30_ts_${Date.now()}`
        },
        compareAtCentsString(variantRow) {
          if (!variantRow) return '0'
          const c = Number(variantRow.compareAtPrice || 0)
          if (!c || c <= 0) return '0'
          return String(Math.round(c))
        },
        compareDiscountPercentString(variantRow) {
          if (!variantRow) return '0'
          const cap = Number(variantRow.compareAtPrice || 0)
          const price = Number(variantRow.price || 0)
          if (!cap || cap <= 0 || cap <= price) return '0'
          const pct = Math.round(((cap - price) / cap) * 100)
          return String(Math.max(0, pct))
        },
        buildBundleLineProperties(variantRow, bundleId, tosAcceptedAt) {
          const props = {
            _bundle_promo: 'free-diffuser-set',
            _bundle_id: bundleId,
            _bundle_identifier: 'true',
            _compare_at_price: this.compareAtCentsString(variantRow),
            _compare_at_price_discount: this.compareDiscountPercentString(variantRow),
            _free_diffuser_tos_aceptance:
              tosAcceptedAt != null && tosAcceptedAt !== '' ? String(tosAcceptedAt) : '',
          }
          return props
        },
        async addReviewSetToCart() {
          if (!this.termsAccepted || this.addToCartLoading) return
          const main = this.reviewMainVariant()
          if (!main || main.id == null) return
          if (!this.variantIsAvailable(main)) return
  
          this.addToCartLoading = true
          try {
            const addon = this.reviewAddonRow()
            const mainId = Number(main.id)
            const addonEligible =
              addon && this.selectedAddonVariantId != null && addon.available !== false
            const addonId = addonEligible ? Number(addon.id) : 0
            const bundleId = this.buildBundleId(mainId, addonId)
            const tosAt = this.termsAcceptedAt
  
            const items = [
              {
                id: mainId,
                properties: this.buildBundleLineProperties(main, bundleId, tosAt),
                quantity: 1,
              },
            ]
            if (addonEligible) {
              const addonLine = {
                id: Number(addon.id),
                properties: this.buildBundleLineProperties(addon, bundleId, tosAt),
                quantity: 1,
              }
              const sp = addon.sellingPlanId
              if (sp != null && sp !== '') {
                addonLine.selling_plan = Number(sp);
                addonLine.properties._notes = "Initial Subscription Order";
              }
              items.push(addonLine)
            }
  
            const rootPath =
              typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.root
                ? window.Shopify.routes.root
                : '/'
            const payload = { items: items }
  
            const res = await fetch(`${rootPath}cart/add.js`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
              },
              credentials: 'same-origin',
              body: JSON.stringify(payload),
            })
            const data = await res.json().catch(() => ({}))
            if (!res.ok || data.status === 422) {
              const msg =
                (data && (data.description || data.message)) || res.statusText || 'Could not add to cart'
              console.error('pdp-swiper cart/add', data)
              return
            }
          } catch (err) {
            console.error(err)
          } finally {
            this.addToCartLoading = false
          }
        },
        expectedAddonFilterRule() {
          const main = this.getVariantById(this.activeVariantId)
          if (!main || !main.title) return null
          const title = String(main.title)
          const rules = parseAddonProductTypeRules(this.addonProductTypeMap)
          for (let i = 0; i < rules.length; i++) {
            const m = rules[i]
            if (title.indexOf(m.match) !== -1) return m
          }
          return null
        },
        expectedAddonProductType() {
          const rule = this.expectedAddonFilterRule()
          return rule ? rule.productType : null
        },
        isAddonVariantVisible(addonVariantId) {
          const row = this.addonVariantsById[String(addonVariantId)]
          if (!row) return false
          if (row.available === false) return false
          const sp = row.sellingPlanId
          if (sp == null || sp === '' || Number(sp) <= 0) return false
          const rule = this.expectedAddonFilterRule()
          if (!rule) return true
          const pt = row.productType != null ? String(row.productType).trim() : ''
          if (pt !== String(rule.productType).trim()) return false
          if (rule.addonGroupHandle) {
            const groupHandle = row.addonGroupHandle != null ? String(row.addonGroupHandle).trim() : ''
            if (groupHandle !== String(rule.addonGroupHandle).trim()) return false
          }
          return true
        },
        isAddonVariantVisibleInStepList(addonVariantId) {
          const targetId = Number(addonVariantId)
          if (!targetId) return false
          return this.stepListAddonVariantIds().indexOf(targetId) !== -1
        },
        stepListAddonVariantIds() {
          const ids = Object.keys(this.addonVariantsById)
          const typeCount = {}
          const perTypeCap = 5
          const out = []
          for (let i = 0; i < ids.length; i++) {
            const id = Number(ids[i])
            if (!this.isAddonVariantVisible(id)) continue
            const row = this.addonVariantsById[String(id)]
            const pt =
              row && row.productType != null && String(row.productType).trim() !== ''
                ? String(row.productType).trim()
                : '__unknown__'
            const nextCount = (typeCount[pt] || 0) + 1
            typeCount[pt] = nextCount
            if (nextCount > perTypeCap) continue
            out.push(id)
          }
          return out
        },
        extraSelectedAddonVariantId() {
          const sel = this.selectedAddonVariantId
          if (sel == null) return null
          const id = Number(sel)
          if (!id || !this.isAddonVariantVisible(id)) return null
          if (this.isAddonVariantVisibleInStepList(id)) return null
          return id
        },
        showExtraSelectedAddonCard() {
          return this.extraSelectedAddonVariantId() != null
        },
        firstVisibleAddonVariantId() {
          const ids = Object.keys(this.addonVariantsById)
          for (let i = 0; i < ids.length; i++) {
            const id = ids[i]
            if (this.isAddonVariantVisible(Number(id))) return Number(id)
          }
          return null
        },
        pruneAddonSelection() {
          const sel = this.selectedAddonVariantId
          if (sel == null) return
          if (!this.isAddonVariantVisible(sel)) {
            this.selectedAddonVariantId = this.firstVisibleAddonVariantId()
          }
        },
        formatPdpMoney(cents) {
          const n = Number(cents)
          if (cents == null || cents === '' || Number.isNaN(n)) return ''
          if (typeof window.formatMoney === 'function') {
            return window.formatMoney(n)
          }
          return String(n)
        },
        formatPdpMoneyOrFree(cents) {
          const n = Number(cents)
          if (cents == null || cents === '' || Number.isNaN(n)) return ''
          if (n === 0) return 'FREE'
          return this.formatPdpMoney(n)
        },
        formatPdpMainVariantPrice(v) {
          if (!v) return ''
          if (Number(v.price || 0) === 0) return 'FREE'
          return this.formatPdpMoney(v.price)
        },
        mappedDiscountPercentForType(productType) {
          const pt = productType != null ? String(productType).trim() : ''
          if (!pt) return null
          const rules = parseDiscountByProductTypeRules(this.discountByProductTypeMap)
          for (let i = 0; i < rules.length; i++) {
            const r = rules[i]
            if (r.productType === pt) return Number(r.percent)
          }
          return null
        },
        normalizedPricing(v) {
          if (!v) return { price: 0, compareAtPrice: 0 }
          const originalPrice = Number(v.price || 0)
          const originalCompare = Number(v.compareAtPrice || 0)
          const mappedPct = this.mappedDiscountPercentForType(v.productType)
          if (mappedPct == null) {
            return { price: originalPrice, compareAtPrice: originalCompare }
          }
  
          const hasOriginalCompare = originalCompare > originalPrice && originalCompare > 0
          if (hasOriginalCompare) {
            const currentPct = ((originalCompare - originalPrice) / originalCompare) * 100
            if (currentPct > mappedPct) {
              return { price: originalPrice, compareAtPrice: originalCompare }
            }
          }
  
          const base = hasOriginalCompare ? originalCompare : originalPrice
          if (base <= 0) return { price: originalPrice, compareAtPrice: originalCompare }
  
          const discounted = Math.max(0, Math.round(base * (100 - mappedPct) / 100))
          if (discounted >= base) {
            return { price: originalPrice, compareAtPrice: originalCompare }
          }
          return { price: discounted, compareAtPrice: base }
        },
        normalizedAddonRowById(id) {
          const row = this.addonVariantsById[String(id)]
          if (!row) return null
          return this.normalizedPricing(row)
        },
        addonHasCompare(variantId) {
          const pricing = this.normalizedAddonRowById(variantId)
          if (!pricing) return false
          return Number(pricing.compareAtPrice) > Number(pricing.price)
        },
        addonDisplayCompare(variantId) {
          const pricing = this.normalizedAddonRowById(variantId)
          if (!pricing) return ''
          return this.formatPdpMoney(pricing.compareAtPrice)
        },
        addonDisplayPrice(variantId) {
          const pricing = this.normalizedAddonRowById(variantId)
          if (!pricing) return ''
          return this.formatPdpMoney(pricing.price)
        },
        addonSavePercent(variantId) {
          const pricing = this.normalizedAddonRowById(variantId)
          if (!pricing) return ''
          const compareAt = Number(pricing.compareAtPrice || 0)
          const price = Number(pricing.price || 0)
          if (!compareAt || compareAt <= 0 || compareAt <= price) return ''
          const pct = Math.round(((compareAt - price) / compareAt) * 100)
          if (!pct || pct <= 0) return ''
          return String(pct)
        },
        reviewMainVariant() {
          return this.getVariantById(this.activeVariantId)
        },
        reviewMainDisplayTitle() {
          const v = this.reviewMainVariant()
          if (!v) return ''
          return v.option1 || v.title || ''
        },
        reviewMainHasCompare() {
          const v = this.reviewMainVariant()
          if (!v) return false
          return Number(v.compareAtPrice) > Number(v.price)
        },
        reviewAddonRow() {
          const id = this.selectedAddonVariantId
          if (id == null) return null
          return this.addonVariantsById[String(id)] || null
        },
        reviewAddonHasCompare() {
          const v = this.reviewAddonRow()
          if (!v) return false
          const pricing = this.normalizedPricing(v)
          return Number(pricing.compareAtPrice) > Number(pricing.price)
        },
        reviewAddonSavePercent() {
          const id = this.selectedAddonVariantId
          if (id == null) return ''
          return this.addonSavePercent(id)
        },
        reviewMappedImageUrl() {
          const expectedType = this.expectedAddonProductType()
          if (!expectedType) return ''
          const mappings = Array.isArray(this.reviewImageMappings) ? this.reviewImageMappings : []
          for (let i = 0; i < mappings.length; i++) {
            const row = mappings[i] || {}
            const mapRaw = row.map != null ? String(row.map) : ''
            const parsed = parseAddonProductTypeRules(mapRaw)
            if (!parsed.length) continue
            for (let j = 0; j < parsed.length; j++) {
              const rule = parsed[j]
              if (String(rule.productType).trim() === String(expectedType).trim()) {
                return row.imageUrl != null ? String(row.imageUrl) : ''
              }
            }
          }
          return ''
        },
        reviewLineCompareCents(v) {
          if (!v) return 0
          const pricing = this.normalizedPricing(v)
          const c = Number(pricing.compareAtPrice || 0)
          const p = Number(pricing.price || 0)
          return c > p ? c : p
        },
        reviewSumCompareAtCents() {
          return (
            this.reviewLineCompareCents(this.reviewMainVariant()) +
            this.reviewLineCompareCents(this.reviewAddonRow())
          )
        },
        reviewSumPriceCents() {
          let s = 0
          const m = this.reviewMainVariant()
          const a = this.reviewAddonRow()
          if (m) s += Number(m.price || 0)
          if (a) {
            const addonPricing = this.normalizedPricing(a)
            s += Number(addonPricing.price || 0)
          }
          return s
        },
        getVariantById(id) {
          if (!id) return null
          return this.variantsById[String(id)] || null
        },
        imageUrlWithWidth(url, width) {
          const src = url != null ? String(url).trim() : ''
          const w = Number(width)
          if (!src) return ''
          if (!w || Number.isNaN(w) || w <= 0) return src
          if (src.includes(' width=')) return src
          if (/[?&]width=\d+/.test(src)) {
            return src.replace(/([?&]width=)\d+/, `$1${w}`)
          }
          const sep = src.includes('?') ? '&' : '?'
          return `${src}${sep}width=${w}`
        },
        popupAccordionItems() {
          const option1 = this.popupOption1
          const all = Object.values(this.variantsById)
          const match = all.find(v => v.option1 === option1 && v.accordionItems?.length)
          return match?.accordionItems || this.popupVariant?.accordionItems || []
        },
        popupLinkedProductHandle() {
          const items = this.popupAccordionItems()
          const item = items.find(i => i.linkedProductHandle)
          if (item?.linkedProductHandle) return item.linkedProductHandle
          if (this.popupVariant?.popupProductHandle) return this.popupVariant.popupProductHandle
          return null
        },
        _initPopupSectionAnimations() {
          const container = this.$refs.popupSections
          if (!container) return
          const store = Alpine.store('xScrollPromotion')
          if (store) {
            const bannerEl = container.querySelector('.el_animate')?.closest('[class*="section-"]')
            if (bannerEl) { store.load(bannerEl) }
          }
          container.querySelectorAll('.el_animate').forEach(el => {
            el.classList.add('animate-scroll-banner')
          })
          requestAnimationFrame(() => {
            container.querySelectorAll('marquee-text').forEach(el => {
              const w = el.getBoundingClientRect().width
              if (!w) return
              const speed = parseInt(el.getAttribute('scrolling-speed') || 5)
              const span = el.querySelector('span')
              if (!span) return
              const slowFactor = 1 + (Math.min(1600, w) - 375) / (1600 - 375)
              const duration = (speed * slowFactor * span.clientWidth / w).toFixed(3)
              el.style.setProperty('--marquee-animation-duration', `${duration}s`)
            })
          })
        },
        async fetchPopupSections(handle) {
          if (!handle) return
          if (this.popupSectionsCache[handle] !== undefined) {
            this.popupSectionsHtml = this.popupSectionsCache[handle]
            await this.$nextTick()
            this._initPopupSectionAnimations()
            return
          }
          const items = this.popupAccordionItems()
          const sourceItem = items.find(i => i.linkedProductHandle === handle)
          let sectionIds = [sourceItem?.popupSection1, sourceItem?.popupSection2].filter(Boolean)
          if (sectionIds.length === 0) {
            const sectionMap = {
              'studio-scent-diffuser': ['scrolling_text_v2_r7QEbL', 'media_with_text_mjPcmV', 'multi_column_HTQGbC', 'media_with_text_GWpp88']
            }
            sectionIds = sectionMap[handle] || (this.popupVariant?.productType === 'Oil' ? ['scrolling_text_v2_r7QEbL'] : [])
          }
          const ratingId = 'pdp-popup-okendo-rating'
          try {
            const url = `${window.location.origin}/products/${handle}`
            const res = await fetch(url)
            const html = await res.text()

            const parser = new DOMParser()
            const doc = parser.parseFromString(html, 'text/html')

            const ratingSection = doc.querySelector(`#shopify-section-${ratingId}`)
            const ratingHtml = ratingSection ? ratingSection.outerHTML : ''

            if (ratingHtml && this.popupVariant) {
              const tmp = document.createElement('div')
              tmp.innerHTML = ratingHtml
              const el = tmp.querySelector('[data-popup-okendo-rating]')
              if (el) {
                try {
                  const rd = JSON.parse(el.textContent)
                  this.popupVariant = { ...this.popupVariant, reviewCount: rd.reviewCount, reviewRating: rd.reviewRating }
                } catch(e) {}
              }
            }

            let sectionHtml = ''
            sectionIds.forEach(sectionSuffix => {
              const section = doc.querySelector(`[id*="${sectionSuffix}"]`)
              if (section) {
                sectionHtml += section.outerHTML
              }
            })
            this.popupSectionsCache[handle] = sectionHtml
            this.popupSectionsHtml = sectionHtml
            await this.$nextTick()
            this._initPopupSectionAnimations()
          } catch (e) {
            console.error('Error fetching popup sections:', e)
            this.popupSectionsCache[handle] = ''
            this.popupSectionsHtml = ''
          }
        },
        async fetchMainProductOkendoRating() {
          let mainHandle = 'studio-scent-diffuser'
          const variantTitle = this.popupVariant?.title || ''

          if (variantTitle.includes('Chauffeur')) {
            mainHandle = 'chauffeur-car-diffuser'
          }

          try {
            const url = `${window.location.origin}/products/${mainHandle}`
            const res = await fetch(url)
            const html = await res.text()

            const parser = new DOMParser()
            const doc = parser.parseFromString(html, 'text/html')

            const okendoElement = doc.querySelector('[data-oke-reviews-product-listing-rating]')
            if (okendoElement && this.popupVariant) {
              this.popupVariant = { ...this.popupVariant, okendoSnippetHtml: okendoElement.outerHTML }
            }
          } catch (e) {
            console.error('Error fetching main product Okendo rating:', e)
          }
        },
        _initAddonPopupSectionAnimations() {
          const container = this.$refs.addonPopupSections
          if (!container) return
          const store = Alpine.store('xScrollPromotion')
          if (store) {
            const bannerEl = container.querySelector('.el_animate')?.closest('[class*="section-"]')
            if (bannerEl) { store.load(bannerEl) }
          }
          container.querySelectorAll('.el_animate').forEach(el => {
            el.classList.add('animate-scroll-banner')
          })
          requestAnimationFrame(() => {
            container.querySelectorAll('marquee-text').forEach(el => {
              const w = el.getBoundingClientRect().width
              if (!w) return
              const speed = parseInt(el.getAttribute('scrolling-speed') || 5)
              const span = el.querySelector('span')
              if (!span) return
              const slowFactor = 1 + (Math.min(1600, w) - 375) / (1600 - 375)
              const duration = (speed * slowFactor * span.clientWidth / w).toFixed(3)
              el.style.setProperty('--marquee-animation-duration', `${duration}s`)
            })
          })
        },
        async fetchAddonPopupSections(handle) {
          if (!handle) return
          if (this.addonPopupSectionsCache[handle] !== undefined) {
            this.addonPopupSectionsHtml = this.addonPopupSectionsCache[handle]
            await this.$nextTick()
            this._initAddonPopupSectionAnimations()
          }

          const sectionMap = {
            'studio-scent-diffuser': ['scrolling_text_v2_r7QEbL', 'media_with_text_mjPcmV', 'multi_column_HTQGbC', 'media_with_text_GWpp88'],
            'chauffeur-car-diffuser': ['scrolling_text_v2_r7QEbL']
          }

          let fetchHandle = handle
          const productType = this.addonPopupVariant?.productType || ''

          let sectionIds = sectionMap[fetchHandle] || ['scrolling_text_v2_r7QEbL']

          if (productType.includes('Oil') || productType.includes('Refill')) {
            fetchHandle = 'studio-scent-diffuser'
            sectionIds = ['scrolling_text_v2_r7QEbL']
          }

          try {
            const url = `${window.location.origin}/products/${fetchHandle}`
            const res = await fetch(url)
            const html = await res.text()

            const parser = new DOMParser()
            const doc = parser.parseFromString(html, 'text/html')

            let sectionHtml = ''
            sectionIds.forEach(sectionSuffix => {
              const section = doc.querySelector(`[id*="${sectionSuffix}"]`)
              if (section) {
                sectionHtml += section.outerHTML
              }
            })
            this.addonPopupSectionsCache[handle] = sectionHtml
            this.addonPopupSectionsHtml = sectionHtml
            await this.$nextTick()
            this._initAddonPopupSectionAnimations()
          } catch (e) {
            this.addonPopupSectionsCache[handle] = ''
            this.addonPopupSectionsHtml = ''
          }
        },
        richTextToHtml(json) {
          if (!json) return ''
          let tree
          try { tree = typeof json === 'string' ? JSON.parse(json) : json }
          catch (e) { return json }
          function walk(node) {
            if (!node) return ''
            if (node.type === 'text') {
              let t = (node.value || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\n/g, '<br>')
              if (node.bold)   t = '<strong>' + t + '</strong>'
              if (node.italic) t = '<em>' + t + '</em>'
              if (node.code)   t = '<code>' + t + '</code>'
              return t
            }
            const inner = (node.children || []).map(walk).join('')
            switch (node.type) {
              case 'root':      return inner
              case 'paragraph': return '<p>' + inner + '</p>'
              case 'heading':   return '<h' + node.level + '>' + inner + '</h' + node.level + '>'
              case 'list':      return node.listType === 'ordered' ? '<ol>' + inner + '</ol>' : '<ul>' + inner + '</ul>'
              case 'list-item': return '<li>' + inner + '</li>'
              case 'link':      return '<a href="' + (node.url || '') + '"' + (node.target ? ' target="' + node.target + '"' : '') + '>' + inner + '</a>'
              default:          return inner
            }
          }
          return walk(tree)
        },
        decodeEscapedHtml(str) {
          if (!str) return ''
          return str
            .replace(/&amp;/g, '&')
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>')
            .replace(/&quot;/g, '"')
            .replace(/&#39;/g, "'")
        },
        formatNotes(val) {
          if (!val) return ''
          const html = this.richTextToHtml(val)
          if (html !== val) return html
          return val.split(/\n|\r\n/).filter(l => l.trim()).map(line => {
            const idx = line.indexOf(':')
            if (idx > -1) {
              const label = line.slice(0, idx).trim()
              const rest  = line.slice(idx + 1).trim()
              return '<p><strong>' + label + '</strong>: ' + rest + '</p>'
            }
            return '<p>' + line + '</p>'
          }).join('')
        },
        variantIsAvailable(v) {
          if (!v) return false
          return v.available !== false
        },
        firstAvailableVariantIdGlobally() {
          const list = Object.values(this.variantsById)
          for (let i = 0; i < list.length; i++) {
            const v = list[i]
            if (this.variantIsAvailable(v)) return v.id
          }
          return null
        },
        firstAvailableVariantIdForOptionKey(optionKey) {
          const key = optionKey != null ? String(optionKey) : ''
          const list = Object.values(this.variantsById)
          for (let i = 0; i < list.length; i++) {
            const v = list[i]
            if (!this.variantIsAvailable(v)) continue
            const o1 = v.option1 != null ? String(v.option1) : ''
            const t = v.title != null ? String(v.title) : ''
            if (o1 === key || t === key) return v.id
          }
          return null
        },
        getCardImage(option1Key) {
          const variant = this.getVariantById(this.activeVariantId)
          if (!variant || variant.option1 !== option1Key) return ''
          return variant && variant.image ? this.imageUrlWithWidth(variant.image, 248) : ''
        },
        getCardAlt(option1Key) {
          const variant = this.getVariantById(this.activeVariantId)
          if (!variant || variant.option1 !== option1Key) return ''
          return variant && variant.title ? variant.title : ''
        },
        getFeatureMetadata() {
          const active = this.getVariantById(this.activeVariantId)
          if (!active) return []
          if (active.featureMetadata && active.featureMetadata.length) return active.featureMetadata
          const match = Object.values(this.variantsById).find(
            v => v.option1 === active.option1 && v.featureMetadata && v.featureMetadata.length
          )
          return match ? match.featureMetadata : []
        },
        getCardFeatureIcon(option1Key) {
          const variant = this.getVariantById(this.activeVariantId)
          if (!variant || variant.option1 !== option1Key) return ''
          return variant && variant.featureIcon ? variant.featureIcon : ''
        },
        getCardFeatureText(option1Key) {
          const variant = this.getVariantById(this.activeVariantId)
          if (!variant || variant.option1 !== option1Key) return ''
          return variant && variant.featureText ? variant.featureText : ''
        },
        getAddonScentProfile(variantId) {
          const row = this.addonVariantsById[String(variantId)]
          if (!row) return []
          const list = row.scentProfile
          return Array.isArray(list) ? list : []
        },
        getAddonScentMoods(variantId) {
          const row = this.addonVariantsById[String(variantId)]
          if (!row) return []
          const list = row.scentMoods
          return Array.isArray(list) ? list : []
        },
        addonRowById(variantId) {
          return this.addonVariantsById[String(variantId)] || null
        },
        allScentsCardImage(variantId) {
          const row = this.addonRowById(variantId)
          if (!row || !row.cardImage) return ''
          const desktop = typeof window !== 'undefined' && window.matchMedia
            ? window.matchMedia('(min-width: 990px)').matches
            : false
          return this.imageUrlWithWidth(row.cardImage, desktop ? 512 : 248)
        },
        normalizeFilterText(value) {
          if (value == null) return ''
          return String(value).trim().toLowerCase()
        },
        availableScentProfiles() {
          const out = []
          const seen = {}
          const ids = Object.keys(this.addonVariantsById)
          for (let i = 0; i < ids.length; i++) {
            const id = Number(ids[i])
            if (!this.isAddonVariantVisible(id)) continue
            const list = this.getAddonScentProfile(id)
            for (let j = 0; j < list.length; j++) {
              const sp = list[j] || {}
              const rawName = sp.name != null ? String(sp.name).trim() : ''
              if (!rawName) continue
              const key = this.normalizeFilterText(rawName)
              if (seen[key]) continue
              seen[key] = true
              out.push({ name: rawName, color: sp.color || '' })
            }
          }
          return out
        },
        availableScentMoods() {
          const out = []
          const seen = {}
          const ids = Object.keys(this.addonVariantsById)
          for (let i = 0; i < ids.length; i++) {
            const id = Number(ids[i])
            if (!this.isAddonVariantVisible(id)) continue
            const list = this.getAddonScentMoods(id)
            for (let j = 0; j < list.length; j++) {
              const sm = list[j] || {}
              const rawName = sm.name != null ? String(sm.name).trim() : ''
              if (!rawName) continue
              const key = this.normalizeFilterText(rawName)
              if (seen[key]) continue
              seen[key] = true
              out.push({ name: rawName, image: sm.image || '' })
            }
          }
          return out
        },
        availableCollections() {
          const out = []
          const seen = {}
          const ids = Object.keys(this.addonVariantsById)
          for (let i = 0; i < ids.length; i++) {
            const id = Number(ids[i])
            if (!this.isAddonVariantVisible(id)) continue
            const row = this.addonVariantsById[String(id)]
            const rawName = row && row.collectionName != null ? String(row.collectionName).trim() : ''
            if (!rawName) continue
            const key = this.normalizeFilterText(rawName)
            if (seen[key]) continue
            seen[key] = true
            out.push({ name: rawName })
          }
          return out
        },
        isProfileFilterSelected(name) {
          const key = this.normalizeFilterText(name)
          return this.selectedScentProfileFilters.includes(key)
        },
        isMoodFilterSelected(name) {
          const key = this.normalizeFilterText(name)
          return this.selectedScentMoodFilters.includes(key)
        },
        isCollectionFilterSelected(name) {
          const key = this.normalizeFilterText(name)
          return this.selectedCollectionFilters.includes(key)
        },
        toggleProfileFilter(name) {
          const key = this.normalizeFilterText(name)
          if (!key) return
          if (this.selectedScentProfileFilters.includes(key)) {
            this.selectedScentProfileFilters = this.selectedScentProfileFilters.filter((x) => x !== key)
          } else {
            this.selectedScentProfileFilters = [...this.selectedScentProfileFilters, key]
          }
        },
        toggleMoodFilter(name) {
          const key = this.normalizeFilterText(name)
          if (!key) return
          if (this.selectedScentMoodFilters.includes(key)) {
            this.selectedScentMoodFilters = this.selectedScentMoodFilters.filter((x) => x !== key)
          } else {
            this.selectedScentMoodFilters = [...this.selectedScentMoodFilters, key]
          }
        },
        toggleCollectionFilter(name) {
          const key = this.normalizeFilterText(name)
          if (!key) return
          if (this.selectedCollectionFilters.includes(key)) {
            this.selectedCollectionFilters = this.selectedCollectionFilters.filter((x) => x !== key)
          } else {
            this.selectedCollectionFilters = [...this.selectedCollectionFilters, key]
          }
        },
        goToReviewStep() {
          const root = this.pdpSwiperRootEl || (this.$el && this.$el.closest ? this.$el.closest('.pdp-swiper') : null)
          if (!root) return
          const rootSwiperEl = root.querySelector('.pdp-swiper__root')
          if (!rootSwiperEl || !rootSwiperEl.swiper) return
          if (this.hideReviewStep) {
            rootSwiperEl.swiper.slideTo(1)
            return
          }
          rootSwiperEl.swiper.slideTo(2)
        },
        selectAddonFromAllScents(variantId) {
          this.selectAddonVariant(variantId)
          this.closeAllScentsModal()
          this.$nextTick(() => {
            if (this.hideReviewStep) {
              if (typeof window !== 'undefined') {
                window.scrollTo({ top: 0, behavior: 'smooth' })
              }
              return
            }
            this.goToReviewStep()
            if (typeof window !== 'undefined') {
              window.scrollTo({ top: 0, behavior: 'smooth' })
            }
          })
        },
        shouldShowAddonStepAtc() {
          return Boolean(this.hideReviewStep && this.selectedAddonVariantId != null)
        },
        addonMatchesSearch(row) {
          const q = this.normalizeFilterText(this.allScentsSearch)
          if (!q) return true
          const title = row && row.cardTitle ? this.normalizeFilterText(row.cardTitle) : ''
          const inspiredBy = row && row.inspiredBy ? this.normalizeFilterText(row.inspiredBy) : ''
          return title.includes(q) || inspiredBy.includes(q)
        },
        addonMatchesProfileFilters(variantId) {
          if (!this.selectedScentProfileFilters.length) return false
          const names = this.getAddonScentProfile(variantId).map((sp) => this.normalizeFilterText(sp && sp.name))
          return this.selectedScentProfileFilters.some((selected) => names.includes(selected))
        },
        addonMatchesMoodFilters(variantId) {
          if (!this.selectedScentMoodFilters.length) return false
          const names = this.getAddonScentMoods(variantId).map((sm) => this.normalizeFilterText(sm && sm.name))
          return this.selectedScentMoodFilters.some((selected) => names.includes(selected))
        },
        addonMatchesCollectionFilters(variantId) {
          if (!this.selectedCollectionFilters.length) return false
          const row = this.addonRowById(variantId)
          const name = this.normalizeFilterText(row && row.collectionName)
          if (!name) return false
          return this.selectedCollectionFilters.includes(name)
        },
        addonMatchesSelectedFilters(variantId) {
          const hasProfileFilters = this.selectedScentProfileFilters.length > 0
          const hasMoodFilters = this.selectedScentMoodFilters.length > 0
          const hasCollectionFilters = this.selectedCollectionFilters.length > 0
          if (!hasProfileFilters && !hasMoodFilters && !hasCollectionFilters) return true
          return (
            this.addonMatchesProfileFilters(variantId) ||
            this.addonMatchesMoodFilters(variantId) ||
            this.addonMatchesCollectionFilters(variantId)
          )
        },
        filteredAddonVariantIds() {
          const ids = Object.keys(this.addonVariantsById)
          const out = []
          for (let i = 0; i < ids.length; i++) {
            const id = Number(ids[i])
            if (!this.isAddonVariantVisible(id)) continue
            const row = this.addonRowById(id)
            if (!row) continue
            if (!this.addonMatchesSearch(row)) continue
            if (!this.addonMatchesSelectedFilters(id)) continue
            out.push(id)
          }
          return out
        },
        selectVariant(option1Key, variantId) {
          const next = this.getVariantById(variantId)
          if (!this.variantIsAvailable(next)) return
          this.activeVariantId = variantId
          this.pruneAddonSelection()
          this.$nextTick(() => {
            this.$dispatch('pdp-swiper-variant-changed', { variantId })
          })
        },
        setActiveCard(option1Key) {
          let id = this.defaultByOption1[option1Key]
          if (id != null && !this.variantIsAvailable(this.getVariantById(id))) {
            id = this.firstAvailableVariantIdForOptionKey(option1Key)
          }
          if (id != null) {
            this.activeVariantId = id
            this.pruneAddonSelection()
            this.$nextTick(() => {
              this.$dispatch('pdp-swiper-variant-changed', { variantId: id })
            })
          }
        },
        isCardActive(option1Key) {
          const active = this.getVariantById(this.activeVariantId)
          if (!active) return false
          return active.option1 === option1Key
        },
        isSwatchSelected(option1Key, variantId) {
          return Number(this.activeVariantId) === Number(variantId)
        },
        selectAddonVariant(variantId) {
          if (!this.isAddonVariantVisible(variantId)) return
          this.selectedAddonVariantId = variantId
          this.$nextTick(() => {
            this.$dispatch('pdp-swiper-variant-changed', { variantId })
          })
        },
        isAddonSelected(variantId) {
          return Number(this.selectedAddonVariantId) === Number(variantId)
        },
        openVariantPopup(option1Key) {
          this.popupOption1 = option1Key
          const id = this.defaultByOption1[option1Key] || this.activeVariantId
          const v = this.getVariantById(id)
          if (v) {
            this.popupVariant = v
            this.popupOpen = true
            this.popupSectionsHtml = ''
            this.$nextTick(async () => {
              await this.fetchMainProductOkendoRating()
              let handle = this.popupLinkedProductHandle()
              if (!handle && option1Key) {
                handle = option1Key.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')
              }
              this.fetchPopupSections(handle)
            })
          }
        },
        closePopup() {
          this.popupOpen = false
          this.popupVariant = null
          this.popupOption1 = null
        },
        selectDeviceAndClose() {
          if (this.popupVariant) {
            this.activeVariantId = this.popupVariant.id
            this.pruneAddonSelection()
            this.$nextTick(() => {
              this.$dispatch('pdp-swiper-variant-changed', { variantId: this.activeVariantId })
            })
          }
          this.closePopup()
        },
        openAddonPopup(addonVariantId) {
          const v = this.getAddonVariantById(addonVariantId)
          if (v) {
            this.addonPopupVariant = v
            this.addonPopupOpen = true
            this.addonPopupSectionsHtml = ''
            this.$nextTick(() => {
              this.fetchAddonPopupSections(v.handle)
            })
          }
        },
        closeAddonPopup() {
          this.addonPopupOpen = false
          this.addonPopupVariant = null
        },
        selectAddonAndClose() {
          if (this.addonPopupVariant) {
            this.selectedAddonVariantId = this.addonPopupVariant.id
            this.pruneAddonSelection()
            this.$nextTick(() => {
              this.$dispatch('pdp-swiper-addon-changed', { variantId: this.selectedAddonVariantId })
            })
          }
          this.closeAddonPopup()
        },
        getAddonVariantById(id) {
          return this.addonVariantsById[String(id)] || null
        },
        popupSelectSwatch(variantId) {
          const v = this.getVariantById(variantId)
          if (v) {
            this.popupVariant = v
          }
        },
        popupSwatches() {
          if (!this.popupOption1) return []
          const swatches = []
          const seen = {}
          const allIds = Object.keys(this.variantsById)
          for (let i = 0; i < allIds.length; i++) {
            const v = this.variantsById[allIds[i]]
            if (v.option1 !== this.popupOption1) continue
            if (!v.available) continue
            if (!v.option2 || seen[v.option2]) continue
            seen[v.option2] = true
            swatches.push({ id: v.id, label: v.option2, bg: v.swatchBg || '#e0e0e0' })
          }
          return swatches
        },
        isPopupSwatchActive(variantId) {
          return this.popupVariant && Number(this.popupVariant.id) === Number(variantId)
        },
        popupFeatures() {
          if (!this.popupVariant) return []
          return Array.isArray(this.popupVariant.allFeatures) ? this.popupVariant.allFeatures : []
        },
        popupTitle() {
          if (!this.popupVariant) return ''
          return this.popupVariant.option1 || this.popupVariant.title || ''
        },
        popupSubtitle() {
          if (!this.popupVariant) return ''
          return this.popupVariant.option2 || ''
        },
        popupReviewCount() {
          if (!this.popupVariant) return 0
          return Number(this.popupVariant.reviewCount || 0)
        },
        popupReviewRating() {
          if (!this.popupVariant) return 0
          return Number(this.popupVariant.reviewRating || 0)
        },
        popupImage() {
          if (!this.popupVariant) return ''
          return this.popupVariant.image || ''
        },
        popupRealPrice() {
          if (!this.popupVariant) return ''
          return this.formatPdpMoney(this.popupVariant.realPrice)
        },
        popupCompareAtPrice() {
          if (!this.popupVariant) return ''
          const c = Number(this.popupVariant.compareAtPrice || 0)
          const p = Number(this.popupVariant.realPrice || 0)
          if (c > p) return this.formatPdpMoney(c)
          return ''
        },
        popupSavePercent() {
          if (!this.popupVariant) return ''
          const c = Number(this.popupVariant.compareAtPrice || 0)
          const p = Number(this.popupVariant.realPrice || 0)
          if (c > p && c > 0) return Math.round(((c - p) / c) * 100) + '%'
          return ''
        },
        addonPopupTitle() {
          if (!this.addonPopupVariant) return ''
          return this.addonPopupVariant.cardTitle || ''
        },
        addonPopupReviewCount() {
          if (!this.addonPopupVariant) return 0
          return Number(this.addonPopupVariant.reviewCount || 0)
        },
        addonPopupReviewRating() {
          if (!this.addonPopupVariant) return 0
          return Number(this.addonPopupVariant.reviewRating || 0)
        },
        addonPopupImage() {
          if (!this.addonPopupVariant) return ''
          return this.addonPopupVariant.cardImage || ''
        },
        addonPopupPrice() {
          if (!this.addonPopupVariant) return ''
          const pricing = this.normalizedPricing(this.addonPopupVariant)
          return this.formatPdpMoney(pricing.price)
        },
        addonPopupCompareAtPrice() {
          if (!this.addonPopupVariant) return ''
          const pricing = this.normalizedPricing(this.addonPopupVariant)
          const c = Number(pricing.compareAtPrice || 0)
          const p = Number(pricing.price || 0)
          if (c > p) return this.formatPdpMoney(c)
          return ''
        },
        addonPopupHasCompare() {
          if (!this.addonPopupVariant) return false
          const pricing = this.normalizedPricing(this.addonPopupVariant)
          return Number(pricing.compareAtPrice) > Number(pricing.price)
        },
        addonPopupScentProfile() {
          if (!this.addonPopupVariant) return []
          return Array.isArray(this.addonPopupVariant.scentProfile) ? this.addonPopupVariant.scentProfile : []
        },
        addonPopupScentMoods() {
          if (!this.addonPopupVariant) return [] 
          return Array.isArray(this.addonPopupVariant.scentMoods) ? this.addonPopupVariant.scentMoods : []
        },
        addonPopupInspiredBy() {
          if (!this.addonPopupVariant) return ''
          return this.addonPopupVariant.inspiredBy || ''
        },
        addonPopupNotes() {
          if (!this.addonPopupVariant) return ''
          return this.addonPopupVariant.accordionNotes || ''
        },
        addonPopupSavePercent() {
          if (!this.addonPopupVariant) return ''
          const pricing = this.normalizedPricing(this.addonPopupVariant)
          const c = Number(pricing.compareAtPrice || 0)
          const p = Number(pricing.price || 0)
          if (c > p && c > 0) return Math.round(((c - p) / c) * 100) + '%'
          return ''
        },
        addonPopupDescription() {
          if (!this.addonPopupVariant) return ''
          return this.addonPopupVariant.description || ''
        },
      }))
    })
  
  } catch(e) { console.error(e); }
})();
})();
